// source: data_view.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

import jspb from 'google-protobuf';
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.zelos.zoe.data_view.proto.AlarmLevelCode', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.AlarmLevelCode.FreeMoveStatus', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.AuthorizeInfo', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Boundary', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Boundary.Color', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Boundary.Type', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.BumperEntity', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.BumperEntity.BumperPosition', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.BusinessInfo', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.CameraCalibration', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ClearZone', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.CloudAssistanceStatus', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.ExecutionState', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveFunctionVersion', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.LaneChangeFailReason', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ConnectionData', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ConstructionAreaList', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ControlDebugData', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.CoordinateType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.CoordinateType.Type', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.CrossWalk', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.DataPackage', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.DataSessionProtocal', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.DataSessionProtocal.SessionDataCase', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.EmergencySteering', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.EntryLine', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.EnvironmentEdit', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.EraseObstacle', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.FrameData', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.FreeArea', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.FreeMoveCommand', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.FreeMoveCommand.CommandCase', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.FreeMoveEraseArea', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.EraseAreaType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.FreeMoveFailReason', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Gate', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Gate.Type', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.GateMovingStatus', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.GatePosePointList', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.GateSpecialState', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.GateType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Goal', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.GpsInfo', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.GpsInfo.GnssStatus', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.GpsInfo.GpsPositionStatus', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Intersection', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Lane', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Lane.Type', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Lane.VirtualType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.LocalMap', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.LocalNaviLine', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Localization', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Localization.MapMode', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Localization.Mode', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Localization.RoadType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Localization.SourceFrom', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Localization.Status', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.MainLight', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.MainLight.Source', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.MapData', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.MapData.GeoMapType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.MapVersionMeta', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.MessageFormat', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.MetricDataFrame', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.MetricLineData', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.MetricLineData.LineXType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.MetricLineType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.MetricPointData', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.MovableGate', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ObjectNegligibleType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Obstacle', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Obstacle.ObstacleType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.OverwriteType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Parking', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Parking.Type', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Path', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.PathPoint', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Paths', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Pillar', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Planning', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.PlanningTrafficLight', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.PlanningTrafficLight.StateSource', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.PncBusinessCommand', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.PncBusinessInfo', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Point2D', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Point3D', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Polygon', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Polygon2d', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Pose3D', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.PredictionTrajectory', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ProhibitedArea', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ProhibitedArea.Type', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.RecoveryCommand', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.RequestData', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ResponseData', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.RoadMark', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.RoadMark.Type', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.RoadType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Routing', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Routing.MissionStatus', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Routing.RouterEdition', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.RoutingLine', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.RoutingPosition', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.SafetyIsland', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Scene', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.SceneType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.SensorAnomalyDetection', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.AnomalySeverity', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.SensorCalibration', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.SessionType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ShapeInfo', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ShieldEmergencyStop', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ShieldOutput', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.SpeedBump', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.SpeedLimitStatus', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitSource', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.SpeedPlanningStatus', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.StopInfo', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.StopInfo.Status', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.StopLine', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.StopLine.Type', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.TrackList', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.TrafficLight', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.TrafficLight.MultiFrameTrafficSignal', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.TrafficLight.SignalFrameTrafficSignal', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.TrafficLight.TurnType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.TrafficSign', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.TrafficSignType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.TrajectoryPoint', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.UltrasonicData', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.UltrasonicObstacle', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.UltrasonicObstacle.UltrasonicState', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.UserAuthroizeInfo', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Vector2d', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Vector3d', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Vehicle', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Vehicle.DrivingMode', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Vehicle.GearPosition', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Vehicle.ShieldDrivingMode', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.Vehicle.TurnSignalState', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleBumper', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleCalibration', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleData', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleData.AnomalySeverity', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleData.LocMode', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleData.WeatherCommand', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleData.WeatherType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleMotion', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleParam', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleSignal', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleSignal.SwitchState', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleSignalCtrl', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.SwitchCtrl', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleTrajectory', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VerificationData', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VerificationData.VerifcationInfoCase', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VirtualObstacle', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.VirtualObstacle.VirtualType', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ZPoint2D', null, global);
goog.exportSymbol('proto.zelos.zoe.data_view.proto.ZPoint3D', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Point2D = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Point2D, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Point2D.displayName = 'proto.zelos.zoe.data_view.proto.Point2D';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Point3D = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Point3D, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Point3D.displayName = 'proto.zelos.zoe.data_view.proto.Point3D';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.ZPoint2D = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.ZPoint2D, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.ZPoint2D.displayName = 'proto.zelos.zoe.data_view.proto.ZPoint2D';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.ZPoint3D = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.ZPoint3D, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.ZPoint3D.displayName = 'proto.zelos.zoe.data_view.proto.ZPoint3D';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Vector3d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Vector3d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Vector3d.displayName = 'proto.zelos.zoe.data_view.proto.Vector3d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Vector2d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Vector2d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Vector2d.displayName = 'proto.zelos.zoe.data_view.proto.Vector2d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Pose3D = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Pose3D, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Pose3D.displayName = 'proto.zelos.zoe.data_view.proto.Pose3D';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Polygon2d = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Polygon2d.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Polygon2d, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Polygon2d.displayName = 'proto.zelos.zoe.data_view.proto.Polygon2d';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.StopLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.StopLine.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.StopLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.StopLine.displayName = 'proto.zelos.zoe.data_view.proto.StopLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Boundary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Boundary.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Boundary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Boundary.displayName = 'proto.zelos.zoe.data_view.proto.Boundary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Lane = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Lane.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Lane, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Lane.displayName = 'proto.zelos.zoe.data_view.proto.Lane';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.ClearZone = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.ClearZone.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.ClearZone, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.ClearZone.displayName = 'proto.zelos.zoe.data_view.proto.ClearZone';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.CrossWalk = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.CrossWalk.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.CrossWalk, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.CrossWalk.displayName = 'proto.zelos.zoe.data_view.proto.CrossWalk';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.FreeArea = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.FreeArea.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.FreeArea, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.FreeArea.displayName = 'proto.zelos.zoe.data_view.proto.FreeArea';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Gate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Gate.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Gate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Gate.displayName = 'proto.zelos.zoe.data_view.proto.Gate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Intersection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Intersection.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Intersection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Intersection.displayName = 'proto.zelos.zoe.data_view.proto.Intersection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Parking = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Parking.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Parking, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Parking.displayName = 'proto.zelos.zoe.data_view.proto.Parking';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Pillar = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Pillar.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Pillar, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Pillar.displayName = 'proto.zelos.zoe.data_view.proto.Pillar';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.ProhibitedArea.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.ProhibitedArea, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.ProhibitedArea.displayName = 'proto.zelos.zoe.data_view.proto.ProhibitedArea';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.SafetyIsland = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.SafetyIsland.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.SafetyIsland, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.SafetyIsland.displayName = 'proto.zelos.zoe.data_view.proto.SafetyIsland';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.SpeedBump = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.SpeedBump.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.SpeedBump, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.SpeedBump.displayName = 'proto.zelos.zoe.data_view.proto.SpeedBump';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.MainLight = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.MainLight, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.MainLight.displayName = 'proto.zelos.zoe.data_view.proto.MainLight';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.TrafficLight = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.TrafficLight.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.TrafficLight, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.TrafficLight.displayName = 'proto.zelos.zoe.data_view.proto.TrafficLight';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Polygon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Polygon.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Polygon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Polygon.displayName = 'proto.zelos.zoe.data_view.proto.Polygon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.TrajectoryPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.TrajectoryPoint.displayName = 'proto.zelos.zoe.data_view.proto.TrajectoryPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.PredictionTrajectory.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.PredictionTrajectory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.PredictionTrajectory.displayName = 'proto.zelos.zoe.data_view.proto.PredictionTrajectory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Obstacle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Obstacle.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Obstacle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Obstacle.displayName = 'proto.zelos.zoe.data_view.proto.Obstacle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.RoutingLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.RoutingLine.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.RoutingLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.RoutingLine.displayName = 'proto.zelos.zoe.data_view.proto.RoutingLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Routing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Routing.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Routing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Routing.displayName = 'proto.zelos.zoe.data_view.proto.Routing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.StopInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.StopInfo.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.StopInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.StopInfo.displayName = 'proto.zelos.zoe.data_view.proto.StopInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.RoutingPosition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.RoutingPosition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.RoutingPosition.displayName = 'proto.zelos.zoe.data_view.proto.RoutingPosition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.PlanningTrafficLight = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.PlanningTrafficLight, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.PlanningTrafficLight.displayName = 'proto.zelos.zoe.data_view.proto.PlanningTrafficLight';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Goal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Goal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Goal.displayName = 'proto.zelos.zoe.data_view.proto.Goal';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Paths = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Paths.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Paths, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Paths.displayName = 'proto.zelos.zoe.data_view.proto.Paths';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.displayName = 'proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.VirtualObstacle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.VirtualObstacle.displayName = 'proto.zelos.zoe.data_view.proto.VirtualObstacle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.VehicleSignalCtrl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.VehicleSignalCtrl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.displayName = 'proto.zelos.zoe.data_view.proto.VehicleSignalCtrl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.SpeedLimitStatus.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.SpeedLimitStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.SpeedLimitStatus.displayName = 'proto.zelos.zoe.data_view.proto.SpeedLimitStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.displayName = 'proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.SpeedPlanningStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.SpeedPlanningStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.displayName = 'proto.zelos.zoe.data_view.proto.SpeedPlanningStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.CloudAssistanceStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.displayName = 'proto.zelos.zoe.data_view.proto.CloudAssistanceStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.displayName = 'proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.displayName = 'proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.AlarmLevelCode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.AlarmLevelCode.displayName = 'proto.zelos.zoe.data_view.proto.AlarmLevelCode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Planning = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Planning.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Planning, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Planning.displayName = 'proto.zelos.zoe.data_view.proto.Planning';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Vehicle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Vehicle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Vehicle.displayName = 'proto.zelos.zoe.data_view.proto.Vehicle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.AuthorizeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.AuthorizeInfo.displayName = 'proto.zelos.zoe.data_view.proto.AuthorizeInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.UserAuthroizeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.displayName = 'proto.zelos.zoe.data_view.proto.UserAuthroizeInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.VerificationData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.zelos.zoe.data_view.proto.VerificationData.oneofGroups_);
};
goog.inherits(proto.zelos.zoe.data_view.proto.VerificationData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.VerificationData.displayName = 'proto.zelos.zoe.data_view.proto.VerificationData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.ConnectionData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.ConnectionData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.ConnectionData.displayName = 'proto.zelos.zoe.data_view.proto.ConnectionData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.VehicleParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.VehicleParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.VehicleParam.displayName = 'proto.zelos.zoe.data_view.proto.VehicleParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.CameraCalibration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.CameraCalibration.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.CameraCalibration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.CameraCalibration.displayName = 'proto.zelos.zoe.data_view.proto.CameraCalibration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.SensorCalibration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.SensorCalibration.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.SensorCalibration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.SensorCalibration.displayName = 'proto.zelos.zoe.data_view.proto.SensorCalibration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.VehicleCalibration.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.VehicleCalibration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.VehicleCalibration.displayName = 'proto.zelos.zoe.data_view.proto.VehicleCalibration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.ResponseData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.ResponseData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.ResponseData.displayName = 'proto.zelos.zoe.data_view.proto.ResponseData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.ShapeInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.ShapeInfo.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.ShapeInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.ShapeInfo.displayName = 'proto.zelos.zoe.data_view.proto.ShapeInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.MapVersionMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.MapVersionMeta.displayName = 'proto.zelos.zoe.data_view.proto.MapVersionMeta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.MapData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.MapData.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.MapData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.MapData.displayName = 'proto.zelos.zoe.data_view.proto.MapData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.BumperEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.BumperEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.BumperEntity.displayName = 'proto.zelos.zoe.data_view.proto.BumperEntity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.VehicleBumper = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.VehicleBumper.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.VehicleBumper, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.VehicleBumper.displayName = 'proto.zelos.zoe.data_view.proto.VehicleBumper';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.VehicleSignal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.VehicleSignal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.VehicleSignal.displayName = 'proto.zelos.zoe.data_view.proto.VehicleSignal';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.VehicleMotion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.VehicleMotion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.VehicleMotion.displayName = 'proto.zelos.zoe.data_view.proto.VehicleMotion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.SensorAnomalyDetection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.displayName = 'proto.zelos.zoe.data_view.proto.SensorAnomalyDetection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.displayName = 'proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.UltrasonicObstacle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.UltrasonicObstacle.displayName = 'proto.zelos.zoe.data_view.proto.UltrasonicObstacle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.UltrasonicData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.UltrasonicData.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.UltrasonicData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.UltrasonicData.displayName = 'proto.zelos.zoe.data_view.proto.UltrasonicData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.VehicleTrajectory.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.VehicleTrajectory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.VehicleTrajectory.displayName = 'proto.zelos.zoe.data_view.proto.VehicleTrajectory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.displayName = 'proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.GatePosePointList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.GatePosePointList.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.GatePosePointList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.GatePosePointList.displayName = 'proto.zelos.zoe.data_view.proto.GatePosePointList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.ConstructionAreaList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.ConstructionAreaList.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.ConstructionAreaList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.ConstructionAreaList.displayName = 'proto.zelos.zoe.data_view.proto.ConstructionAreaList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.PncBusinessInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.PncBusinessInfo.displayName = 'proto.zelos.zoe.data_view.proto.PncBusinessInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.EraseObstacle = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.EraseObstacle, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.EraseObstacle.displayName = 'proto.zelos.zoe.data_view.proto.EraseObstacle';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.FreeMoveEraseArea, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.displayName = 'proto.zelos.zoe.data_view.proto.FreeMoveEraseArea';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.EnvironmentEdit.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.EnvironmentEdit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.EnvironmentEdit.displayName = 'proto.zelos.zoe.data_view.proto.EnvironmentEdit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.RecoveryCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.RecoveryCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.RecoveryCommand.displayName = 'proto.zelos.zoe.data_view.proto.RecoveryCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.zelos.zoe.data_view.proto.FreeMoveCommand.oneofGroups_);
};
goog.inherits(proto.zelos.zoe.data_view.proto.FreeMoveCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.FreeMoveCommand.displayName = 'proto.zelos.zoe.data_view.proto.FreeMoveCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.displayName = 'proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.displayName = 'proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.displayName = 'proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.displayName = 'proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.displayName = 'proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.PncBusinessCommand.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.PncBusinessCommand, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.PncBusinessCommand.displayName = 'proto.zelos.zoe.data_view.proto.PncBusinessCommand';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.CoordinateType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.CoordinateType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.CoordinateType.displayName = 'proto.zelos.zoe.data_view.proto.CoordinateType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.BusinessInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.BusinessInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.BusinessInfo.displayName = 'proto.zelos.zoe.data_view.proto.BusinessInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.ShieldEmergencyStop, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.displayName = 'proto.zelos.zoe.data_view.proto.ShieldEmergencyStop';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Path = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.Path.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Path, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Path.displayName = 'proto.zelos.zoe.data_view.proto.Path';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.EmergencySteering = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.EmergencySteering, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.EmergencySteering.displayName = 'proto.zelos.zoe.data_view.proto.EmergencySteering';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.ShieldOutput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.ShieldOutput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.ShieldOutput.displayName = 'proto.zelos.zoe.data_view.proto.ShieldOutput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.RoadMark = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.RoadMark.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.RoadMark, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.RoadMark.displayName = 'proto.zelos.zoe.data_view.proto.RoadMark';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.LocalNaviLine.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.LocalNaviLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.LocalNaviLine.displayName = 'proto.zelos.zoe.data_view.proto.LocalNaviLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.EntryLine = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.EntryLine.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.EntryLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.EntryLine.displayName = 'proto.zelos.zoe.data_view.proto.EntryLine';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.LocalMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.LocalMap.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.LocalMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.LocalMap.displayName = 'proto.zelos.zoe.data_view.proto.LocalMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.TrafficSign = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.TrafficSign, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.TrafficSign.displayName = 'proto.zelos.zoe.data_view.proto.TrafficSign';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.TrackList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.TrackList.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.TrackList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.TrackList.displayName = 'proto.zelos.zoe.data_view.proto.TrackList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Scene = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Scene, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Scene.displayName = 'proto.zelos.zoe.data_view.proto.Scene';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.MovableGate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.MovableGate.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.MovableGate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.MovableGate.displayName = 'proto.zelos.zoe.data_view.proto.MovableGate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.VehicleData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.VehicleData.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.VehicleData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.VehicleData.displayName = 'proto.zelos.zoe.data_view.proto.VehicleData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.MetricDataFrame.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.MetricDataFrame, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.MetricDataFrame.displayName = 'proto.zelos.zoe.data_view.proto.MetricDataFrame';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.MetricLineData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.MetricLineData.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.MetricLineData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.MetricLineData.displayName = 'proto.zelos.zoe.data_view.proto.MetricLineData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.MetricPointData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.MetricPointData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.MetricPointData.displayName = 'proto.zelos.zoe.data_view.proto.MetricPointData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.PathPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.PathPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.PathPoint.displayName = 'proto.zelos.zoe.data_view.proto.PathPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.ControlDebugData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.ControlDebugData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.ControlDebugData.displayName = 'proto.zelos.zoe.data_view.proto.ControlDebugData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.GpsInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.GpsInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.GpsInfo.displayName = 'proto.zelos.zoe.data_view.proto.GpsInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.Localization = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.Localization, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.Localization.displayName = 'proto.zelos.zoe.data_view.proto.Localization';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.RequestData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.RequestData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.RequestData.displayName = 'proto.zelos.zoe.data_view.proto.RequestData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.FrameData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.FrameData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.FrameData.displayName = 'proto.zelos.zoe.data_view.proto.FrameData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.DataPackage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.zelos.zoe.data_view.proto.DataPackage.repeatedFields_, null);
};
goog.inherits(proto.zelos.zoe.data_view.proto.DataPackage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.DataPackage.displayName = 'proto.zelos.zoe.data_view.proto.DataPackage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.zelos.zoe.data_view.proto.DataSessionProtocal.oneofGroups_);
};
goog.inherits(proto.zelos.zoe.data_view.proto.DataSessionProtocal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.zelos.zoe.data_view.proto.DataSessionProtocal.displayName = 'proto.zelos.zoe.data_view.proto.DataSessionProtocal';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Point2D.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Point2D.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Point2D} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Point2D.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
xInt: jspb.Message.getFieldWithDefault(msg, 3, 0),
yInt: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Point2D}
 */
proto.zelos.zoe.data_view.proto.Point2D.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Point2D;
  return proto.zelos.zoe.data_view.proto.Point2D.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Point2D} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Point2D}
 */
proto.zelos.zoe.data_view.proto.Point2D.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setXInt(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Point2D.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Point2D.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Point2D} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Point2D.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getXInt();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getYInt();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional float x = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Point2D.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Point2D} returns this
 */
proto.zelos.zoe.data_view.proto.Point2D.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float y = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Point2D.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Point2D} returns this
 */
proto.zelos.zoe.data_view.proto.Point2D.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 x_int = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Point2D.prototype.getXInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Point2D} returns this
 */
proto.zelos.zoe.data_view.proto.Point2D.prototype.setXInt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 y_int = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Point2D.prototype.getYInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Point2D} returns this
 */
proto.zelos.zoe.data_view.proto.Point2D.prototype.setYInt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Point3D.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Point3D} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Point3D.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
z: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
xInt: jspb.Message.getFieldWithDefault(msg, 4, 0),
yInt: jspb.Message.getFieldWithDefault(msg, 5, 0),
zInt: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Point3D.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Point3D;
  return proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Point3D} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setZ(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setXInt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYInt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setZInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Point3D} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getZ();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getXInt();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getYInt();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getZInt();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional float x = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Point3D} returns this
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float y = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Point3D} returns this
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float z = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.getZ = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Point3D} returns this
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.setZ = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int32 x_int = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.getXInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Point3D} returns this
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.setXInt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 y_int = 5;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.getYInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Point3D} returns this
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.setYInt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 z_int = 6;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.getZInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Point3D} returns this
 */
proto.zelos.zoe.data_view.proto.Point3D.prototype.setZInt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.ZPoint2D.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.ZPoint2D.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.ZPoint2D} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ZPoint2D.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFieldWithDefault(msg, 1, 0),
y: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.ZPoint2D}
 */
proto.zelos.zoe.data_view.proto.ZPoint2D.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.ZPoint2D;
  return proto.zelos.zoe.data_view.proto.ZPoint2D.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.ZPoint2D} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.ZPoint2D}
 */
proto.zelos.zoe.data_view.proto.ZPoint2D.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.ZPoint2D.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.ZPoint2D.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.ZPoint2D} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ZPoint2D.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
};


/**
 * optional uint64 x = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.ZPoint2D.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.ZPoint2D} returns this
 */
proto.zelos.zoe.data_view.proto.ZPoint2D.prototype.setX = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 y = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.ZPoint2D.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.ZPoint2D} returns this
 */
proto.zelos.zoe.data_view.proto.ZPoint2D.prototype.setY = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.ZPoint3D.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.ZPoint3D.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.ZPoint3D} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ZPoint3D.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFieldWithDefault(msg, 1, "0"),
y: jspb.Message.getFieldWithDefault(msg, 2, "0"),
z: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.ZPoint3D}
 */
proto.zelos.zoe.data_view.proto.ZPoint3D.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.ZPoint3D;
  return proto.zelos.zoe.data_view.proto.ZPoint3D.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.ZPoint3D} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.ZPoint3D}
 */
proto.zelos.zoe.data_view.proto.ZPoint3D.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setZ(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.ZPoint3D.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.ZPoint3D.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.ZPoint3D} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ZPoint3D.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getY();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getZ();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
};


/**
 * optional uint64 x = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.ZPoint3D.prototype.getX = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.ZPoint3D} returns this
 */
proto.zelos.zoe.data_view.proto.ZPoint3D.prototype.setX = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 y = 2;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.ZPoint3D.prototype.getY = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.ZPoint3D} returns this
 */
proto.zelos.zoe.data_view.proto.ZPoint3D.prototype.setY = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional double z = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.ZPoint3D.prototype.getZ = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.ZPoint3D} returns this
 */
proto.zelos.zoe.data_view.proto.ZPoint3D.prototype.setZ = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Vector3d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Vector3d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Vector3d.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
z: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
xInt: jspb.Message.getFieldWithDefault(msg, 4, 0),
yInt: jspb.Message.getFieldWithDefault(msg, 5, 0),
zInt: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Vector3d}
 */
proto.zelos.zoe.data_view.proto.Vector3d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Vector3d;
  return proto.zelos.zoe.data_view.proto.Vector3d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Vector3d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Vector3d}
 */
proto.zelos.zoe.data_view.proto.Vector3d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setZ(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setXInt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYInt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setZInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Vector3d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Vector3d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Vector3d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getZ();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getXInt();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getYInt();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getZInt();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional double x = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vector3d} returns this
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double y = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vector3d} returns this
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double z = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.getZ = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vector3d} returns this
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.setZ = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int32 x_int = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.getXInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vector3d} returns this
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.setXInt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 y_int = 5;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.getYInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vector3d} returns this
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.setYInt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 z_int = 6;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.getZInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vector3d} returns this
 */
proto.zelos.zoe.data_view.proto.Vector3d.prototype.setZInt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Vector2d.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Vector2d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Vector2d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Vector2d.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Vector2d}
 */
proto.zelos.zoe.data_view.proto.Vector2d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Vector2d;
  return proto.zelos.zoe.data_view.proto.Vector2d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Vector2d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Vector2d}
 */
proto.zelos.zoe.data_view.proto.Vector2d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Vector2d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Vector2d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Vector2d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Vector2d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double x = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vector2d.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vector2d} returns this
 */
proto.zelos.zoe.data_view.proto.Vector2d.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double y = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vector2d.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vector2d} returns this
 */
proto.zelos.zoe.data_view.proto.Vector2d.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Pose3D.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Pose3D.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Pose3D} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Pose3D.toObject = function(includeInstance, msg) {
  var f, obj = {
position: (f = msg.getPosition()) && proto.zelos.zoe.data_view.proto.Point3D.toObject(includeInstance, f),
orientation: (f = msg.getOrientation()) && proto.zelos.zoe.data_view.proto.Point3D.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Pose3D}
 */
proto.zelos.zoe.data_view.proto.Pose3D.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Pose3D;
  return proto.zelos.zoe.data_view.proto.Pose3D.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Pose3D} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Pose3D}
 */
proto.zelos.zoe.data_view.proto.Pose3D.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.setOrientation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Pose3D.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Pose3D.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Pose3D} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Pose3D.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getOrientation();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * optional Point3D position = 1;
 * @return {?proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Pose3D.prototype.getPosition = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Point3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Point3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Pose3D} returns this
*/
proto.zelos.zoe.data_view.proto.Pose3D.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Pose3D} returns this
 */
proto.zelos.zoe.data_view.proto.Pose3D.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Pose3D.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Point3D orientation = 2;
 * @return {?proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Pose3D.prototype.getOrientation = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Point3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Point3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Pose3D} returns this
*/
proto.zelos.zoe.data_view.proto.Pose3D.prototype.setOrientation = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Pose3D} returns this
 */
proto.zelos.zoe.data_view.proto.Pose3D.prototype.clearOrientation = function() {
  return this.setOrientation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Pose3D.prototype.hasOrientation = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Polygon2d.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Polygon2d.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Polygon2d.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Polygon2d} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Polygon2d.toObject = function(includeInstance, msg) {
  var f, obj = {
isConvex: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
polygonPointList: jspb.Message.toObjectList(msg.getPolygonPointList(),
    proto.zelos.zoe.data_view.proto.Point2D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Polygon2d}
 */
proto.zelos.zoe.data_view.proto.Polygon2d.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Polygon2d;
  return proto.zelos.zoe.data_view.proto.Polygon2d.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Polygon2d} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Polygon2d}
 */
proto.zelos.zoe.data_view.proto.Polygon2d.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsConvex(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point2D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point2D.deserializeBinaryFromReader);
      msg.addPolygonPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Polygon2d.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Polygon2d.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Polygon2d} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Polygon2d.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsConvex();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getPolygonPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point2D.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool is_convex = 1;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Polygon2d.prototype.getIsConvex = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.Polygon2d} returns this
 */
proto.zelos.zoe.data_view.proto.Polygon2d.prototype.setIsConvex = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated Point2D polygon_point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point2D>}
 */
proto.zelos.zoe.data_view.proto.Polygon2d.prototype.getPolygonPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point2D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point2D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point2D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Polygon2d} returns this
*/
proto.zelos.zoe.data_view.proto.Polygon2d.prototype.setPolygonPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point2D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point2D}
 */
proto.zelos.zoe.data_view.proto.Polygon2d.prototype.addPolygonPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point2D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Polygon2d} returns this
 */
proto.zelos.zoe.data_view.proto.Polygon2d.prototype.clearPolygonPointList = function() {
  return this.setPolygonPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.StopLine.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.StopLine.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.StopLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.StopLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.StopLine.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.StopLine}
 */
proto.zelos.zoe.data_view.proto.StopLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.StopLine;
  return proto.zelos.zoe.data_view.proto.StopLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.StopLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.StopLine}
 */
proto.zelos.zoe.data_view.proto.StopLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.StopLine.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.StopLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.StopLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.StopLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.StopLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.StopLine.Type = {
  UNKNOWN: 0,
  SIGNAL: 1,
  YIELD: 2,
  STOP: 3
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.StopLine.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.StopLine} returns this
 */
proto.zelos.zoe.data_view.proto.StopLine.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Type type = 2;
 * @return {!proto.zelos.zoe.data_view.proto.StopLine.Type}
 */
proto.zelos.zoe.data_view.proto.StopLine.prototype.getType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.StopLine.Type} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.StopLine.Type} value
 * @return {!proto.zelos.zoe.data_view.proto.StopLine} returns this
 */
proto.zelos.zoe.data_view.proto.StopLine.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated Point3D point = 3;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.StopLine.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 3));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.StopLine} returns this
*/
proto.zelos.zoe.data_view.proto.StopLine.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.StopLine.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.StopLine} returns this
 */
proto.zelos.zoe.data_view.proto.StopLine.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Boundary.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Boundary.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Boundary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Boundary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Boundary.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
color: jspb.Message.getFieldWithDefault(msg, 3, 0),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Boundary}
 */
proto.zelos.zoe.data_view.proto.Boundary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Boundary;
  return proto.zelos.zoe.data_view.proto.Boundary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Boundary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Boundary}
 */
proto.zelos.zoe.data_view.proto.Boundary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Boundary.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Boundary.Color} */ (reader.readEnum());
      msg.setColor(value);
      break;
    case 4:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Boundary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Boundary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Boundary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Boundary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getColor();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Boundary.Type = {
  UNKNOWN: 0,
  DASHED: 1,
  SOLID: 2,
  BARRIER: 3,
  CURB: 4,
  VIRTUAL: 5
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Boundary.Color = {
  OTHER: 0,
  YELLOW: 1,
  WHITE: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.Boundary.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.Boundary} returns this
 */
proto.zelos.zoe.data_view.proto.Boundary.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Type type = 2;
 * @return {!proto.zelos.zoe.data_view.proto.Boundary.Type}
 */
proto.zelos.zoe.data_view.proto.Boundary.prototype.getType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Boundary.Type} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Boundary.Type} value
 * @return {!proto.zelos.zoe.data_view.proto.Boundary} returns this
 */
proto.zelos.zoe.data_view.proto.Boundary.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Color color = 3;
 * @return {!proto.zelos.zoe.data_view.proto.Boundary.Color}
 */
proto.zelos.zoe.data_view.proto.Boundary.prototype.getColor = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Boundary.Color} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Boundary.Color} value
 * @return {!proto.zelos.zoe.data_view.proto.Boundary} returns this
 */
proto.zelos.zoe.data_view.proto.Boundary.prototype.setColor = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated Point3D point = 4;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.Boundary.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 4));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Boundary} returns this
*/
proto.zelos.zoe.data_view.proto.Boundary.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Boundary.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Boundary} returns this
 */
proto.zelos.zoe.data_view.proto.Boundary.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Lane.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Lane.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Lane.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Lane} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Lane.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance),
virtualType: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Lane}
 */
proto.zelos.zoe.data_view.proto.Lane.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Lane;
  return proto.zelos.zoe.data_view.proto.Lane.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Lane} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Lane}
 */
proto.zelos.zoe.data_view.proto.Lane.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Lane.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    case 4:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Lane.VirtualType} */ (reader.readEnum());
      msg.setVirtualType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Lane.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Lane.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Lane} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Lane.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getVirtualType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Lane.Type = {
  UNKNOWN: 0,
  BICYCLE: 1,
  DRIVING: 2,
  SIDEWALK: 3,
  BUSWAY: 4,
  EMERGENCY: 5,
  REVERSIBLE: 6,
  RAIL: 7
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Lane.VirtualType = {
  NONE: 0,
  INTERSECTION_MOCKED: 1,
  ROAD_MOCKED: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.Lane.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.Lane} returns this
 */
proto.zelos.zoe.data_view.proto.Lane.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Type type = 2;
 * @return {!proto.zelos.zoe.data_view.proto.Lane.Type}
 */
proto.zelos.zoe.data_view.proto.Lane.prototype.getType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Lane.Type} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Lane.Type} value
 * @return {!proto.zelos.zoe.data_view.proto.Lane} returns this
 */
proto.zelos.zoe.data_view.proto.Lane.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated Point3D point = 3;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.Lane.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 3));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Lane} returns this
*/
proto.zelos.zoe.data_view.proto.Lane.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Lane.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Lane} returns this
 */
proto.zelos.zoe.data_view.proto.Lane.prototype.clearPointList = function() {
  return this.setPointList([]);
};


/**
 * optional VirtualType virtual_type = 4;
 * @return {!proto.zelos.zoe.data_view.proto.Lane.VirtualType}
 */
proto.zelos.zoe.data_view.proto.Lane.prototype.getVirtualType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Lane.VirtualType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Lane.VirtualType} value
 * @return {!proto.zelos.zoe.data_view.proto.Lane} returns this
 */
proto.zelos.zoe.data_view.proto.Lane.prototype.setVirtualType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.ClearZone.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.ClearZone.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.ClearZone.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.ClearZone} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ClearZone.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.ClearZone}
 */
proto.zelos.zoe.data_view.proto.ClearZone.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.ClearZone;
  return proto.zelos.zoe.data_view.proto.ClearZone.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.ClearZone} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.ClearZone}
 */
proto.zelos.zoe.data_view.proto.ClearZone.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.ClearZone.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.ClearZone.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.ClearZone} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ClearZone.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.ClearZone.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.ClearZone} returns this
 */
proto.zelos.zoe.data_view.proto.ClearZone.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Point3D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.ClearZone.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.ClearZone} returns this
*/
proto.zelos.zoe.data_view.proto.ClearZone.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.ClearZone.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.ClearZone} returns this
 */
proto.zelos.zoe.data_view.proto.ClearZone.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.CrossWalk.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.CrossWalk.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.CrossWalk.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.CrossWalk} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.CrossWalk.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.CrossWalk}
 */
proto.zelos.zoe.data_view.proto.CrossWalk.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.CrossWalk;
  return proto.zelos.zoe.data_view.proto.CrossWalk.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.CrossWalk} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.CrossWalk}
 */
proto.zelos.zoe.data_view.proto.CrossWalk.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.CrossWalk.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.CrossWalk.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.CrossWalk} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.CrossWalk.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.CrossWalk.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.CrossWalk} returns this
 */
proto.zelos.zoe.data_view.proto.CrossWalk.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Point3D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.CrossWalk.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.CrossWalk} returns this
*/
proto.zelos.zoe.data_view.proto.CrossWalk.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.CrossWalk.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.CrossWalk} returns this
 */
proto.zelos.zoe.data_view.proto.CrossWalk.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.FreeArea.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.FreeArea.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.FreeArea.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.FreeArea} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeArea.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.FreeArea}
 */
proto.zelos.zoe.data_view.proto.FreeArea.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.FreeArea;
  return proto.zelos.zoe.data_view.proto.FreeArea.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.FreeArea} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.FreeArea}
 */
proto.zelos.zoe.data_view.proto.FreeArea.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.FreeArea.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.FreeArea.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.FreeArea} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeArea.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.FreeArea.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.FreeArea} returns this
 */
proto.zelos.zoe.data_view.proto.FreeArea.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Point3D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.FreeArea.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.FreeArea} returns this
*/
proto.zelos.zoe.data_view.proto.FreeArea.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.FreeArea.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.FreeArea} returns this
 */
proto.zelos.zoe.data_view.proto.FreeArea.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Gate.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Gate.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Gate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Gate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Gate.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Gate}
 */
proto.zelos.zoe.data_view.proto.Gate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Gate;
  return proto.zelos.zoe.data_view.proto.Gate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Gate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Gate}
 */
proto.zelos.zoe.data_view.proto.Gate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Gate.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Gate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Gate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Gate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Gate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Gate.Type = {
  UNKNOWN: 0,
  AUTO: 1,
  MANUAL: 2,
  BARRIER: 3
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.Gate.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.Gate} returns this
 */
proto.zelos.zoe.data_view.proto.Gate.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Type type = 2;
 * @return {!proto.zelos.zoe.data_view.proto.Gate.Type}
 */
proto.zelos.zoe.data_view.proto.Gate.prototype.getType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Gate.Type} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Gate.Type} value
 * @return {!proto.zelos.zoe.data_view.proto.Gate} returns this
 */
proto.zelos.zoe.data_view.proto.Gate.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated Point3D point = 3;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.Gate.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 3));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Gate} returns this
*/
proto.zelos.zoe.data_view.proto.Gate.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Gate.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Gate} returns this
 */
proto.zelos.zoe.data_view.proto.Gate.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Intersection.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Intersection.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Intersection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Intersection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Intersection.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Intersection}
 */
proto.zelos.zoe.data_view.proto.Intersection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Intersection;
  return proto.zelos.zoe.data_view.proto.Intersection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Intersection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Intersection}
 */
proto.zelos.zoe.data_view.proto.Intersection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Intersection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Intersection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Intersection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Intersection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.Intersection.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.Intersection} returns this
 */
proto.zelos.zoe.data_view.proto.Intersection.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Point3D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.Intersection.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Intersection} returns this
*/
proto.zelos.zoe.data_view.proto.Intersection.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Intersection.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Intersection} returns this
 */
proto.zelos.zoe.data_view.proto.Intersection.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Parking.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Parking.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Parking.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Parking} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Parking.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Parking}
 */
proto.zelos.zoe.data_view.proto.Parking.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Parking;
  return proto.zelos.zoe.data_view.proto.Parking.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Parking} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Parking}
 */
proto.zelos.zoe.data_view.proto.Parking.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Parking.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Parking.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Parking.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Parking} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Parking.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Parking.Type = {
  UNKNOWN: 0,
  ACTUAL: 1,
  VIRTUAL: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.Parking.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.Parking} returns this
 */
proto.zelos.zoe.data_view.proto.Parking.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Type type = 2;
 * @return {!proto.zelos.zoe.data_view.proto.Parking.Type}
 */
proto.zelos.zoe.data_view.proto.Parking.prototype.getType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Parking.Type} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Parking.Type} value
 * @return {!proto.zelos.zoe.data_view.proto.Parking} returns this
 */
proto.zelos.zoe.data_view.proto.Parking.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated Point3D point = 3;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.Parking.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 3));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Parking} returns this
*/
proto.zelos.zoe.data_view.proto.Parking.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Parking.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Parking} returns this
 */
proto.zelos.zoe.data_view.proto.Parking.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Pillar.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Pillar.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Pillar.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Pillar} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Pillar.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Pillar}
 */
proto.zelos.zoe.data_view.proto.Pillar.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Pillar;
  return proto.zelos.zoe.data_view.proto.Pillar.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Pillar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Pillar}
 */
proto.zelos.zoe.data_view.proto.Pillar.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Pillar.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Pillar.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Pillar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Pillar.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.Pillar.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.Pillar} returns this
 */
proto.zelos.zoe.data_view.proto.Pillar.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Point3D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.Pillar.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Pillar} returns this
*/
proto.zelos.zoe.data_view.proto.Pillar.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Pillar.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Pillar} returns this
 */
proto.zelos.zoe.data_view.proto.Pillar.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.ProhibitedArea.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.ProhibitedArea} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.ProhibitedArea}
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.ProhibitedArea;
  return proto.zelos.zoe.data_view.proto.ProhibitedArea.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.ProhibitedArea} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.ProhibitedArea}
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.ProhibitedArea.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.ProhibitedArea.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.ProhibitedArea} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.Type = {
  UNKNOWN: 0,
  GREEN_BELT: 1,
  PLATFORM: 2,
  BOOTH: 3
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.ProhibitedArea} returns this
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Type type = 2;
 * @return {!proto.zelos.zoe.data_view.proto.ProhibitedArea.Type}
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.prototype.getType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.ProhibitedArea.Type} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.ProhibitedArea.Type} value
 * @return {!proto.zelos.zoe.data_view.proto.ProhibitedArea} returns this
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated Point3D point = 3;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 3));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.ProhibitedArea} returns this
*/
proto.zelos.zoe.data_view.proto.ProhibitedArea.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.ProhibitedArea} returns this
 */
proto.zelos.zoe.data_view.proto.ProhibitedArea.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.SafetyIsland.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.SafetyIsland.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.SafetyIsland.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.SafetyIsland} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SafetyIsland.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.SafetyIsland}
 */
proto.zelos.zoe.data_view.proto.SafetyIsland.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.SafetyIsland;
  return proto.zelos.zoe.data_view.proto.SafetyIsland.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.SafetyIsland} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.SafetyIsland}
 */
proto.zelos.zoe.data_view.proto.SafetyIsland.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.SafetyIsland.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.SafetyIsland.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.SafetyIsland} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SafetyIsland.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.SafetyIsland.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.SafetyIsland} returns this
 */
proto.zelos.zoe.data_view.proto.SafetyIsland.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Point3D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.SafetyIsland.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.SafetyIsland} returns this
*/
proto.zelos.zoe.data_view.proto.SafetyIsland.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.SafetyIsland.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.SafetyIsland} returns this
 */
proto.zelos.zoe.data_view.proto.SafetyIsland.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.SpeedBump.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.SpeedBump.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.SpeedBump.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.SpeedBump} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SpeedBump.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.SpeedBump}
 */
proto.zelos.zoe.data_view.proto.SpeedBump.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.SpeedBump;
  return proto.zelos.zoe.data_view.proto.SpeedBump.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.SpeedBump} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.SpeedBump}
 */
proto.zelos.zoe.data_view.proto.SpeedBump.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.SpeedBump.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.SpeedBump.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.SpeedBump} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SpeedBump.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.SpeedBump.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.SpeedBump} returns this
 */
proto.zelos.zoe.data_view.proto.SpeedBump.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Point3D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.SpeedBump.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.SpeedBump} returns this
*/
proto.zelos.zoe.data_view.proto.SpeedBump.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.SpeedBump.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.SpeedBump} returns this
 */
proto.zelos.zoe.data_view.proto.SpeedBump.prototype.clearPointList = function() {
  return this.setPointList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.MainLight.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.MainLight.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.MainLight} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MainLight.toObject = function(includeInstance, msg) {
  var f, obj = {
main: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
source: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.MainLight}
 */
proto.zelos.zoe.data_view.proto.MainLight.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.MainLight;
  return proto.zelos.zoe.data_view.proto.MainLight.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.MainLight} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.MainLight}
 */
proto.zelos.zoe.data_view.proto.MainLight.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMain(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.MainLight.Source} */ (reader.readEnum());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.MainLight.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.MainLight.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.MainLight} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MainLight.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMain();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.MainLight.Source = {
  UNKNOWN: 0,
  PLANNING_INTEREST: 1,
  PERCEPTION: 2,
  PERCEPTION_ALL_UNKNOWN: 3
};

/**
 * optional bool main = 1;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.MainLight.prototype.getMain = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.MainLight} returns this
 */
proto.zelos.zoe.data_view.proto.MainLight.prototype.setMain = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional Source source = 2;
 * @return {!proto.zelos.zoe.data_view.proto.MainLight.Source}
 */
proto.zelos.zoe.data_view.proto.MainLight.prototype.getSource = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.MainLight.Source} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.MainLight.Source} value
 * @return {!proto.zelos.zoe.data_view.proto.MainLight} returns this
 */
proto.zelos.zoe.data_view.proto.MainLight.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.TrafficLight.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.TrafficLight.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.TrafficLight} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.TrafficLight.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
light: jspb.Message.getFieldWithDefault(msg, 2, 0),
position: (f = msg.getPosition()) && proto.zelos.zoe.data_view.proto.Point3D.toObject(includeInstance, f),
angle: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
remainingSecs: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
duration: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
multiFrameState: jspb.Message.getFieldWithDefault(msg, 7, 0),
mainLight: (f = msg.getMainLight()) && proto.zelos.zoe.data_view.proto.MainLight.toObject(includeInstance, f),
lightSpotTypeList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
layerNum: jspb.Message.getFieldWithDefault(msg, 10, 0),
angleInt: jspb.Message.getFieldWithDefault(msg, 11, 0),
remainingSecsInt: jspb.Message.getFieldWithDefault(msg, 12, 0),
durationInt: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.TrafficLight;
  return proto.zelos.zoe.data_view.proto.TrafficLight.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.TrafficLight} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.TrafficLight.SignalFrameTrafficSignal} */ (reader.readEnum());
      msg.setLight(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAngle(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRemainingSecs(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDuration(value);
      break;
    case 7:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.TrafficLight.MultiFrameTrafficSignal} */ (reader.readEnum());
      msg.setMultiFrameState(value);
      break;
    case 8:
      var value = new proto.zelos.zoe.data_view.proto.MainLight;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.MainLight.deserializeBinaryFromReader);
      msg.setMainLight(value);
      break;
    case 9:
      var values = /** @type {!Array<!proto.zelos.zoe.data_view.proto.TrafficLight.TurnType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addLightSpotType(values[i]);
      }
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLayerNum(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAngleInt(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRemainingSecsInt(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDurationInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.TrafficLight.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.TrafficLight} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.TrafficLight.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLight();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getAngle();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getRemainingSecs();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getMultiFrameState();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getMainLight();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.zelos.zoe.data_view.proto.MainLight.serializeBinaryToWriter
    );
  }
  f = message.getLightSpotTypeList();
  if (f.length > 0) {
    writer.writePackedEnum(
      9,
      f
    );
  }
  f = message.getLayerNum();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getAngleInt();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getRemainingSecsInt();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getDurationInt();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.SignalFrameTrafficSignal = {
  TL_UNKNOWN: 0,
  TL_RED: 1,
  TL_GREEN: 2,
  TL_YELLOW: 3,
  TL_BLACK: 4
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.MultiFrameTrafficSignal = {
  TL_NONE: 0,
  TL_FLASHING_GREEN: 1,
  TL_FLASHING_RED: 2,
  TL_FLASHING_YELLOW: 3,
  TL_CONTINUE_UNKNOWN: 4,
  TL_CONTINUE_BLACK: 5,
  TL_CONTINUE_GREEN: 6,
  TL_CONTINUE_RED: 7,
  TL_CONTINUE_YELLOW: 8
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.TurnType = {
  TL_UNKNOWN_TURNTYPE: 0,
  TL_STRAIGHT: 1,
  TL_RIGHT_TURN: 2,
  TL_LEFT_TURN: 3,
  TL_U_TURN: 4,
  TL_COUNT_DOWN: 5,
  TL_BLACK_LIGHT: 6,
  TL_YELLOW_LIGHT: 7,
  TL_MULTI_DIRECTION: 8
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SignalFrameTrafficSignal light = 2;
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight.SignalFrameTrafficSignal}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getLight = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.TrafficLight.SignalFrameTrafficSignal} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.TrafficLight.SignalFrameTrafficSignal} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setLight = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Point3D position = 3;
 * @return {?proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getPosition = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Point3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 3));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Point3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
*/
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional double angle = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getAngle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setAngle = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double remaining_secs = 5;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getRemainingSecs = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setRemainingSecs = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double duration = 6;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setDuration = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional MultiFrameTrafficSignal multi_frame_state = 7;
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight.MultiFrameTrafficSignal}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getMultiFrameState = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.TrafficLight.MultiFrameTrafficSignal} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.TrafficLight.MultiFrameTrafficSignal} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setMultiFrameState = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional MainLight main_light = 8;
 * @return {?proto.zelos.zoe.data_view.proto.MainLight}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getMainLight = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.MainLight} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.MainLight, 8));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.MainLight|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
*/
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setMainLight = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.clearMainLight = function() {
  return this.setMainLight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.hasMainLight = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated TurnType light_spot_type = 9;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.TrafficLight.TurnType>}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getLightSpotTypeList = function() {
  return /** @type {!Array<!proto.zelos.zoe.data_view.proto.TrafficLight.TurnType>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.TrafficLight.TurnType>} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setLightSpotTypeList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.TrafficLight.TurnType} value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.addLightSpotType = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.clearLightSpotTypeList = function() {
  return this.setLightSpotTypeList([]);
};


/**
 * optional int32 layer_num = 10;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getLayerNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setLayerNum = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 angle_int = 11;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getAngleInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setAngleInt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 remaining_secs_int = 12;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getRemainingSecsInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setRemainingSecsInt = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 duration_int = 13;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.getDurationInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficLight.prototype.setDurationInt = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Polygon.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Polygon.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Polygon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Polygon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Polygon.toObject = function(includeInstance, msg) {
  var f, obj = {
center: (f = msg.getCenter()) && proto.zelos.zoe.data_view.proto.Pose3D.toObject(includeInstance, f),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point2D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Polygon}
 */
proto.zelos.zoe.data_view.proto.Polygon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Polygon;
  return proto.zelos.zoe.data_view.proto.Polygon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Polygon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Polygon}
 */
proto.zelos.zoe.data_view.proto.Polygon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.Pose3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Pose3D.deserializeBinaryFromReader);
      msg.setCenter(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point2D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point2D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Polygon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Polygon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Polygon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Polygon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCenter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.Pose3D.serializeBinaryToWriter
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point2D.serializeBinaryToWriter
    );
  }
};


/**
 * optional Pose3D center = 1;
 * @return {?proto.zelos.zoe.data_view.proto.Pose3D}
 */
proto.zelos.zoe.data_view.proto.Polygon.prototype.getCenter = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Pose3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Pose3D, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Pose3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Polygon} returns this
*/
proto.zelos.zoe.data_view.proto.Polygon.prototype.setCenter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Polygon} returns this
 */
proto.zelos.zoe.data_view.proto.Polygon.prototype.clearCenter = function() {
  return this.setCenter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Polygon.prototype.hasCenter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Point2D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point2D>}
 */
proto.zelos.zoe.data_view.proto.Polygon.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point2D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point2D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point2D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Polygon} returns this
*/
proto.zelos.zoe.data_view.proto.Polygon.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point2D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point2D}
 */
proto.zelos.zoe.data_view.proto.Polygon.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point2D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Polygon} returns this
 */
proto.zelos.zoe.data_view.proto.Polygon.prototype.clearPointList = function() {
  return this.setPointList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.TrajectoryPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.TrajectoryPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
point: (f = msg.getPoint()) && proto.zelos.zoe.data_view.proto.Point3D.toObject(includeInstance, f),
relativeTime: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
relativeTimeInt: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.TrajectoryPoint}
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.TrajectoryPoint;
  return proto.zelos.zoe.data_view.proto.TrajectoryPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.TrajectoryPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.TrajectoryPoint}
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.setPoint(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRelativeTime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRelativeTimeInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.TrajectoryPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.TrajectoryPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPoint();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getRelativeTime();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getRelativeTimeInt();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional Point3D point = 1;
 * @return {?proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.prototype.getPoint = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Point3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Point3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.TrajectoryPoint} returns this
*/
proto.zelos.zoe.data_view.proto.TrajectoryPoint.prototype.setPoint = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.TrajectoryPoint} returns this
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.prototype.clearPoint = function() {
  return this.setPoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.prototype.hasPoint = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double relative_time = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.prototype.getRelativeTime = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.TrajectoryPoint} returns this
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.prototype.setRelativeTime = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 relative_time_int = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.prototype.getRelativeTimeInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.TrajectoryPoint} returns this
 */
proto.zelos.zoe.data_view.proto.TrajectoryPoint.prototype.setRelativeTimeInt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.PredictionTrajectory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.PredictionTrajectory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.toObject = function(includeInstance, msg) {
  var f, obj = {
trajectoryPointList: jspb.Message.toObjectList(msg.getTrajectoryPointList(),
    proto.zelos.zoe.data_view.proto.TrajectoryPoint.toObject, includeInstance),
probability: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
probabilityInt: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.PredictionTrajectory}
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.PredictionTrajectory;
  return proto.zelos.zoe.data_view.proto.PredictionTrajectory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.PredictionTrajectory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.PredictionTrajectory}
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.TrajectoryPoint;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.TrajectoryPoint.deserializeBinaryFromReader);
      msg.addTrajectoryPoint(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProbability(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setProbabilityInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.PredictionTrajectory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.PredictionTrajectory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrajectoryPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.TrajectoryPoint.serializeBinaryToWriter
    );
  }
  f = message.getProbability();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getProbabilityInt();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated TrajectoryPoint trajectory_point = 1;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.TrajectoryPoint>}
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.prototype.getTrajectoryPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.TrajectoryPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.TrajectoryPoint, 1));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.TrajectoryPoint>} value
 * @return {!proto.zelos.zoe.data_view.proto.PredictionTrajectory} returns this
*/
proto.zelos.zoe.data_view.proto.PredictionTrajectory.prototype.setTrajectoryPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.TrajectoryPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.TrajectoryPoint}
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.prototype.addTrajectoryPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.zelos.zoe.data_view.proto.TrajectoryPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.PredictionTrajectory} returns this
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.prototype.clearTrajectoryPointList = function() {
  return this.setTrajectoryPointList([]);
};


/**
 * optional double probability = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.prototype.getProbability = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PredictionTrajectory} returns this
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.prototype.setProbability = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 probability_int = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.prototype.getProbabilityInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PredictionTrajectory} returns this
 */
proto.zelos.zoe.data_view.proto.PredictionTrajectory.prototype.setProbabilityInt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Obstacle.repeatedFields_ = [8,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Obstacle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Obstacle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Obstacle.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
obstacleType: jspb.Message.getFieldWithDefault(msg, 2, 0),
length: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
width: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
height: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
polygon: (f = msg.getPolygon()) && proto.zelos.zoe.data_view.proto.Polygon.toObject(includeInstance, f),
trajectoryList: jspb.Message.toObjectList(msg.getTrajectoryList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance),
speed: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
speedHeading: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
preTrajectoryList: jspb.Message.toObjectList(msg.getPreTrajectoryList(),
    proto.zelos.zoe.data_view.proto.PredictionTrajectory.toObject, includeInstance),
negligibleType: jspb.Message.getFieldWithDefault(msg, 12, 0),
lengthInt: jspb.Message.getFieldWithDefault(msg, 13, 0),
widthInt: jspb.Message.getFieldWithDefault(msg, 14, 0),
heightInt: jspb.Message.getFieldWithDefault(msg, 15, 0),
speedInt: jspb.Message.getFieldWithDefault(msg, 16, 0),
speedHeadingInt: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle}
 */
proto.zelos.zoe.data_view.proto.Obstacle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Obstacle;
  return proto.zelos.zoe.data_view.proto.Obstacle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Obstacle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle}
 */
proto.zelos.zoe.data_view.proto.Obstacle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Obstacle.ObstacleType} */ (reader.readEnum());
      msg.setObstacleType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLength(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWidth(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeight(value);
      break;
    case 6:
      var value = new proto.zelos.zoe.data_view.proto.Polygon;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Polygon.deserializeBinaryFromReader);
      msg.setPolygon(value);
      break;
    case 8:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addTrajectory(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSpeed(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSpeedHeading(value);
      break;
    case 11:
      var value = new proto.zelos.zoe.data_view.proto.PredictionTrajectory;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.PredictionTrajectory.deserializeBinaryFromReader);
      msg.addPreTrajectory(value);
      break;
    case 12:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.ObjectNegligibleType} */ (reader.readEnum());
      msg.setNegligibleType(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLengthInt(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidthInt(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeightInt(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSpeedInt(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSpeedHeadingInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Obstacle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Obstacle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Obstacle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getObstacleType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLength();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getPolygon();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.zelos.zoe.data_view.proto.Polygon.serializeBinaryToWriter
    );
  }
  f = message.getTrajectoryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getSpeedHeading();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getPreTrajectoryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.zelos.zoe.data_view.proto.PredictionTrajectory.serializeBinaryToWriter
    );
  }
  f = message.getNegligibleType();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getLengthInt();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getWidthInt();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getHeightInt();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getSpeedInt();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getSpeedHeadingInt();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Obstacle.ObstacleType = {
  MISC: 0,
  CAR: 1,
  TRUCK: 2,
  BUS: 3,
  PEDESTRIAN: 4,
  BICYCLE: 5,
  TRICYCLE: 6,
  SPECIAL_SMALL_VEHICLE: 7,
  UNKNOWN_OBSTACLE: 8,
  MAP_POINT_CLUSTER: 100,
  TRAFFIC_CONE: 101,
  LOW_PROFILE_OBSTACLE: 102,
  UNMANNED_BICYCLE: 103,
  VEGETATION: 104,
  ROAD: 105,
  CURB: 106,
  BUILDING: 107,
  WALL: 108,
  FENCE: 109,
  POLE: 110,
  TRAFFIC_LIGHT: 111,
  TRAFFIC_SIGN: 112,
  SEMANTIC_LOW_OBSTACLE: 113,
  MANHOLE_COVER: 114,
  UNNAVIGABLE_AREA: 115,
  UNKNOWN_NONMOVABLE: 116,
  LIFTING_LEVER: 117,
  HOLE: 118,
  FLOATING_OBSTACLE: 119,
  TRUNK: 120,
  TRAFFIC_BARREL: 121,
  LOW_BRANCH: 150,
  LOW_MOUND: 151,
  LOW_PAPER: 152,
  LOW_STONE: 153,
  LOW_SMALL_BOX: 154,
  LOW_PLASTIC_BAG: 155,
  LOW_ANIMAL: 156,
  LOW_HAZARD_TRIANGLE: 157,
  LOW_SHAFT: 158,
  LOW_BARREL: 159,
  LOW_OVERTURNED_BICYCLE: 160,
  LOW_SEAT: 161,
  LOW_STAKE: 162,
  LOW_OTHERS: 179,
  RETRACTABLE_GATE: 181,
  ROLLING_SHUTTER: 182,
  BACKGROUND: 199,
  ARTIFICIAL_OBJECT: 200,
  BLIND_SPOT_OBSTACLE: 201
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ObstacleType obstacle_type = 2;
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle.ObstacleType}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getObstacleType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Obstacle.ObstacleType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Obstacle.ObstacleType} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setObstacleType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional double length = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getLength = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setLength = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double width = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setWidth = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double height = 5;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional Polygon polygon = 6;
 * @return {?proto.zelos.zoe.data_view.proto.Polygon}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getPolygon = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Polygon} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Polygon, 6));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Polygon|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
*/
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setPolygon = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.clearPolygon = function() {
  return this.setPolygon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.hasPolygon = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated Point3D trajectory = 8;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getTrajectoryList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 8));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
*/
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setTrajectoryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.addTrajectory = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.clearTrajectoryList = function() {
  return this.setTrajectoryList([]);
};


/**
 * optional double speed = 9;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double speed_heading = 10;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getSpeedHeading = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setSpeedHeading = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * repeated PredictionTrajectory pre_trajectory = 11;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.PredictionTrajectory>}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getPreTrajectoryList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.PredictionTrajectory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.PredictionTrajectory, 11));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.PredictionTrajectory>} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
*/
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setPreTrajectoryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.PredictionTrajectory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.PredictionTrajectory}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.addPreTrajectory = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.zelos.zoe.data_view.proto.PredictionTrajectory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.clearPreTrajectoryList = function() {
  return this.setPreTrajectoryList([]);
};


/**
 * optional ObjectNegligibleType negligible_type = 12;
 * @return {!proto.zelos.zoe.data_view.proto.ObjectNegligibleType}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getNegligibleType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.ObjectNegligibleType} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.ObjectNegligibleType} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setNegligibleType = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional int32 length_int = 13;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getLengthInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setLengthInt = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 width_int = 14;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getWidthInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setWidthInt = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 height_int = 15;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getHeightInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setHeightInt = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 speed_int = 16;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getSpeedInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setSpeedInt = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 speed_heading_int = 17;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.getSpeedHeadingInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle} returns this
 */
proto.zelos.zoe.data_view.proto.Obstacle.prototype.setSpeedHeadingInt = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.RoutingLine.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.RoutingLine.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.RoutingLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.RoutingLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.RoutingLine.toObject = function(includeInstance, msg) {
  var f, obj = {
routingLineList: jspb.Message.toObjectList(msg.getRoutingLineList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance),
isCutOff: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
id: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.RoutingLine}
 */
proto.zelos.zoe.data_view.proto.RoutingLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.RoutingLine;
  return proto.zelos.zoe.data_view.proto.RoutingLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.RoutingLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.RoutingLine}
 */
proto.zelos.zoe.data_view.proto.RoutingLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addRoutingLine(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCutOff(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.RoutingLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.RoutingLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.RoutingLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.RoutingLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoutingLineList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getIsCutOff();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * repeated Point3D routing_line = 1;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.RoutingLine.prototype.getRoutingLineList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 1));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.RoutingLine} returns this
*/
proto.zelos.zoe.data_view.proto.RoutingLine.prototype.setRoutingLineList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.RoutingLine.prototype.addRoutingLine = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.RoutingLine} returns this
 */
proto.zelos.zoe.data_view.proto.RoutingLine.prototype.clearRoutingLineList = function() {
  return this.setRoutingLineList([]);
};


/**
 * optional bool is_cut_off = 2;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.RoutingLine.prototype.getIsCutOff = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.RoutingLine} returns this
 */
proto.zelos.zoe.data_view.proto.RoutingLine.prototype.setIsCutOff = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional int32 id = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.RoutingLine.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.RoutingLine} returns this
 */
proto.zelos.zoe.data_view.proto.RoutingLine.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Routing.repeatedFields_ = [1,2,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Routing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Routing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Routing.toObject = function(includeInstance, msg) {
  var f, obj = {
routingLineList: jspb.Message.toObjectList(msg.getRoutingLineList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance),
laneIdList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
spot: (f = msg.getSpot()) && proto.zelos.zoe.data_view.proto.StopInfo.toObject(includeInstance, f),
subRoutingLineList: jspb.Message.toObjectList(msg.getSubRoutingLineList(),
    proto.zelos.zoe.data_view.proto.RoutingLine.toObject, includeInstance),
motorRoutingLineList: jspb.Message.toObjectList(msg.getMotorRoutingLineList(),
    proto.zelos.zoe.data_view.proto.RoutingLine.toObject, includeInstance),
routerEdition: jspb.Message.getFieldWithDefault(msg, 6, 0),
missionStatus: jspb.Message.getFieldWithDefault(msg, 7, 0),
forceEnableSdMapMode: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Routing}
 */
proto.zelos.zoe.data_view.proto.Routing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Routing;
  return proto.zelos.zoe.data_view.proto.Routing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Routing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Routing}
 */
proto.zelos.zoe.data_view.proto.Routing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addRoutingLine(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addLaneId(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.StopInfo;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.StopInfo.deserializeBinaryFromReader);
      msg.setSpot(value);
      break;
    case 4:
      var value = new proto.zelos.zoe.data_view.proto.RoutingLine;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.RoutingLine.deserializeBinaryFromReader);
      msg.addSubRoutingLine(value);
      break;
    case 5:
      var value = new proto.zelos.zoe.data_view.proto.RoutingLine;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.RoutingLine.deserializeBinaryFromReader);
      msg.addMotorRoutingLine(value);
      break;
    case 6:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Routing.RouterEdition} */ (reader.readEnum());
      msg.setRouterEdition(value);
      break;
    case 7:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Routing.MissionStatus} */ (reader.readEnum());
      msg.setMissionStatus(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setForceEnableSdMapMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Routing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Routing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Routing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoutingLineList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getLaneIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getSpot();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.StopInfo.serializeBinaryToWriter
    );
  }
  f = message.getSubRoutingLineList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.zelos.zoe.data_view.proto.RoutingLine.serializeBinaryToWriter
    );
  }
  f = message.getMotorRoutingLineList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.zelos.zoe.data_view.proto.RoutingLine.serializeBinaryToWriter
    );
  }
  f = message.getRouterEdition();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getMissionStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getForceEnableSdMapMode();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Routing.RouterEdition = {
  ROUTER_UNKNONW: 0,
  ROUTER_NON_MOTOR: 1,
  ROUTER_MOTOR: 2
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Routing.MissionStatus = {
  UNKNOWN: 0,
  RUNNING: 1,
  PAUSE: 2,
  CANCELLED: 3,
  SMOOTHING: 4,
  NAVIGATING: 5,
  AS_ARRIVED: 6,
  UPDATE_OBSTACLE: 7,
  MANUALGUIDANCE: 8,
  PULL_OVER: 9
};

/**
 * repeated Point3D routing_line = 1;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.getRoutingLineList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 1));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
*/
proto.zelos.zoe.data_view.proto.Routing.prototype.setRoutingLineList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.addRoutingLine = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.clearRoutingLineList = function() {
  return this.setRoutingLineList([]);
};


/**
 * repeated string lane_id = 2;
 * @return {!Array<string>}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.getLaneIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.setLaneIdList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.addLaneId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.clearLaneIdList = function() {
  return this.setLaneIdList([]);
};


/**
 * optional StopInfo spot = 3;
 * @return {?proto.zelos.zoe.data_view.proto.StopInfo}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.getSpot = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.StopInfo} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.StopInfo, 3));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.StopInfo|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
*/
proto.zelos.zoe.data_view.proto.Routing.prototype.setSpot = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.clearSpot = function() {
  return this.setSpot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.hasSpot = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated RoutingLine sub_routing_line = 4;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.RoutingLine>}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.getSubRoutingLineList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.RoutingLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.RoutingLine, 4));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.RoutingLine>} value
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
*/
proto.zelos.zoe.data_view.proto.Routing.prototype.setSubRoutingLineList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.RoutingLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.RoutingLine}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.addSubRoutingLine = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.zelos.zoe.data_view.proto.RoutingLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.clearSubRoutingLineList = function() {
  return this.setSubRoutingLineList([]);
};


/**
 * repeated RoutingLine motor_routing_line = 5;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.RoutingLine>}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.getMotorRoutingLineList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.RoutingLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.RoutingLine, 5));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.RoutingLine>} value
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
*/
proto.zelos.zoe.data_view.proto.Routing.prototype.setMotorRoutingLineList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.RoutingLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.RoutingLine}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.addMotorRoutingLine = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.zelos.zoe.data_view.proto.RoutingLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.clearMotorRoutingLineList = function() {
  return this.setMotorRoutingLineList([]);
};


/**
 * optional RouterEdition router_edition = 6;
 * @return {!proto.zelos.zoe.data_view.proto.Routing.RouterEdition}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.getRouterEdition = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Routing.RouterEdition} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Routing.RouterEdition} value
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.setRouterEdition = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional MissionStatus mission_status = 7;
 * @return {!proto.zelos.zoe.data_view.proto.Routing.MissionStatus}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.getMissionStatus = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Routing.MissionStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Routing.MissionStatus} value
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.setMissionStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional bool force_enable_sd_map_mode = 8;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.getForceEnableSdMapMode = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.Routing} returns this
 */
proto.zelos.zoe.data_view.proto.Routing.prototype.setForceEnableSdMapMode = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.StopInfo.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.StopInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.StopInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.StopInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.StopInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
stopSpot: (f = msg.getStopSpot()) && proto.zelos.zoe.data_view.proto.RoutingPosition.toObject(includeInstance, f),
status: jspb.Message.getFieldWithDefault(msg, 3, 0),
parkingSpotList: jspb.Message.toObjectList(msg.getParkingSpotList(),
    proto.zelos.zoe.data_view.proto.RoutingPosition.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.StopInfo}
 */
proto.zelos.zoe.data_view.proto.StopInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.StopInfo;
  return proto.zelos.zoe.data_view.proto.StopInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.StopInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.StopInfo}
 */
proto.zelos.zoe.data_view.proto.StopInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.RoutingPosition;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.RoutingPosition.deserializeBinaryFromReader);
      msg.setStopSpot(value);
      break;
    case 3:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.StopInfo.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = new proto.zelos.zoe.data_view.proto.RoutingPosition;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.RoutingPosition.deserializeBinaryFromReader);
      msg.addParkingSpot(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.StopInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.StopInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.StopInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.StopInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getStopSpot();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.RoutingPosition.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getParkingSpotList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.zelos.zoe.data_view.proto.RoutingPosition.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.StopInfo.Status = {
  TODO: 0,
  DONE: 1,
  DOING: 2
};

/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.StopInfo.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.StopInfo} returns this
 */
proto.zelos.zoe.data_view.proto.StopInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional RoutingPosition stop_spot = 2;
 * @return {?proto.zelos.zoe.data_view.proto.RoutingPosition}
 */
proto.zelos.zoe.data_view.proto.StopInfo.prototype.getStopSpot = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.RoutingPosition} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.RoutingPosition, 2));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.RoutingPosition|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.StopInfo} returns this
*/
proto.zelos.zoe.data_view.proto.StopInfo.prototype.setStopSpot = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.StopInfo} returns this
 */
proto.zelos.zoe.data_view.proto.StopInfo.prototype.clearStopSpot = function() {
  return this.setStopSpot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.StopInfo.prototype.hasStopSpot = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Status status = 3;
 * @return {!proto.zelos.zoe.data_view.proto.StopInfo.Status}
 */
proto.zelos.zoe.data_view.proto.StopInfo.prototype.getStatus = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.StopInfo.Status} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.StopInfo.Status} value
 * @return {!proto.zelos.zoe.data_view.proto.StopInfo} returns this
 */
proto.zelos.zoe.data_view.proto.StopInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated RoutingPosition parking_spot = 4;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.RoutingPosition>}
 */
proto.zelos.zoe.data_view.proto.StopInfo.prototype.getParkingSpotList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.RoutingPosition>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.RoutingPosition, 4));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.RoutingPosition>} value
 * @return {!proto.zelos.zoe.data_view.proto.StopInfo} returns this
*/
proto.zelos.zoe.data_view.proto.StopInfo.prototype.setParkingSpotList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.RoutingPosition=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.RoutingPosition}
 */
proto.zelos.zoe.data_view.proto.StopInfo.prototype.addParkingSpot = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.zelos.zoe.data_view.proto.RoutingPosition, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.StopInfo} returns this
 */
proto.zelos.zoe.data_view.proto.StopInfo.prototype.clearParkingSpotList = function() {
  return this.setParkingSpotList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.RoutingPosition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.RoutingPosition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.toObject = function(includeInstance, msg) {
  var f, obj = {
zcsX: jspb.Message.getFieldWithDefault(msg, 1, 0),
zcsY: jspb.Message.getFieldWithDefault(msg, 2, 0),
angle: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
mapX: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
mapY: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
angleInt: jspb.Message.getFieldWithDefault(msg, 9, 0),
mapXInt: jspb.Message.getFieldWithDefault(msg, 10, 0),
mapYInt: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.RoutingPosition}
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.RoutingPosition;
  return proto.zelos.zoe.data_view.proto.RoutingPosition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.RoutingPosition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.RoutingPosition}
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setZcsX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setZcsY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAngle(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMapX(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMapY(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAngleInt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapXInt(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapYInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.RoutingPosition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.RoutingPosition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getZcsX();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getZcsY();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getAngle();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getMapX();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMapY();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getAngleInt();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getMapXInt();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getMapYInt();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
};


/**
 * optional uint64 zcs_x = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.getZcsX = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.RoutingPosition} returns this
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.setZcsX = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 zcs_y = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.getZcsY = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.RoutingPosition} returns this
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.setZcsY = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double angle = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.getAngle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.RoutingPosition} returns this
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.setAngle = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double map_x = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.getMapX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.RoutingPosition} returns this
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.setMapX = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double map_y = 5;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.getMapY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.RoutingPosition} returns this
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.setMapY = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int32 angle_int = 9;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.getAngleInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.RoutingPosition} returns this
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.setAngleInt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 map_x_int = 10;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.getMapXInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.RoutingPosition} returns this
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.setMapXInt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 map_y_int = 11;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.getMapYInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.RoutingPosition} returns this
 */
proto.zelos.zoe.data_view.proto.RoutingPosition.prototype.setMapYInt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.PlanningTrafficLight.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.PlanningTrafficLight.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.PlanningTrafficLight} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.PlanningTrafficLight.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
source: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.PlanningTrafficLight}
 */
proto.zelos.zoe.data_view.proto.PlanningTrafficLight.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.PlanningTrafficLight;
  return proto.zelos.zoe.data_view.proto.PlanningTrafficLight.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.PlanningTrafficLight} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.PlanningTrafficLight}
 */
proto.zelos.zoe.data_view.proto.PlanningTrafficLight.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.PlanningTrafficLight.StateSource} */ (reader.readEnum());
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.PlanningTrafficLight.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.PlanningTrafficLight.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.PlanningTrafficLight} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.PlanningTrafficLight.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.PlanningTrafficLight.StateSource = {
  UNKNOWN: 0,
  PERCEPTION: 1,
  SUPERVISOR: 2
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.PlanningTrafficLight.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningTrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningTrafficLight.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional StateSource source = 2;
 * @return {!proto.zelos.zoe.data_view.proto.PlanningTrafficLight.StateSource}
 */
proto.zelos.zoe.data_view.proto.PlanningTrafficLight.prototype.getSource = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.PlanningTrafficLight.StateSource} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.PlanningTrafficLight.StateSource} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningTrafficLight} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningTrafficLight.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Goal.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Goal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Goal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Goal.toObject = function(includeInstance, msg) {
  var f, obj = {
position: (f = msg.getPosition()) && proto.zelos.zoe.data_view.proto.Point2D.toObject(includeInstance, f),
heading: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
headingInt: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Goal}
 */
proto.zelos.zoe.data_view.proto.Goal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Goal;
  return proto.zelos.zoe.data_view.proto.Goal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Goal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Goal}
 */
proto.zelos.zoe.data_view.proto.Goal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.Point2D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point2D.deserializeBinaryFromReader);
      msg.setPosition(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeading(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeadingInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Goal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Goal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Goal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Goal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPosition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.Point2D.serializeBinaryToWriter
    );
  }
  f = message.getHeading();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getHeadingInt();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional Point2D position = 1;
 * @return {?proto.zelos.zoe.data_view.proto.Point2D}
 */
proto.zelos.zoe.data_view.proto.Goal.prototype.getPosition = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Point2D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Point2D, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Point2D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Goal} returns this
*/
proto.zelos.zoe.data_view.proto.Goal.prototype.setPosition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Goal} returns this
 */
proto.zelos.zoe.data_view.proto.Goal.prototype.clearPosition = function() {
  return this.setPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Goal.prototype.hasPosition = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double heading = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Goal.prototype.getHeading = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Goal} returns this
 */
proto.zelos.zoe.data_view.proto.Goal.prototype.setHeading = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 heading_int = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Goal.prototype.getHeadingInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Goal} returns this
 */
proto.zelos.zoe.data_view.proto.Goal.prototype.setHeadingInt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Paths.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Paths.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Paths.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Paths} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Paths.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
pathPointList: jspb.Message.toObjectList(msg.getPathPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Paths}
 */
proto.zelos.zoe.data_view.proto.Paths.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Paths;
  return proto.zelos.zoe.data_view.proto.Paths.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Paths} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Paths}
 */
proto.zelos.zoe.data_view.proto.Paths.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPathPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Paths.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Paths.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Paths} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Paths.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPathPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.Paths.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.Paths} returns this
 */
proto.zelos.zoe.data_view.proto.Paths.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Point3D path_point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.Paths.prototype.getPathPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Paths} returns this
*/
proto.zelos.zoe.data_view.proto.Paths.prototype.setPathPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Paths.prototype.addPathPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Paths} returns this
 */
proto.zelos.zoe.data_view.proto.Paths.prototype.clearPathPointList = function() {
  return this.setPathPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
centerPosition: (f = msg.getCenterPosition()) && proto.zelos.zoe.data_view.proto.Point3D.toObject(includeInstance, f),
heading: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
length: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
width: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
height: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
relativeObstacleIdList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
headingInt: jspb.Message.getFieldWithDefault(msg, 8, 0),
lengthInt: jspb.Message.getFieldWithDefault(msg, 9, 0),
widthInt: jspb.Message.getFieldWithDefault(msg, 10, 0),
heightInt: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle;
  return proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.setCenterPosition(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeading(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLength(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWidth(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeight(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addRelativeObstacleId(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeadingInt(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLengthInt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setWidthInt(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHeightInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCenterPosition();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getHeading();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getLength();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getRelativeObstacleIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getHeadingInt();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getLengthInt();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getWidthInt();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getHeightInt();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Point3D center_position = 2;
 * @return {?proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.getCenterPosition = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Point3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Point3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
*/
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.setCenterPosition = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.clearCenterPosition = function() {
  return this.setCenterPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.hasCenterPosition = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional double heading = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.getHeading = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.setHeading = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double length = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.getLength = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.setLength = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double width = 5;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.setWidth = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double height = 6;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.setHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * repeated string relative_obstacle_id = 7;
 * @return {!Array<string>}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.getRelativeObstacleIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.setRelativeObstacleIdList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.addRelativeObstacleId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.clearRelativeObstacleIdList = function() {
  return this.setRelativeObstacleIdList([]);
};


/**
 * optional int32 heading_int = 8;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.getHeadingInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.setHeadingInt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 length_int = 9;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.getLengthInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.setLengthInt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 width_int = 10;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.getWidthInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.setWidthInt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 height_int = 11;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.getHeightInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.prototype.setHeightInt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.VirtualObstacle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.VirtualObstacle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
virtualType: jspb.Message.getFieldWithDefault(msg, 2, 0),
polygon: (f = msg.getPolygon()) && proto.zelos.zoe.data_view.proto.Polygon2d.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.VirtualObstacle}
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.VirtualObstacle;
  return proto.zelos.zoe.data_view.proto.VirtualObstacle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.VirtualObstacle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.VirtualObstacle}
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.VirtualObstacle.VirtualType} */ (reader.readEnum());
      msg.setVirtualType(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.Polygon2d;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Polygon2d.deserializeBinaryFromReader);
      msg.setPolygon(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.VirtualObstacle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.VirtualObstacle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVirtualType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPolygon();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.Polygon2d.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.VirtualType = {
  VIRTUAL_MISC: 0,
  DESTINATION: 1,
  CROSSWALK: 2,
  CLEAR_ZONE: 3,
  WAITING_POINT: 4,
  TRAFFIC_LIGHT: 5,
  TRAFFIC_LIGHT_L2: 6,
  GATE_BARRIER: 7,
  ROUTING_OBS: 8,
  PROHIBITED_AREA: 9,
  SLOW_DOWN_AREA: 10,
  BLIND_SPOT_OBS: 11,
  UNPROTECTED_TURN: 12,
  PARKING_AREA: 13,
  NOA_TAKE_OVER_COLLECT_AREA: 45,
  GLOBAL_TAKE_OVER_COLLECT_AREA: 46,
  NOA_AND_GLOBAL_TAKE_OVER_COLLECT_AREA: 47
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.VirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional VirtualType virtual_type = 2;
 * @return {!proto.zelos.zoe.data_view.proto.VirtualObstacle.VirtualType}
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.prototype.getVirtualType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.VirtualObstacle.VirtualType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.VirtualObstacle.VirtualType} value
 * @return {!proto.zelos.zoe.data_view.proto.VirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.prototype.setVirtualType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Polygon2d polygon = 3;
 * @return {?proto.zelos.zoe.data_view.proto.Polygon2d}
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.prototype.getPolygon = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Polygon2d} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Polygon2d, 3));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Polygon2d|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VirtualObstacle} returns this
*/
proto.zelos.zoe.data_view.proto.VirtualObstacle.prototype.setPolygon = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VirtualObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.prototype.clearPolygon = function() {
  return this.setPolygon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VirtualObstacle.prototype.hasPolygon = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.toObject = function(includeInstance, msg) {
  var f, obj = {
brakeLamp: jspb.Message.getFieldWithDefault(msg, 4, 0),
horn: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl}
 */
proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.VehicleSignalCtrl;
  return proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl}
 */
proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.SwitchCtrl} */ (reader.readEnum());
      msg.setBrakeLamp(value);
      break;
    case 8:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.SwitchCtrl} */ (reader.readEnum());
      msg.setHorn(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrakeLamp();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getHorn();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.SwitchCtrl = {
  SWITCH_NONE: 0,
  SWITCH_ON: 1,
  SWITCH_OFF: 2
};

/**
 * optional SwitchCtrl brake_lamp = 4;
 * @return {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.SwitchCtrl}
 */
proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.prototype.getBrakeLamp = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.SwitchCtrl} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.SwitchCtrl} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.prototype.setBrakeLamp = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional SwitchCtrl horn = 8;
 * @return {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.SwitchCtrl}
 */
proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.prototype.getHorn = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.SwitchCtrl} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.SwitchCtrl} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleSignalCtrl} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.prototype.setHorn = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.SpeedLimitStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
source: jspb.Message.getFieldWithDefault(msg, 1, 0),
speedLimit: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
speedLimitInfosList: jspb.Message.toObjectList(msg.getSpeedLimitInfosList(),
    proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.SpeedLimitStatus;
  return proto.zelos.zoe.data_view.proto.SpeedLimitStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitSource} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSpeedLimit(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.deserializeBinaryFromReader);
      msg.addSpeedLimitInfos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.SpeedLimitStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSpeedLimit();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getSpeedLimitInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitSource = {
  UNKNOWN: 0,
  VEHICLE_TYPE: 1,
  ROAD_TYPE: 2,
  ROAD_WIDTH: 3,
  LANE: 4,
  JUNCTION_DEFENCE: 5,
  SUPERVISOR: 6,
  SLOW_DOWN_AREA: 7,
  PERC_SCENE: 8,
  LOCALIZATION: 9,
  GUARD_MSG: 10,
  PITCH: 11,
  SHIELD_DETECTOR: 12,
  LANE_KEEPING: 13
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
source: jspb.Message.getFieldWithDefault(msg, 1, 0),
speedLimit: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo;
  return proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitSource} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSpeedLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSpeedLimit();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional SpeedLimitSource source = 1;
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitSource}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.prototype.getSource = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitSource} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitSource} value
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo} returns this
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional double speed_limit = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.prototype.getSpeedLimit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo} returns this
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo.prototype.setSpeedLimit = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional SpeedLimitSource source = 1;
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitSource}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.prototype.getSource = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitSource} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitSource} value
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus} returns this
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional double speed_limit = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.prototype.getSpeedLimit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus} returns this
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.prototype.setSpeedLimit = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * repeated SpeedLimitInfo speed_limit_infos = 3;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo>}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.prototype.getSpeedLimitInfosList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo, 3));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo>} value
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus} returns this
*/
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.prototype.setSpeedLimitInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo}
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.prototype.addSpeedLimitInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.zelos.zoe.data_view.proto.SpeedLimitStatus.SpeedLimitInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.SpeedLimitStatus} returns this
 */
proto.zelos.zoe.data_view.proto.SpeedLimitStatus.prototype.clearSpeedLimitInfosList = function() {
  return this.setSpeedLimitInfosList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.SpeedPlanningStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
speedLimitStatus: (f = msg.getSpeedLimitStatus()) && proto.zelos.zoe.data_view.proto.SpeedLimitStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.SpeedPlanningStatus}
 */
proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.SpeedPlanningStatus;
  return proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.SpeedPlanningStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.SpeedPlanningStatus}
 */
proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.SpeedLimitStatus;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.SpeedLimitStatus.deserializeBinaryFromReader);
      msg.setSpeedLimitStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.SpeedPlanningStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSpeedLimitStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.SpeedLimitStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional SpeedLimitStatus speed_limit_status = 1;
 * @return {?proto.zelos.zoe.data_view.proto.SpeedLimitStatus}
 */
proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.prototype.getSpeedLimitStatus = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.SpeedLimitStatus} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.SpeedLimitStatus, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.SpeedLimitStatus|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.SpeedPlanningStatus} returns this
*/
proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.prototype.setSpeedLimitStatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.SpeedPlanningStatus} returns this
 */
proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.prototype.clearSpeedLimitStatus = function() {
  return this.setSpeedLimitStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.prototype.hasSpeedLimitStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
laneChangeCommandStatus: (f = msg.getLaneChangeCommandStatus()) && proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.toObject(includeInstance, f),
freeMoveCommandStatus: (f = msg.getFreeMoveCommandStatus()) && proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.toObject(includeInstance, f),
freeMoveFunctionVersion: jspb.Message.getFieldWithDefault(msg, 3, 0),
sessionId: jspb.Message.getFieldWithDefault(msg, 4, ""),
eventId: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.CloudAssistanceStatus;
  return proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.deserializeBinaryFromReader);
      msg.setLaneChangeCommandStatus(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.deserializeBinaryFromReader);
      msg.setFreeMoveCommandStatus(value);
      break;
    case 3:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveFunctionVersion} */ (reader.readEnum());
      msg.setFreeMoveFunctionVersion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessionId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLaneChangeCommandStatus();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.serializeBinaryToWriter
    );
  }
  f = message.getFreeMoveCommandStatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.serializeBinaryToWriter
    );
  }
  f = message.getFreeMoveFunctionVersion();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSessionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.ExecutionState = {
  EXECUTION_STATE_IDLE: 0,
  EXECUTION_STATE_REJECTED: 1,
  EXECUTION_STATE_IN_PROGRESS: 2,
  EXECUTION_STATE_SUCCEEDED: 3,
  EXECUTION_STATE_FAILED: 4,
  EXECUTION_STATE_PLANNING: 5,
  EXECUTION_STATE_READY_TO_GO: 6,
  EXECUTION_STATE_CANCELED: 7
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveFunctionVersion = {
  V0: 0,
  V3: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
state: jspb.Message.getFieldWithDefault(msg, 1, 0),
reason: jspb.Message.getFieldWithDefault(msg, 2, ""),
failReason: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus;
  return proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.ExecutionState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 3:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.LaneChangeFailReason} */ (reader.readEnum());
      msg.setFailReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFailReason();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.LaneChangeFailReason = {
  LANE_CHANGE_FAIL_REASON_UNSPECIFIED: 0,
  LANE_CHANGE_FAIL_REASON_DIRECTION_MISSING: 1,
  LANE_CHANGE_FAIL_REASON_COMMAND_STALE: 2,
  LANE_CHANGE_FAIL_REASON_TIMESTAMP_UNTRUSTED: 3,
  LANE_CHANGE_FAIL_REASON_NO_TARGET_REF_LINE: 4,
  LANE_CHANGE_FAIL_REASON_IN_JUNCTION: 5,
  LANE_CHANGE_FAIL_REASON_IN_RAMP: 6,
  LANE_CHANGE_FAIL_REASON_NOT_AUTO_MODE: 7,
  LANE_CHANGE_FAIL_REASON_ALREADY_LANE_CHANGING: 8,
  LANE_CHANGE_FAIL_REASON_TARGET_LANE_TYPE_FORBIDDEN: 9,
  LANE_CHANGE_FAIL_REASON_LANE_CHANGE_FINISHED: 10,
  LANE_CHANGE_FAIL_REASON_TIMEOUT: 11,
  LANE_CHANGE_FAIL_REASON_LANE_CHANGE_CANCELED: 12,
  LANE_CHANGE_FAIL_REASON_LANE_CHANGE_FAILED: 13,
  LANE_CHANGE_FAIL_REASON_EXIT_AUTO_MODE: 14,
  LANE_CHANGE_FAIL_REASON_OVERRIDDEN_BY_NEW_COMMAND: 15
};

/**
 * optional ExecutionState state = 1;
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.ExecutionState}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.prototype.getState = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.ExecutionState} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.ExecutionState} value
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus} returns this
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus} returns this
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional LaneChangeFailReason fail_reason = 3;
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.LaneChangeFailReason}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.prototype.getFailReason = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.LaneChangeFailReason} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.LaneChangeFailReason} value
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus} returns this
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus.prototype.setFailReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
state: jspb.Message.getFieldWithDefault(msg, 1, 0),
reason: jspb.Message.getFieldWithDefault(msg, 2, ""),
failReason: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus;
  return proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.ExecutionState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 3:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.FreeMoveFailReason} */ (reader.readEnum());
      msg.setFailReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFailReason();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional ExecutionState state = 1;
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.ExecutionState}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.prototype.getState = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.ExecutionState} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.ExecutionState} value
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus} returns this
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus} returns this
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional FreeMoveFailReason fail_reason = 3;
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveFailReason}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.prototype.getFailReason = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.FreeMoveFailReason} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveFailReason} value
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus} returns this
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus.prototype.setFailReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional LaneChangeCommandStatus lane_change_command_status = 1;
 * @return {?proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.getLaneChangeCommandStatus = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.LaneChangeCommandStatus|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus} returns this
*/
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.setLaneChangeCommandStatus = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus} returns this
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.clearLaneChangeCommandStatus = function() {
  return this.setLaneChangeCommandStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.hasLaneChangeCommandStatus = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FreeMoveCommandStatus free_move_command_status = 2;
 * @return {?proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.getFreeMoveCommandStatus = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus, 2));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveCommandStatus|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus} returns this
*/
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.setFreeMoveCommandStatus = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus} returns this
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.clearFreeMoveCommandStatus = function() {
  return this.setFreeMoveCommandStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.hasFreeMoveCommandStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional FreeMoveFunctionVersion free_move_function_version = 3;
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveFunctionVersion}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.getFreeMoveFunctionVersion = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveFunctionVersion} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.FreeMoveFunctionVersion} value
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus} returns this
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.setFreeMoveFunctionVersion = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string session_id = 4;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.getSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus} returns this
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.setSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string event_id = 5;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.CloudAssistanceStatus} returns this
 */
proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.AlarmLevelCode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.AlarmLevelCode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.toObject = function(includeInstance, msg) {
  var f, obj = {
alarmCode: jspb.Message.getFieldWithDefault(msg, 2, 0),
alarmMessage: jspb.Message.getFieldWithDefault(msg, 3, ""),
freeMoveStatus: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.AlarmLevelCode}
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.AlarmLevelCode;
  return proto.zelos.zoe.data_view.proto.AlarmLevelCode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.AlarmLevelCode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.AlarmLevelCode}
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAlarmCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlarmMessage(value);
      break;
    case 4:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.AlarmLevelCode.FreeMoveStatus} */ (reader.readEnum());
      msg.setFreeMoveStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.AlarmLevelCode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.AlarmLevelCode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAlarmCode();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getAlarmMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFreeMoveStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.FreeMoveStatus = {
  FREE_MOVE_STATUS_IDLE: 0,
  FREE_MOVE_STATUS_PLANNING: 1,
  FREE_MOVE_STATUS_READY_TO_EXECUTING: 2,
  FREE_MOVE_STATUS_EXECUTING: 3,
  FREE_MOVE_STATUS_CANCELED: 4,
  FREE_MOVE_STATUS_SUCCEEDED: 5,
  FREE_MOVE_STATUS_FAILED: 6
};

/**
 * optional int32 alarm_code = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.prototype.getAlarmCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.AlarmLevelCode} returns this
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.prototype.setAlarmCode = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string alarm_message = 3;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.prototype.getAlarmMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.AlarmLevelCode} returns this
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.prototype.setAlarmMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional FreeMoveStatus free_move_status = 4;
 * @return {!proto.zelos.zoe.data_view.proto.AlarmLevelCode.FreeMoveStatus}
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.prototype.getFreeMoveStatus = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.AlarmLevelCode.FreeMoveStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.AlarmLevelCode.FreeMoveStatus} value
 * @return {!proto.zelos.zoe.data_view.proto.AlarmLevelCode} returns this
 */
proto.zelos.zoe.data_view.proto.AlarmLevelCode.prototype.setFreeMoveStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Planning.repeatedFields_ = [1,2,3,8,9,33];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Planning.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Planning} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Planning.toObject = function(includeInstance, msg) {
  var f, obj = {
pathList: jspb.Message.toObjectList(msg.getPathList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance),
trajectoryList: jspb.Message.toObjectList(msg.getTrajectoryList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance),
parkingNodeList: jspb.Message.toObjectList(msg.getParkingNodeList(),
    proto.zelos.zoe.data_view.proto.Pose3D.toObject, includeInstance),
planningScenario: jspb.Message.getFieldWithDefault(msg, 5, ""),
openspaceGoal: (f = msg.getOpenspaceGoal()) && proto.zelos.zoe.data_view.proto.Goal.toObject(includeInstance, f),
virtualObstacleList: jspb.Message.toObjectList(msg.getVirtualObstacleList(),
    proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.toObject, includeInstance),
virtualObstaclesList: jspb.Message.toObjectList(msg.getVirtualObstaclesList(),
    proto.zelos.zoe.data_view.proto.VirtualObstacle.toObject, includeInstance),
useMainReferenceLine: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
useMotorRefId: jspb.Message.getFieldWithDefault(msg, 12, 0),
vehicleSignalCtrl: (f = msg.getVehicleSignalCtrl()) && proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.toObject(includeInstance, f),
speedPlanningStatus: (f = msg.getSpeedPlanningStatus()) && proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.toObject(includeInstance, f),
alarmLevelCodeList: jspb.Message.toObjectList(msg.getAlarmLevelCodeList(),
    proto.zelos.zoe.data_view.proto.AlarmLevelCode.toObject, includeInstance),
cloudAssistanceStatus: (f = msg.getCloudAssistanceStatus()) && proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Planning}
 */
proto.zelos.zoe.data_view.proto.Planning.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Planning;
  return proto.zelos.zoe.data_view.proto.Planning.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Planning} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Planning}
 */
proto.zelos.zoe.data_view.proto.Planning.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPath(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addTrajectory(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.Pose3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Pose3D.deserializeBinaryFromReader);
      msg.addParkingNode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanningScenario(value);
      break;
    case 6:
      var value = new proto.zelos.zoe.data_view.proto.Goal;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Goal.deserializeBinaryFromReader);
      msg.setOpenspaceGoal(value);
      break;
    case 8:
      var value = new proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.deserializeBinaryFromReader);
      msg.addVirtualObstacle(value);
      break;
    case 9:
      var value = new proto.zelos.zoe.data_view.proto.VirtualObstacle;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VirtualObstacle.deserializeBinaryFromReader);
      msg.addVirtualObstacles(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseMainReferenceLine(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUseMotorRefId(value);
      break;
    case 31:
      var value = new proto.zelos.zoe.data_view.proto.VehicleSignalCtrl;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.deserializeBinaryFromReader);
      msg.setVehicleSignalCtrl(value);
      break;
    case 32:
      var value = new proto.zelos.zoe.data_view.proto.SpeedPlanningStatus;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.deserializeBinaryFromReader);
      msg.setSpeedPlanningStatus(value);
      break;
    case 33:
      var value = new proto.zelos.zoe.data_view.proto.AlarmLevelCode;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.AlarmLevelCode.deserializeBinaryFromReader);
      msg.addAlarmLevelCode(value);
      break;
    case 34:
      var value = new proto.zelos.zoe.data_view.proto.CloudAssistanceStatus;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.deserializeBinaryFromReader);
      msg.setCloudAssistanceStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Planning.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Planning} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Planning.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPathList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getTrajectoryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getParkingNodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.Pose3D.serializeBinaryToWriter
    );
  }
  f = message.getPlanningScenario();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOpenspaceGoal();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.zelos.zoe.data_view.proto.Goal.serializeBinaryToWriter
    );
  }
  f = message.getVirtualObstacleList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle.serializeBinaryToWriter
    );
  }
  f = message.getVirtualObstaclesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.zelos.zoe.data_view.proto.VirtualObstacle.serializeBinaryToWriter
    );
  }
  f = message.getUseMainReferenceLine();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getUseMotorRefId();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getVehicleSignalCtrl();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      proto.zelos.zoe.data_view.proto.VehicleSignalCtrl.serializeBinaryToWriter
    );
  }
  f = message.getSpeedPlanningStatus();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      proto.zelos.zoe.data_view.proto.SpeedPlanningStatus.serializeBinaryToWriter
    );
  }
  f = message.getAlarmLevelCodeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      33,
      f,
      proto.zelos.zoe.data_view.proto.AlarmLevelCode.serializeBinaryToWriter
    );
  }
  f = message.getCloudAssistanceStatus();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      proto.zelos.zoe.data_view.proto.CloudAssistanceStatus.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Point3D path = 1;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getPathList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 1));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
*/
proto.zelos.zoe.data_view.proto.Planning.prototype.setPathList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.addPath = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.clearPathList = function() {
  return this.setPathList([]);
};


/**
 * repeated Point3D trajectory = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getTrajectoryList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
*/
proto.zelos.zoe.data_view.proto.Planning.prototype.setTrajectoryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.addTrajectory = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.clearTrajectoryList = function() {
  return this.setTrajectoryList([]);
};


/**
 * repeated Pose3D parking_node = 3;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Pose3D>}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getParkingNodeList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Pose3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Pose3D, 3));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Pose3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
*/
proto.zelos.zoe.data_view.proto.Planning.prototype.setParkingNodeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Pose3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Pose3D}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.addParkingNode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.zelos.zoe.data_view.proto.Pose3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.clearParkingNodeList = function() {
  return this.setParkingNodeList([]);
};


/**
 * optional string planning_scenario = 5;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getPlanningScenario = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.setPlanningScenario = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Goal openspace_goal = 6;
 * @return {?proto.zelos.zoe.data_view.proto.Goal}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getOpenspaceGoal = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Goal} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Goal, 6));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Goal|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
*/
proto.zelos.zoe.data_view.proto.Planning.prototype.setOpenspaceGoal = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.clearOpenspaceGoal = function() {
  return this.setOpenspaceGoal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.hasOpenspaceGoal = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated PlanningVirtualObstacle virtual_obstacle = 8;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle>}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getVirtualObstacleList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle, 8));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle>} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
*/
proto.zelos.zoe.data_view.proto.Planning.prototype.setVirtualObstacleList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.addVirtualObstacle = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.zelos.zoe.data_view.proto.PlanningVirtualObstacle, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.clearVirtualObstacleList = function() {
  return this.setVirtualObstacleList([]);
};


/**
 * repeated VirtualObstacle virtual_obstacles = 9;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.VirtualObstacle>}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getVirtualObstaclesList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.VirtualObstacle>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.VirtualObstacle, 9));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.VirtualObstacle>} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
*/
proto.zelos.zoe.data_view.proto.Planning.prototype.setVirtualObstaclesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.VirtualObstacle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.VirtualObstacle}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.addVirtualObstacles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.zelos.zoe.data_view.proto.VirtualObstacle, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.clearVirtualObstaclesList = function() {
  return this.setVirtualObstaclesList([]);
};


/**
 * optional bool use_main_reference_line = 10;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getUseMainReferenceLine = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.setUseMainReferenceLine = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional int32 use_motor_ref_id = 12;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getUseMotorRefId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.setUseMotorRefId = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional VehicleSignalCtrl vehicle_signal_ctrl = 31;
 * @return {?proto.zelos.zoe.data_view.proto.VehicleSignalCtrl}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getVehicleSignalCtrl = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.VehicleSignalCtrl} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.VehicleSignalCtrl, 31));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.VehicleSignalCtrl|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
*/
proto.zelos.zoe.data_view.proto.Planning.prototype.setVehicleSignalCtrl = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.clearVehicleSignalCtrl = function() {
  return this.setVehicleSignalCtrl(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.hasVehicleSignalCtrl = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional SpeedPlanningStatus speed_planning_status = 32;
 * @return {?proto.zelos.zoe.data_view.proto.SpeedPlanningStatus}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getSpeedPlanningStatus = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.SpeedPlanningStatus} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.SpeedPlanningStatus, 32));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.SpeedPlanningStatus|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
*/
proto.zelos.zoe.data_view.proto.Planning.prototype.setSpeedPlanningStatus = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.clearSpeedPlanningStatus = function() {
  return this.setSpeedPlanningStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.hasSpeedPlanningStatus = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * repeated AlarmLevelCode alarm_level_code = 33;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.AlarmLevelCode>}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getAlarmLevelCodeList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.AlarmLevelCode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.AlarmLevelCode, 33));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.AlarmLevelCode>} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
*/
proto.zelos.zoe.data_view.proto.Planning.prototype.setAlarmLevelCodeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 33, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.AlarmLevelCode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.AlarmLevelCode}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.addAlarmLevelCode = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 33, opt_value, proto.zelos.zoe.data_view.proto.AlarmLevelCode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.clearAlarmLevelCodeList = function() {
  return this.setAlarmLevelCodeList([]);
};


/**
 * optional CloudAssistanceStatus cloud_assistance_status = 34;
 * @return {?proto.zelos.zoe.data_view.proto.CloudAssistanceStatus}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.getCloudAssistanceStatus = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.CloudAssistanceStatus} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.CloudAssistanceStatus, 34));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.CloudAssistanceStatus|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
*/
proto.zelos.zoe.data_view.proto.Planning.prototype.setCloudAssistanceStatus = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Planning} returns this
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.clearCloudAssistanceStatus = function() {
  return this.setCloudAssistanceStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Planning.prototype.hasCloudAssistanceStatus = function() {
  return jspb.Message.getField(this, 34) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Vehicle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Vehicle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Vehicle.toObject = function(includeInstance, msg) {
  var f, obj = {
orientation: (f = msg.getOrientation()) && proto.zelos.zoe.data_view.proto.Point3D.toObject(includeInstance, f),
velocity: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
steerAngle: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
drivingMode: jspb.Message.getFieldWithDefault(msg, 4, 0),
gearPosition: jspb.Message.getFieldWithDefault(msg, 5, 0),
acceleration: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
turnSignalState: jspb.Message.getFieldWithDefault(msg, 7, 0),
battery: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
emerStopReason: jspb.Message.getFieldWithDefault(msg, 11, ""),
brakeLampOn: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
backLampOn: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
shieldDrivingMode: jspb.Message.getFieldWithDefault(msg, 14, 0),
velocityInt: jspb.Message.getFieldWithDefault(msg, 15, 0),
steerAngleInt: jspb.Message.getFieldWithDefault(msg, 16, 0),
accelerationInt: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle}
 */
proto.zelos.zoe.data_view.proto.Vehicle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Vehicle;
  return proto.zelos.zoe.data_view.proto.Vehicle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Vehicle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle}
 */
proto.zelos.zoe.data_view.proto.Vehicle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.setOrientation(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVelocity(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSteerAngle(value);
      break;
    case 4:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Vehicle.DrivingMode} */ (reader.readEnum());
      msg.setDrivingMode(value);
      break;
    case 5:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Vehicle.GearPosition} */ (reader.readEnum());
      msg.setGearPosition(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAcceleration(value);
      break;
    case 7:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Vehicle.TurnSignalState} */ (reader.readEnum());
      msg.setTurnSignalState(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBattery(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmerStopReason(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBrakeLampOn(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBackLampOn(value);
      break;
    case 14:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Vehicle.ShieldDrivingMode} */ (reader.readEnum());
      msg.setShieldDrivingMode(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVelocityInt(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSteerAngleInt(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAccelerationInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Vehicle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Vehicle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Vehicle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrientation();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getVelocity();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getSteerAngle();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getDrivingMode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getGearPosition();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getAcceleration();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getTurnSignalState();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getBattery();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = message.getEmerStopReason();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getBrakeLampOn();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getBackLampOn();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getShieldDrivingMode();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getVelocityInt();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getSteerAngleInt();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getAccelerationInt();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Vehicle.DrivingMode = {
  UNKNOWN: 0,
  INIT: 1,
  AUTO_CTRL: 2,
  VANGUARD_CTRL: 3,
  VANGUARD_NORMAL: 4,
  REMOTE_CTRL: 5,
  VANGUARD_EMERGENCY: 6,
  VANGUARD_FORBID_DRIVING: 7,
  REMOTE_SUPER_CTRL: 8,
  JOYSTICK_CTRL: 9,
  CHASSIS_STANDBY: 10,
  CHASSIS_CTRL: 11,
  CHASSIS_BUMPER: 12,
  CHASSIS_FAULT: 13,
  EMERGENCY_STOP: 14,
  CHASSIS_HIBERNATE: 15
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Vehicle.GearPosition = {
  OTHER: 0,
  NEUTRAL: 1,
  DRIVE: 2,
  REVERSE: 3,
  PARKING: 4,
  LOW: 5,
  INVALID: 6,
  NONE: 7,
  SPORT: 8
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Vehicle.TurnSignalState = {
  OFF: 0,
  LEFT: 1,
  RIGHT: 2,
  BOTH: 3
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Vehicle.ShieldDrivingMode = {
  SHIELD_UNKNOWN: 0,
  SHIELD_ESTOP: 1
};

/**
 * optional Point3D orientation = 1;
 * @return {?proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getOrientation = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Point3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Point3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
*/
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setOrientation = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.clearOrientation = function() {
  return this.setOrientation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.hasOrientation = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double velocity = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getVelocity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setVelocity = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double steer_angle = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getSteerAngle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setSteerAngle = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional DrivingMode driving_mode = 4;
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle.DrivingMode}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getDrivingMode = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Vehicle.DrivingMode} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Vehicle.DrivingMode} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setDrivingMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional GearPosition gear_position = 5;
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle.GearPosition}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getGearPosition = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Vehicle.GearPosition} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Vehicle.GearPosition} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setGearPosition = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional double acceleration = 6;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getAcceleration = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setAcceleration = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional TurnSignalState turn_signal_state = 7;
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle.TurnSignalState}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getTurnSignalState = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Vehicle.TurnSignalState} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Vehicle.TurnSignalState} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setTurnSignalState = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional float battery = 9;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getBattery = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setBattery = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional string emer_stop_reason = 11;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getEmerStopReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setEmerStopReason = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool brake_lamp_on = 12;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getBrakeLampOn = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setBrakeLampOn = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool back_lamp_on = 13;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getBackLampOn = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setBackLampOn = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional ShieldDrivingMode shield_driving_mode = 14;
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle.ShieldDrivingMode}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getShieldDrivingMode = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Vehicle.ShieldDrivingMode} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Vehicle.ShieldDrivingMode} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setShieldDrivingMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional int32 velocity_int = 15;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getVelocityInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setVelocityInt = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 steer_angle_int = 16;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getSteerAngleInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setSteerAngleInt = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 acceleration_int = 17;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.getAccelerationInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.Vehicle} returns this
 */
proto.zelos.zoe.data_view.proto.Vehicle.prototype.setAccelerationInt = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.AuthorizeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.AuthorizeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
vehicleId: jspb.Message.getFieldWithDefault(msg, 1, ""),
vehicleSn: jspb.Message.getFieldWithDefault(msg, 2, ""),
apiKey: jspb.Message.getFieldWithDefault(msg, 3, ""),
businessId: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.AuthorizeInfo}
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.AuthorizeInfo;
  return proto.zelos.zoe.data_view.proto.AuthorizeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.AuthorizeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.AuthorizeInfo}
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVehicleSn(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setApiKey(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBusinessId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.AuthorizeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.AuthorizeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVehicleSn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getApiKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBusinessId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string vehicle_id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.prototype.getVehicleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.AuthorizeInfo} returns this
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.prototype.setVehicleId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string vehicle_sn = 2;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.prototype.getVehicleSn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.AuthorizeInfo} returns this
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.prototype.setVehicleSn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string api_key = 3;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.prototype.getApiKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.AuthorizeInfo} returns this
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.prototype.setApiKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 business_id = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.prototype.getBusinessId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.AuthorizeInfo} returns this
 */
proto.zelos.zoe.data_view.proto.AuthorizeInfo.prototype.setBusinessId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.UserAuthroizeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
userSn: jspb.Message.getFieldWithDefault(msg, 2, ""),
userKey: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.UserAuthroizeInfo}
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.UserAuthroizeInfo;
  return proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.UserAuthroizeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.UserAuthroizeInfo}
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserSn(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.UserAuthroizeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserSn();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.UserAuthroizeInfo} returns this
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_sn = 2;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.prototype.getUserSn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.UserAuthroizeInfo} returns this
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.prototype.setUserSn = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_key = 3;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.prototype.getUserKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.UserAuthroizeInfo} returns this
 */
proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.prototype.setUserKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.zelos.zoe.data_view.proto.VerificationData.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.VerificationData.VerifcationInfoCase = {
  VERIFCATION_INFO_NOT_SET: 0,
  VEHICLE_AUTHORIZE_INFO: 1,
  USER_AUTORIZE_INFO: 2
};

/**
 * @return {proto.zelos.zoe.data_view.proto.VerificationData.VerifcationInfoCase}
 */
proto.zelos.zoe.data_view.proto.VerificationData.prototype.getVerifcationInfoCase = function() {
  return /** @type {proto.zelos.zoe.data_view.proto.VerificationData.VerifcationInfoCase} */(jspb.Message.computeOneofCase(this, proto.zelos.zoe.data_view.proto.VerificationData.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.VerificationData.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.VerificationData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.VerificationData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VerificationData.toObject = function(includeInstance, msg) {
  var f, obj = {
vehicleAuthorizeInfo: (f = msg.getVehicleAuthorizeInfo()) && proto.zelos.zoe.data_view.proto.AuthorizeInfo.toObject(includeInstance, f),
userAutorizeInfo: (f = msg.getUserAutorizeInfo()) && proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.VerificationData}
 */
proto.zelos.zoe.data_view.proto.VerificationData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.VerificationData;
  return proto.zelos.zoe.data_view.proto.VerificationData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.VerificationData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.VerificationData}
 */
proto.zelos.zoe.data_view.proto.VerificationData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.AuthorizeInfo;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.AuthorizeInfo.deserializeBinaryFromReader);
      msg.setVehicleAuthorizeInfo(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.UserAuthroizeInfo;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.deserializeBinaryFromReader);
      msg.setUserAutorizeInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.VerificationData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.VerificationData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.VerificationData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VerificationData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleAuthorizeInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.AuthorizeInfo.serializeBinaryToWriter
    );
  }
  f = message.getUserAutorizeInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.UserAuthroizeInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional AuthorizeInfo vehicle_authorize_info = 1;
 * @return {?proto.zelos.zoe.data_view.proto.AuthorizeInfo}
 */
proto.zelos.zoe.data_view.proto.VerificationData.prototype.getVehicleAuthorizeInfo = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.AuthorizeInfo} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.AuthorizeInfo, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.AuthorizeInfo|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VerificationData} returns this
*/
proto.zelos.zoe.data_view.proto.VerificationData.prototype.setVehicleAuthorizeInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.zelos.zoe.data_view.proto.VerificationData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VerificationData} returns this
 */
proto.zelos.zoe.data_view.proto.VerificationData.prototype.clearVehicleAuthorizeInfo = function() {
  return this.setVehicleAuthorizeInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VerificationData.prototype.hasVehicleAuthorizeInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UserAuthroizeInfo user_autorize_info = 2;
 * @return {?proto.zelos.zoe.data_view.proto.UserAuthroizeInfo}
 */
proto.zelos.zoe.data_view.proto.VerificationData.prototype.getUserAutorizeInfo = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.UserAuthroizeInfo} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.UserAuthroizeInfo, 2));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.UserAuthroizeInfo|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VerificationData} returns this
*/
proto.zelos.zoe.data_view.proto.VerificationData.prototype.setUserAutorizeInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.zelos.zoe.data_view.proto.VerificationData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VerificationData} returns this
 */
proto.zelos.zoe.data_view.proto.VerificationData.prototype.clearUserAutorizeInfo = function() {
  return this.setUserAutorizeInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VerificationData.prototype.hasUserAutorizeInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.ConnectionData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.ConnectionData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ConnectionData.toObject = function(includeInstance, msg) {
  var f, obj = {
verificationData: (f = msg.getVerificationData()) && proto.zelos.zoe.data_view.proto.VerificationData.toObject(includeInstance, f),
version: jspb.Message.getFieldWithDefault(msg, 2, ""),
profile: jspb.Message.getFieldWithDefault(msg, 3, ""),
sessionType: jspb.Message.getFieldWithDefault(msg, 4, 0),
messageFormat: jspb.Message.getFieldWithDefault(msg, 5, 0),
recordUri: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.ConnectionData}
 */
proto.zelos.zoe.data_view.proto.ConnectionData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.ConnectionData;
  return proto.zelos.zoe.data_view.proto.ConnectionData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.ConnectionData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.ConnectionData}
 */
proto.zelos.zoe.data_view.proto.ConnectionData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.VerificationData;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VerificationData.deserializeBinaryFromReader);
      msg.setVerificationData(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setProfile(value);
      break;
    case 4:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.SessionType} */ (reader.readEnum());
      msg.setSessionType(value);
      break;
    case 5:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.MessageFormat} */ (reader.readEnum());
      msg.setMessageFormat(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRecordUri(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.ConnectionData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.ConnectionData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ConnectionData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerificationData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.VerificationData.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getProfile();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSessionType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getMessageFormat();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getRecordUri();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional VerificationData verification_data = 1;
 * @return {?proto.zelos.zoe.data_view.proto.VerificationData}
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.getVerificationData = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.VerificationData} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.VerificationData, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.VerificationData|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.ConnectionData} returns this
*/
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.setVerificationData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.ConnectionData} returns this
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.clearVerificationData = function() {
  return this.setVerificationData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.hasVerificationData = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string version = 2;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.ConnectionData} returns this
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.setVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string profile = 3;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.getProfile = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.ConnectionData} returns this
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.setProfile = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional SessionType session_type = 4;
 * @return {!proto.zelos.zoe.data_view.proto.SessionType}
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.getSessionType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.SessionType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.SessionType} value
 * @return {!proto.zelos.zoe.data_view.proto.ConnectionData} returns this
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.setSessionType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional MessageFormat message_format = 5;
 * @return {!proto.zelos.zoe.data_view.proto.MessageFormat}
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.getMessageFormat = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.MessageFormat} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.MessageFormat} value
 * @return {!proto.zelos.zoe.data_view.proto.ConnectionData} returns this
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.setMessageFormat = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string record_uri = 6;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.getRecordUri = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.ConnectionData} returns this
 */
proto.zelos.zoe.data_view.proto.ConnectionData.prototype.setRecordUri = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.VehicleParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.VehicleParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleParam.toObject = function(includeInstance, msg) {
  var f, obj = {
length: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
width: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
height: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
frontEdgeToCenter: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
backEdgeToCenter: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
leftEdgeToCenter: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
rightEdgeToCenter: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
topEdgeToCenter: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
bottomEdgeToCenter: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
wheelBase: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
maxSteerAngle: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
minSteerAngle: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.VehicleParam;
  return proto.zelos.zoe.data_view.proto.VehicleParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLength(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setWidth(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeight(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFrontEdgeToCenter(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBackEdgeToCenter(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLeftEdgeToCenter(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRightEdgeToCenter(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTopEdgeToCenter(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setBottomEdgeToCenter(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setWheelBase(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMaxSteerAngle(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMinSteerAngle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.VehicleParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLength();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getFrontEdgeToCenter();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getBackEdgeToCenter();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getLeftEdgeToCenter();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getRightEdgeToCenter();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getTopEdgeToCenter();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = message.getBottomEdgeToCenter();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = message.getWheelBase();
  if (f !== 0.0) {
    writer.writeFloat(
      10,
      f
    );
  }
  f = message.getMaxSteerAngle();
  if (f !== 0.0) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = message.getMinSteerAngle();
  if (f !== 0.0) {
    writer.writeFloat(
      12,
      f
    );
  }
};


/**
 * optional float length = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.getLength = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.setLength = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float width = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.setWidth = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float height = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.setHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float front_edge_to_center = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.getFrontEdgeToCenter = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.setFrontEdgeToCenter = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float back_edge_to_center = 5;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.getBackEdgeToCenter = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.setBackEdgeToCenter = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float left_edge_to_center = 6;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.getLeftEdgeToCenter = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.setLeftEdgeToCenter = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional float right_edge_to_center = 7;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.getRightEdgeToCenter = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.setRightEdgeToCenter = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional float top_edge_to_center = 8;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.getTopEdgeToCenter = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.setTopEdgeToCenter = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional float bottom_edge_to_center = 9;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.getBottomEdgeToCenter = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.setBottomEdgeToCenter = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional float wheel_base = 10;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.getWheelBase = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.setWheelBase = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional float max_steer_angle = 11;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.getMaxSteerAngle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.setMaxSteerAngle = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional float min_steer_angle = 12;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.getMinSteerAngle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleParam} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleParam.prototype.setMinSteerAngle = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.CameraCalibration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.CameraCalibration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.toObject = function(includeInstance, msg) {
  var f, obj = {
frame: jspb.Message.getFieldWithDefault(msg, 1, ""),
intrinsicList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 2)) == null ? undefined : f,
distortionList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.CameraCalibration}
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.CameraCalibration;
  return proto.zelos.zoe.data_view.proto.CameraCalibration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.CameraCalibration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.CameraCalibration}
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrame(value);
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedDouble() : [reader.readDouble()]);
      for (var i = 0; i < values.length; i++) {
        msg.addIntrinsic(values[i]);
      }
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedDouble() : [reader.readDouble()]);
      for (var i = 0; i < values.length; i++) {
        msg.addDistortion(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.CameraCalibration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.CameraCalibration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrame();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntrinsicList();
  if (f.length > 0) {
    writer.writePackedDouble(
      2,
      f
    );
  }
  f = message.getDistortionList();
  if (f.length > 0) {
    writer.writePackedDouble(
      3,
      f
    );
  }
};


/**
 * optional string frame = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.prototype.getFrame = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.CameraCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.prototype.setFrame = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated double intrinsic = 2;
 * @return {!Array<number>}
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.prototype.getIntrinsicList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.zelos.zoe.data_view.proto.CameraCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.prototype.setIntrinsicList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.CameraCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.prototype.addIntrinsic = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.CameraCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.prototype.clearIntrinsicList = function() {
  return this.setIntrinsicList([]);
};


/**
 * repeated double distortion = 3;
 * @return {!Array<number>}
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.prototype.getDistortionList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.zelos.zoe.data_view.proto.CameraCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.prototype.setDistortionList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.CameraCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.prototype.addDistortion = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.CameraCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.CameraCalibration.prototype.clearDistortionList = function() {
  return this.setDistortionList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.SensorCalibration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.SensorCalibration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.toObject = function(includeInstance, msg) {
  var f, obj = {
source: jspb.Message.getFieldWithDefault(msg, 1, ""),
target: jspb.Message.getFieldWithDefault(msg, 2, ""),
transformationList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.SensorCalibration}
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.SensorCalibration;
  return proto.zelos.zoe.data_view.proto.SensorCalibration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.SensorCalibration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.SensorCalibration}
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTarget(value);
      break;
    case 3:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedDouble() : [reader.readDouble()]);
      for (var i = 0; i < values.length; i++) {
        msg.addTransformation(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.SensorCalibration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.SensorCalibration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTarget();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTransformationList();
  if (f.length > 0) {
    writer.writePackedDouble(
      3,
      f
    );
  }
};


/**
 * optional string source = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.SensorCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string target = 2;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.prototype.getTarget = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.SensorCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.prototype.setTarget = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated double transformation = 3;
 * @return {!Array<number>}
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.prototype.getTransformationList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 3));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.zelos.zoe.data_view.proto.SensorCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.prototype.setTransformationList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.SensorCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.prototype.addTransformation = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.SensorCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.SensorCalibration.prototype.clearTransformationList = function() {
  return this.setTransformationList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.VehicleCalibration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.VehicleCalibration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.toObject = function(includeInstance, msg) {
  var f, obj = {
effectiveFrameList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
cameraCalibrationList: jspb.Message.toObjectList(msg.getCameraCalibrationList(),
    proto.zelos.zoe.data_view.proto.CameraCalibration.toObject, includeInstance),
sensorCalibrationList: jspb.Message.toObjectList(msg.getSensorCalibrationList(),
    proto.zelos.zoe.data_view.proto.SensorCalibration.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleCalibration}
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.VehicleCalibration;
  return proto.zelos.zoe.data_view.proto.VehicleCalibration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleCalibration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleCalibration}
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addEffectiveFrame(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.CameraCalibration;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.CameraCalibration.deserializeBinaryFromReader);
      msg.addCameraCalibration(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.SensorCalibration;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.SensorCalibration.deserializeBinaryFromReader);
      msg.addSensorCalibration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.VehicleCalibration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleCalibration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEffectiveFrameList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getCameraCalibrationList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.CameraCalibration.serializeBinaryToWriter
    );
  }
  f = message.getSensorCalibrationList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.SensorCalibration.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string effective_frame = 1;
 * @return {!Array<string>}
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.getEffectiveFrameList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.setEffectiveFrameList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.VehicleCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.addEffectiveFrame = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.clearEffectiveFrameList = function() {
  return this.setEffectiveFrameList([]);
};


/**
 * repeated CameraCalibration camera_calibration = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.CameraCalibration>}
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.getCameraCalibrationList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.CameraCalibration>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.CameraCalibration, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.CameraCalibration>} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleCalibration} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.setCameraCalibrationList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.CameraCalibration=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.CameraCalibration}
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.addCameraCalibration = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.CameraCalibration, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.clearCameraCalibrationList = function() {
  return this.setCameraCalibrationList([]);
};


/**
 * repeated SensorCalibration sensor_calibration = 3;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.SensorCalibration>}
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.getSensorCalibrationList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.SensorCalibration>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.SensorCalibration, 3));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.SensorCalibration>} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleCalibration} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.setSensorCalibrationList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.SensorCalibration=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.SensorCalibration}
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.addSensorCalibration = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.zelos.zoe.data_view.proto.SensorCalibration, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleCalibration} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleCalibration.prototype.clearSensorCalibrationList = function() {
  return this.setSensorCalibrationList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.ResponseData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.ResponseData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ResponseData.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
responseCode: jspb.Message.getFieldWithDefault(msg, 2, 0),
responseContent: jspb.Message.getFieldWithDefault(msg, 3, ""),
responseTimestamp: jspb.Message.getFieldWithDefault(msg, 4, 0),
mapData: (f = msg.getMapData()) && proto.zelos.zoe.data_view.proto.MapData.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.ResponseData}
 */
proto.zelos.zoe.data_view.proto.ResponseData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.ResponseData;
  return proto.zelos.zoe.data_view.proto.ResponseData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.ResponseData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.ResponseData}
 */
proto.zelos.zoe.data_view.proto.ResponseData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setResponseCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponseContent(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setResponseTimestamp(value);
      break;
    case 5:
      var value = new proto.zelos.zoe.data_view.proto.MapData;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.MapData.deserializeBinaryFromReader);
      msg.setMapData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.ResponseData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.ResponseData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ResponseData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResponseCode();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getResponseContent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getResponseTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getMapData();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.zelos.zoe.data_view.proto.MapData.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.ResponseData} returns this
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 response_code = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.getResponseCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.ResponseData} returns this
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.setResponseCode = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string response_content = 3;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.getResponseContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.ResponseData} returns this
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.setResponseContent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 response_timestamp = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.getResponseTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.ResponseData} returns this
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.setResponseTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional MapData map_data = 5;
 * @return {?proto.zelos.zoe.data_view.proto.MapData}
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.getMapData = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.MapData} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.MapData, 5));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.MapData|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.ResponseData} returns this
*/
proto.zelos.zoe.data_view.proto.ResponseData.prototype.setMapData = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.ResponseData} returns this
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.clearMapData = function() {
  return this.setMapData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.ResponseData.prototype.hasMapData = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.ShapeInfo.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.ShapeInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.ShapeInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.ShapeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ShapeInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.ShapeInfo}
 */
proto.zelos.zoe.data_view.proto.ShapeInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.ShapeInfo;
  return proto.zelos.zoe.data_view.proto.ShapeInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.ShapeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.ShapeInfo}
 */
proto.zelos.zoe.data_view.proto.ShapeInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.ShapeInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.ShapeInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.ShapeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ShapeInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.ShapeInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.ShapeInfo} returns this
 */
proto.zelos.zoe.data_view.proto.ShapeInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Point3D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.ShapeInfo.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.ShapeInfo} returns this
*/
proto.zelos.zoe.data_view.proto.ShapeInfo.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.ShapeInfo.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.ShapeInfo} returns this
 */
proto.zelos.zoe.data_view.proto.ShapeInfo.prototype.clearPointList = function() {
  return this.setPointList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.MapVersionMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.MapVersionMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
offsetX: jspb.Message.getFieldWithDefault(msg, 1, "0"),
offsetY: jspb.Message.getFieldWithDefault(msg, 2, "0"),
utmZone: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.MapVersionMeta}
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.MapVersionMeta;
  return proto.zelos.zoe.data_view.proto.MapVersionMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.MapVersionMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.MapVersionMeta}
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOffsetX(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setOffsetY(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUtmZone(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.MapVersionMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.MapVersionMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffsetX();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getOffsetY();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getUtmZone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint64 offset_x = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta.prototype.getOffsetX = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.MapVersionMeta} returns this
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta.prototype.setOffsetX = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 offset_y = 2;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta.prototype.getOffsetY = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.MapVersionMeta} returns this
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta.prototype.setOffsetY = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string utm_zone = 3;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta.prototype.getUtmZone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.MapVersionMeta} returns this
 */
proto.zelos.zoe.data_view.proto.MapVersionMeta.prototype.setUtmZone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.MapData.repeatedFields_ = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,19];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.MapData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.MapData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MapData.toObject = function(includeInstance, msg) {
  var f, obj = {
stopLineList: jspb.Message.toObjectList(msg.getStopLineList(),
    proto.zelos.zoe.data_view.proto.StopLine.toObject, includeInstance),
boundaryList: jspb.Message.toObjectList(msg.getBoundaryList(),
    proto.zelos.zoe.data_view.proto.Boundary.toObject, includeInstance),
laneList: jspb.Message.toObjectList(msg.getLaneList(),
    proto.zelos.zoe.data_view.proto.Lane.toObject, includeInstance),
clearZoneList: jspb.Message.toObjectList(msg.getClearZoneList(),
    proto.zelos.zoe.data_view.proto.ClearZone.toObject, includeInstance),
crossWalkList: jspb.Message.toObjectList(msg.getCrossWalkList(),
    proto.zelos.zoe.data_view.proto.CrossWalk.toObject, includeInstance),
freeAreaList: jspb.Message.toObjectList(msg.getFreeAreaList(),
    proto.zelos.zoe.data_view.proto.FreeArea.toObject, includeInstance),
gateList: jspb.Message.toObjectList(msg.getGateList(),
    proto.zelos.zoe.data_view.proto.Gate.toObject, includeInstance),
intersectionList: jspb.Message.toObjectList(msg.getIntersectionList(),
    proto.zelos.zoe.data_view.proto.Intersection.toObject, includeInstance),
parkingList: jspb.Message.toObjectList(msg.getParkingList(),
    proto.zelos.zoe.data_view.proto.Parking.toObject, includeInstance),
pillarList: jspb.Message.toObjectList(msg.getPillarList(),
    proto.zelos.zoe.data_view.proto.Pillar.toObject, includeInstance),
prohibitedAreaList: jspb.Message.toObjectList(msg.getProhibitedAreaList(),
    proto.zelos.zoe.data_view.proto.ProhibitedArea.toObject, includeInstance),
safetyIslandList: jspb.Message.toObjectList(msg.getSafetyIslandList(),
    proto.zelos.zoe.data_view.proto.SafetyIsland.toObject, includeInstance),
speedBumpList: jspb.Message.toObjectList(msg.getSpeedBumpList(),
    proto.zelos.zoe.data_view.proto.SpeedBump.toObject, includeInstance),
trafficLightList: jspb.Message.toObjectList(msg.getTrafficLightList(),
    proto.zelos.zoe.data_view.proto.TrafficLight.toObject, includeInstance),
mapId: jspb.Message.getFieldWithDefault(msg, 15, 0),
mapVersion: jspb.Message.getFieldWithDefault(msg, 16, 0),
geoMapType: jspb.Message.getFieldWithDefault(msg, 18, 0),
multiLayerAreaList: jspb.Message.toObjectList(msg.getMultiLayerAreaList(),
    proto.zelos.zoe.data_view.proto.ShapeInfo.toObject, includeInstance),
mapVersionMeta: (f = msg.getMapVersionMeta()) && proto.zelos.zoe.data_view.proto.MapVersionMeta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.MapData}
 */
proto.zelos.zoe.data_view.proto.MapData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.MapData;
  return proto.zelos.zoe.data_view.proto.MapData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.MapData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.MapData}
 */
proto.zelos.zoe.data_view.proto.MapData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.StopLine;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.StopLine.deserializeBinaryFromReader);
      msg.addStopLine(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Boundary;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Boundary.deserializeBinaryFromReader);
      msg.addBoundary(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.Lane;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Lane.deserializeBinaryFromReader);
      msg.addLane(value);
      break;
    case 4:
      var value = new proto.zelos.zoe.data_view.proto.ClearZone;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.ClearZone.deserializeBinaryFromReader);
      msg.addClearZone(value);
      break;
    case 5:
      var value = new proto.zelos.zoe.data_view.proto.CrossWalk;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.CrossWalk.deserializeBinaryFromReader);
      msg.addCrossWalk(value);
      break;
    case 6:
      var value = new proto.zelos.zoe.data_view.proto.FreeArea;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.FreeArea.deserializeBinaryFromReader);
      msg.addFreeArea(value);
      break;
    case 7:
      var value = new proto.zelos.zoe.data_view.proto.Gate;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Gate.deserializeBinaryFromReader);
      msg.addGate(value);
      break;
    case 8:
      var value = new proto.zelos.zoe.data_view.proto.Intersection;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Intersection.deserializeBinaryFromReader);
      msg.addIntersection(value);
      break;
    case 9:
      var value = new proto.zelos.zoe.data_view.proto.Parking;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Parking.deserializeBinaryFromReader);
      msg.addParking(value);
      break;
    case 10:
      var value = new proto.zelos.zoe.data_view.proto.Pillar;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Pillar.deserializeBinaryFromReader);
      msg.addPillar(value);
      break;
    case 11:
      var value = new proto.zelos.zoe.data_view.proto.ProhibitedArea;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.ProhibitedArea.deserializeBinaryFromReader);
      msg.addProhibitedArea(value);
      break;
    case 12:
      var value = new proto.zelos.zoe.data_view.proto.SafetyIsland;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.SafetyIsland.deserializeBinaryFromReader);
      msg.addSafetyIsland(value);
      break;
    case 13:
      var value = new proto.zelos.zoe.data_view.proto.SpeedBump;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.SpeedBump.deserializeBinaryFromReader);
      msg.addSpeedBump(value);
      break;
    case 14:
      var value = new proto.zelos.zoe.data_view.proto.TrafficLight;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.TrafficLight.deserializeBinaryFromReader);
      msg.addTrafficLight(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapId(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMapVersion(value);
      break;
    case 18:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.MapData.GeoMapType} */ (reader.readEnum());
      msg.setGeoMapType(value);
      break;
    case 19:
      var value = new proto.zelos.zoe.data_view.proto.ShapeInfo;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.ShapeInfo.deserializeBinaryFromReader);
      msg.addMultiLayerArea(value);
      break;
    case 20:
      var value = new proto.zelos.zoe.data_view.proto.MapVersionMeta;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.MapVersionMeta.deserializeBinaryFromReader);
      msg.setMapVersionMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.MapData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.MapData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MapData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStopLineList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.StopLine.serializeBinaryToWriter
    );
  }
  f = message.getBoundaryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Boundary.serializeBinaryToWriter
    );
  }
  f = message.getLaneList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.Lane.serializeBinaryToWriter
    );
  }
  f = message.getClearZoneList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.zelos.zoe.data_view.proto.ClearZone.serializeBinaryToWriter
    );
  }
  f = message.getCrossWalkList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.zelos.zoe.data_view.proto.CrossWalk.serializeBinaryToWriter
    );
  }
  f = message.getFreeAreaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.zelos.zoe.data_view.proto.FreeArea.serializeBinaryToWriter
    );
  }
  f = message.getGateList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.zelos.zoe.data_view.proto.Gate.serializeBinaryToWriter
    );
  }
  f = message.getIntersectionList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.zelos.zoe.data_view.proto.Intersection.serializeBinaryToWriter
    );
  }
  f = message.getParkingList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.zelos.zoe.data_view.proto.Parking.serializeBinaryToWriter
    );
  }
  f = message.getPillarList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.zelos.zoe.data_view.proto.Pillar.serializeBinaryToWriter
    );
  }
  f = message.getProhibitedAreaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.zelos.zoe.data_view.proto.ProhibitedArea.serializeBinaryToWriter
    );
  }
  f = message.getSafetyIslandList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.zelos.zoe.data_view.proto.SafetyIsland.serializeBinaryToWriter
    );
  }
  f = message.getSpeedBumpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.zelos.zoe.data_view.proto.SpeedBump.serializeBinaryToWriter
    );
  }
  f = message.getTrafficLightList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.zelos.zoe.data_view.proto.TrafficLight.serializeBinaryToWriter
    );
  }
  f = message.getMapId();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getMapVersion();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getGeoMapType();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getMultiLayerAreaList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      19,
      f,
      proto.zelos.zoe.data_view.proto.ShapeInfo.serializeBinaryToWriter
    );
  }
  f = message.getMapVersionMeta();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.zelos.zoe.data_view.proto.MapVersionMeta.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.MapData.GeoMapType = {
  GEO_GLOBAL_MAP: 0,
  GEO_LOCAL_MAP: 1
};

/**
 * repeated StopLine stop_line = 1;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.StopLine>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getStopLineList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.StopLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.StopLine, 1));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.StopLine>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setStopLineList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.StopLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.StopLine}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addStopLine = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.zelos.zoe.data_view.proto.StopLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearStopLineList = function() {
  return this.setStopLineList([]);
};


/**
 * repeated Boundary boundary = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Boundary>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getBoundaryList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Boundary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Boundary, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Boundary>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setBoundaryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Boundary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Boundary}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addBoundary = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Boundary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearBoundaryList = function() {
  return this.setBoundaryList([]);
};


/**
 * repeated Lane lane = 3;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Lane>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getLaneList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Lane>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Lane, 3));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Lane>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setLaneList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Lane=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Lane}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addLane = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.zelos.zoe.data_view.proto.Lane, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearLaneList = function() {
  return this.setLaneList([]);
};


/**
 * repeated ClearZone clear_zone = 4;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.ClearZone>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getClearZoneList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.ClearZone>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.ClearZone, 4));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.ClearZone>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setClearZoneList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.ClearZone=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.ClearZone}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addClearZone = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.zelos.zoe.data_view.proto.ClearZone, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearClearZoneList = function() {
  return this.setClearZoneList([]);
};


/**
 * repeated CrossWalk cross_walk = 5;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.CrossWalk>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getCrossWalkList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.CrossWalk>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.CrossWalk, 5));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.CrossWalk>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setCrossWalkList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.CrossWalk=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.CrossWalk}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addCrossWalk = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.zelos.zoe.data_view.proto.CrossWalk, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearCrossWalkList = function() {
  return this.setCrossWalkList([]);
};


/**
 * repeated FreeArea free_area = 6;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.FreeArea>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getFreeAreaList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.FreeArea>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.FreeArea, 6));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.FreeArea>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setFreeAreaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.FreeArea=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.FreeArea}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addFreeArea = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.zelos.zoe.data_view.proto.FreeArea, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearFreeAreaList = function() {
  return this.setFreeAreaList([]);
};


/**
 * repeated Gate gate = 7;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Gate>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getGateList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Gate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Gate, 7));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Gate>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setGateList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Gate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Gate}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addGate = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.zelos.zoe.data_view.proto.Gate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearGateList = function() {
  return this.setGateList([]);
};


/**
 * repeated Intersection intersection = 8;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Intersection>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getIntersectionList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Intersection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Intersection, 8));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Intersection>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setIntersectionList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Intersection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Intersection}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addIntersection = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.zelos.zoe.data_view.proto.Intersection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearIntersectionList = function() {
  return this.setIntersectionList([]);
};


/**
 * repeated Parking parking = 9;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Parking>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getParkingList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Parking>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Parking, 9));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Parking>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setParkingList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Parking=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Parking}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addParking = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.zelos.zoe.data_view.proto.Parking, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearParkingList = function() {
  return this.setParkingList([]);
};


/**
 * repeated Pillar pillar = 10;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Pillar>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getPillarList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Pillar>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Pillar, 10));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Pillar>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setPillarList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Pillar=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Pillar}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addPillar = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.zelos.zoe.data_view.proto.Pillar, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearPillarList = function() {
  return this.setPillarList([]);
};


/**
 * repeated ProhibitedArea prohibited_area = 11;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.ProhibitedArea>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getProhibitedAreaList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.ProhibitedArea>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.ProhibitedArea, 11));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.ProhibitedArea>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setProhibitedAreaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.ProhibitedArea=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.ProhibitedArea}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addProhibitedArea = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.zelos.zoe.data_view.proto.ProhibitedArea, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearProhibitedAreaList = function() {
  return this.setProhibitedAreaList([]);
};


/**
 * repeated SafetyIsland safety_island = 12;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.SafetyIsland>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getSafetyIslandList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.SafetyIsland>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.SafetyIsland, 12));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.SafetyIsland>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setSafetyIslandList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.SafetyIsland=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.SafetyIsland}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addSafetyIsland = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.zelos.zoe.data_view.proto.SafetyIsland, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearSafetyIslandList = function() {
  return this.setSafetyIslandList([]);
};


/**
 * repeated SpeedBump speed_bump = 13;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.SpeedBump>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getSpeedBumpList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.SpeedBump>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.SpeedBump, 13));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.SpeedBump>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setSpeedBumpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.SpeedBump=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.SpeedBump}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addSpeedBump = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.zelos.zoe.data_view.proto.SpeedBump, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearSpeedBumpList = function() {
  return this.setSpeedBumpList([]);
};


/**
 * repeated TrafficLight traffic_light = 14;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.TrafficLight>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getTrafficLightList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.TrafficLight>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.TrafficLight, 14));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.TrafficLight>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setTrafficLightList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.TrafficLight=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addTrafficLight = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.zelos.zoe.data_view.proto.TrafficLight, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearTrafficLightList = function() {
  return this.setTrafficLightList([]);
};


/**
 * optional int32 map_id = 15;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getMapId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.setMapId = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int32 map_version = 16;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getMapVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.setMapVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional GeoMapType geo_map_type = 18;
 * @return {!proto.zelos.zoe.data_view.proto.MapData.GeoMapType}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getGeoMapType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.MapData.GeoMapType} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.MapData.GeoMapType} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.setGeoMapType = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * repeated ShapeInfo multi_layer_area = 19;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.ShapeInfo>}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getMultiLayerAreaList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.ShapeInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.ShapeInfo, 19));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.ShapeInfo>} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setMultiLayerAreaList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 19, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.ShapeInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.ShapeInfo}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.addMultiLayerArea = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.zelos.zoe.data_view.proto.ShapeInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearMultiLayerAreaList = function() {
  return this.setMultiLayerAreaList([]);
};


/**
 * optional MapVersionMeta map_version_meta = 20;
 * @return {?proto.zelos.zoe.data_view.proto.MapVersionMeta}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.getMapVersionMeta = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.MapVersionMeta} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.MapVersionMeta, 20));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.MapVersionMeta|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
*/
proto.zelos.zoe.data_view.proto.MapData.prototype.setMapVersionMeta = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.MapData} returns this
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.clearMapVersionMeta = function() {
  return this.setMapVersionMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.MapData.prototype.hasMapVersionMeta = function() {
  return jspb.Message.getField(this, 20) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.BumperEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.BumperEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.BumperEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.BumperEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
position: jspb.Message.getFieldWithDefault(msg, 1, 0),
switchTouched: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
switchDisable: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.BumperEntity}
 */
proto.zelos.zoe.data_view.proto.BumperEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.BumperEntity;
  return proto.zelos.zoe.data_view.proto.BumperEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.BumperEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.BumperEntity}
 */
proto.zelos.zoe.data_view.proto.BumperEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.BumperEntity.BumperPosition} */ (reader.readEnum());
      msg.setPosition(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSwitchTouched(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSwitchDisable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.BumperEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.BumperEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.BumperEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.BumperEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPosition();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSwitchTouched();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getSwitchDisable();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.BumperEntity.BumperPosition = {
  BUMPER_POSITION_NONE: 0,
  BUMPER_POSITION_FRONT: 1,
  BUMPER_POSITION_REAR: 2,
  BUMPER_POSITION_LEFT: 3,
  BUMPER_POSITION_RIGHT: 4,
  BUMPER_POSITION_CARGOBOX_FRONT: 5,
  BUMPER_POSITION_CARGOBOX_REAR: 6,
  BUMPER_POSITION_VIRTUAL: 7
};

/**
 * optional BumperPosition position = 1;
 * @return {!proto.zelos.zoe.data_view.proto.BumperEntity.BumperPosition}
 */
proto.zelos.zoe.data_view.proto.BumperEntity.prototype.getPosition = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.BumperEntity.BumperPosition} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.BumperEntity.BumperPosition} value
 * @return {!proto.zelos.zoe.data_view.proto.BumperEntity} returns this
 */
proto.zelos.zoe.data_view.proto.BumperEntity.prototype.setPosition = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool switch_touched = 2;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.BumperEntity.prototype.getSwitchTouched = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.BumperEntity} returns this
 */
proto.zelos.zoe.data_view.proto.BumperEntity.prototype.setSwitchTouched = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool switch_disable = 3;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.BumperEntity.prototype.getSwitchDisable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.BumperEntity} returns this
 */
proto.zelos.zoe.data_view.proto.BumperEntity.prototype.setSwitchDisable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.VehicleBumper.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.VehicleBumper.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.VehicleBumper.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.VehicleBumper} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleBumper.toObject = function(includeInstance, msg) {
  var f, obj = {
bumperList: jspb.Message.toObjectList(msg.getBumperList(),
    proto.zelos.zoe.data_view.proto.BumperEntity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleBumper}
 */
proto.zelos.zoe.data_view.proto.VehicleBumper.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.VehicleBumper;
  return proto.zelos.zoe.data_view.proto.VehicleBumper.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleBumper} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleBumper}
 */
proto.zelos.zoe.data_view.proto.VehicleBumper.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.BumperEntity;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.BumperEntity.deserializeBinaryFromReader);
      msg.addBumper(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.VehicleBumper.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.VehicleBumper.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleBumper} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleBumper.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBumperList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.BumperEntity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BumperEntity bumper = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.BumperEntity>}
 */
proto.zelos.zoe.data_view.proto.VehicleBumper.prototype.getBumperList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.BumperEntity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.BumperEntity, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.BumperEntity>} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleBumper} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleBumper.prototype.setBumperList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.BumperEntity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.BumperEntity}
 */
proto.zelos.zoe.data_view.proto.VehicleBumper.prototype.addBumper = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.BumperEntity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleBumper} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleBumper.prototype.clearBumperList = function() {
  return this.setBumperList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.VehicleSignal.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.VehicleSignal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.VehicleSignal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleSignal.toObject = function(includeInstance, msg) {
  var f, obj = {
brakeLamp: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleSignal}
 */
proto.zelos.zoe.data_view.proto.VehicleSignal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.VehicleSignal;
  return proto.zelos.zoe.data_view.proto.VehicleSignal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleSignal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleSignal}
 */
proto.zelos.zoe.data_view.proto.VehicleSignal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.VehicleSignal.SwitchState} */ (reader.readEnum());
      msg.setBrakeLamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.VehicleSignal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.VehicleSignal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleSignal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleSignal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBrakeLamp();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.VehicleSignal.SwitchState = {
  SWITCH_NONE: 0,
  SWITCH_OFF: 1,
  SWITCH_ON: 2
};

/**
 * optional SwitchState brake_lamp = 4;
 * @return {!proto.zelos.zoe.data_view.proto.VehicleSignal.SwitchState}
 */
proto.zelos.zoe.data_view.proto.VehicleSignal.prototype.getBrakeLamp = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.VehicleSignal.SwitchState} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.VehicleSignal.SwitchState} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleSignal} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleSignal.prototype.setBrakeLamp = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.VehicleMotion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.VehicleMotion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.toObject = function(includeInstance, msg) {
  var f, obj = {
vehicleSignal: (f = msg.getVehicleSignal()) && proto.zelos.zoe.data_view.proto.VehicleSignal.toObject(includeInstance, f),
vehicleBumper: (f = msg.getVehicleBumper()) && proto.zelos.zoe.data_view.proto.VehicleBumper.toObject(includeInstance, f),
linearVelocity: jspb.Message.getFloatingPointFieldWithDefault(msg, 24, 0.0),
linearAcceleration: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
frontWheelAngle: jspb.Message.getFloatingPointFieldWithDefault(msg, 26, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleMotion}
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.VehicleMotion;
  return proto.zelos.zoe.data_view.proto.VehicleMotion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleMotion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleMotion}
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 17:
      var value = new proto.zelos.zoe.data_view.proto.VehicleSignal;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VehicleSignal.deserializeBinaryFromReader);
      msg.setVehicleSignal(value);
      break;
    case 23:
      var value = new proto.zelos.zoe.data_view.proto.VehicleBumper;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VehicleBumper.deserializeBinaryFromReader);
      msg.setVehicleBumper(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLinearVelocity(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLinearAcceleration(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFrontWheelAngle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.VehicleMotion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleMotion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleSignal();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.zelos.zoe.data_view.proto.VehicleSignal.serializeBinaryToWriter
    );
  }
  f = message.getVehicleBumper();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.zelos.zoe.data_view.proto.VehicleBumper.serializeBinaryToWriter
    );
  }
  f = message.getLinearVelocity();
  if (f !== 0.0) {
    writer.writeDouble(
      24,
      f
    );
  }
  f = message.getLinearAcceleration();
  if (f !== 0.0) {
    writer.writeDouble(
      25,
      f
    );
  }
  f = message.getFrontWheelAngle();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
};


/**
 * optional VehicleSignal vehicle_signal = 17;
 * @return {?proto.zelos.zoe.data_view.proto.VehicleSignal}
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.getVehicleSignal = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.VehicleSignal} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.VehicleSignal, 17));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.VehicleSignal|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleMotion} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.setVehicleSignal = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleMotion} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.clearVehicleSignal = function() {
  return this.setVehicleSignal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.hasVehicleSignal = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional VehicleBumper vehicle_bumper = 23;
 * @return {?proto.zelos.zoe.data_view.proto.VehicleBumper}
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.getVehicleBumper = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.VehicleBumper} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.VehicleBumper, 23));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.VehicleBumper|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleMotion} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.setVehicleBumper = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleMotion} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.clearVehicleBumper = function() {
  return this.setVehicleBumper(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.hasVehicleBumper = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional double linear_velocity = 24;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.getLinearVelocity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleMotion} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.setLinearVelocity = function(value) {
  return jspb.Message.setProto3FloatField(this, 24, value);
};


/**
 * optional double linear_acceleration = 25;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.getLinearAcceleration = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleMotion} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.setLinearAcceleration = function(value) {
  return jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional double front_wheel_angle = 26;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.getFrontWheelAngle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleMotion} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleMotion.prototype.setFrontWheelAngle = function(value) {
  return jspb.Message.setProto3FloatField(this, 26, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.toObject = function(includeInstance, msg) {
  var f, obj = {
sensorAnomalyDetectionItemList: jspb.Message.toObjectList(msg.getSensorAnomalyDetectionItemList(),
    proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.SensorAnomalyDetection;
  return proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.deserializeBinaryFromReader);
      msg.addSensorAnomalyDetectionItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSensorAnomalyDetectionItemList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.AnomalySeverity = {
  AS_UNKNOWN: 0,
  AS_NORMAL: 1,
  AS_WARNING: 2,
  AS_ERROR: 3,
  AS_FATAL: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.toObject = function(includeInstance, msg) {
  var f, obj = {
frameId: jspb.Message.getFieldWithDefault(msg, 1, 0),
severity: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem;
  return proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFrameId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.AnomalySeverity} */ (reader.readEnum());
      msg.setSeverity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSeverity();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional uint32 frame_id = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.prototype.getFrameId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem} returns this
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.prototype.setFrameId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional AnomalySeverity severity = 2;
 * @return {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.AnomalySeverity}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.prototype.getSeverity = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.AnomalySeverity} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.AnomalySeverity} value
 * @return {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem} returns this
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem.prototype.setSeverity = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated SensorAnomalyDetectionItem sensor_anomaly_detection_item = 1;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem>}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.prototype.getSensorAnomalyDetectionItemList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem, 1));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem>} value
 * @return {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection} returns this
*/
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.prototype.setSensorAnomalyDetectionItemList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem}
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.prototype.addSensorAnomalyDetectionItem = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.SensorAnomalyDetectionItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.SensorAnomalyDetection} returns this
 */
proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.prototype.clearSensorAnomalyDetectionItemList = function() {
  return this.setSensorAnomalyDetectionItemList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.UltrasonicObstacle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.toObject = function(includeInstance, msg) {
  var f, obj = {
frameId: jspb.Message.getFieldWithDefault(msg, 1, 0),
distance: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0),
state: jspb.Message.getFieldWithDefault(msg, 4, 0),
frameName: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle}
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.UltrasonicObstacle;
  return proto.zelos.zoe.data_view.proto.UltrasonicObstacle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle}
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFrameId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDistance(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    case 4:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle.UltrasonicState} */ (reader.readEnum());
      msg.setState(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrameName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.UltrasonicObstacle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getDistance();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getState();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getFrameName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.UltrasonicState = {
  STATE_NORMAL: 0,
  STATE_TEMPORARY_ERROR: 1,
  STATE_NEED_REPAIR: 2
};

/**
 * optional uint32 frame_id = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.prototype.getFrameId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.prototype.setFrameId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional float distance = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.prototype.getDistance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.prototype.setDistance = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional uint64 timestamp = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional UltrasonicState state = 4;
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle.UltrasonicState}
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.prototype.getState = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle.UltrasonicState} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle.UltrasonicState} value
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.prototype.setState = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string frame_name = 5;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.prototype.getFrameName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.UltrasonicObstacle.prototype.setFrameName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.UltrasonicData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.UltrasonicData.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.UltrasonicData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.UltrasonicData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.UltrasonicData.toObject = function(includeInstance, msg) {
  var f, obj = {
obstacleList: jspb.Message.toObjectList(msg.getObstacleList(),
    proto.zelos.zoe.data_view.proto.UltrasonicObstacle.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicData}
 */
proto.zelos.zoe.data_view.proto.UltrasonicData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.UltrasonicData;
  return proto.zelos.zoe.data_view.proto.UltrasonicData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.UltrasonicData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicData}
 */
proto.zelos.zoe.data_view.proto.UltrasonicData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.UltrasonicObstacle;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.UltrasonicObstacle.deserializeBinaryFromReader);
      msg.addObstacle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.UltrasonicData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.UltrasonicData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.UltrasonicData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.UltrasonicData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getObstacleList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.UltrasonicObstacle.serializeBinaryToWriter
    );
  }
};


/**
 * repeated UltrasonicObstacle obstacle = 1;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.UltrasonicObstacle>}
 */
proto.zelos.zoe.data_view.proto.UltrasonicData.prototype.getObstacleList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.UltrasonicObstacle>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.UltrasonicObstacle, 1));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.UltrasonicObstacle>} value
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicData} returns this
*/
proto.zelos.zoe.data_view.proto.UltrasonicData.prototype.setObstacleList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicObstacle}
 */
proto.zelos.zoe.data_view.proto.UltrasonicData.prototype.addObstacle = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.zelos.zoe.data_view.proto.UltrasonicObstacle, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.UltrasonicData} returns this
 */
proto.zelos.zoe.data_view.proto.UltrasonicData.prototype.clearObstacleList = function() {
  return this.setObstacleList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.VehicleTrajectory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.VehicleTrajectory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.toObject = function(includeInstance, msg) {
  var f, obj = {
leftTrajectoryList: jspb.Message.toObjectList(msg.getLeftTrajectoryList(),
    proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.toObject, includeInstance),
rightTrajectoryList: jspb.Message.toObjectList(msg.getRightTrajectoryList(),
    proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.VehicleTrajectory;
  return proto.zelos.zoe.data_view.proto.VehicleTrajectory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleTrajectory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.deserializeBinaryFromReader);
      msg.addLeftTrajectory(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.deserializeBinaryFromReader);
      msg.addRightTrajectory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.VehicleTrajectory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleTrajectory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLeftTrajectoryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.serializeBinaryToWriter
    );
  }
  f = message.getRightTrajectoryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
trajectoryLength: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
xInt: jspb.Message.getFieldWithDefault(msg, 4, 0),
yInt: jspb.Message.getFieldWithDefault(msg, 5, 0),
trajectoryLengthInt: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint;
  return proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTrajectoryLength(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setXInt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYInt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrajectoryLengthInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getTrajectoryLength();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getXInt();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getYInt();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTrajectoryLengthInt();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional float x = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float y = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float trajectory_length = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.getTrajectoryLength = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.setTrajectoryLength = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int32 x_int = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.getXInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.setXInt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 y_int = 5;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.getYInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.setYInt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 trajectory_length_int = 6;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.getTrajectoryLengthInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint.prototype.setTrajectoryLengthInt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated TrajectoryPoint left_trajectory = 1;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint>}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.prototype.getLeftTrajectoryList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint, 1));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint>} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleTrajectory.prototype.setLeftTrajectoryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.prototype.addLeftTrajectory = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.prototype.clearLeftTrajectoryList = function() {
  return this.setLeftTrajectoryList([]);
};


/**
 * repeated TrajectoryPoint right_trajectory = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint>}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.prototype.getRightTrajectoryList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint>} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleTrajectory.prototype.setRightTrajectoryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint}
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.prototype.addRightTrajectory = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.VehicleTrajectory.TrajectoryPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleTrajectory} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleTrajectory.prototype.clearRightTrajectoryList = function() {
  return this.setRightTrajectoryList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.GatePosePointList.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.GatePosePointList.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.GatePosePointList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.GatePosePointList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.GatePosePointList.toObject = function(includeInstance, msg) {
  var f, obj = {
gatePoseList: jspb.Message.toObjectList(msg.getGatePoseList(),
    proto.zelos.zoe.data_view.proto.PathPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.GatePosePointList}
 */
proto.zelos.zoe.data_view.proto.GatePosePointList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.GatePosePointList;
  return proto.zelos.zoe.data_view.proto.GatePosePointList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.GatePosePointList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.GatePosePointList}
 */
proto.zelos.zoe.data_view.proto.GatePosePointList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.PathPoint;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.PathPoint.deserializeBinaryFromReader);
      msg.addGatePose(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.GatePosePointList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.GatePosePointList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.GatePosePointList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.GatePosePointList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGatePoseList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.PathPoint.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PathPoint gate_pose = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.PathPoint>}
 */
proto.zelos.zoe.data_view.proto.GatePosePointList.prototype.getGatePoseList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.PathPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.PathPoint, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.PathPoint>} value
 * @return {!proto.zelos.zoe.data_view.proto.GatePosePointList} returns this
*/
proto.zelos.zoe.data_view.proto.GatePosePointList.prototype.setGatePoseList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.PathPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint}
 */
proto.zelos.zoe.data_view.proto.GatePosePointList.prototype.addGatePose = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.PathPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.GatePosePointList} returns this
 */
proto.zelos.zoe.data_view.proto.GatePosePointList.prototype.clearGatePoseList = function() {
  return this.setGatePoseList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.ConstructionAreaList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.ConstructionAreaList.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.ConstructionAreaList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.ConstructionAreaList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ConstructionAreaList.toObject = function(includeInstance, msg) {
  var f, obj = {
constructionAreasList: jspb.Message.toObjectList(msg.getConstructionAreasList(),
    proto.zelos.zoe.data_view.proto.VirtualObstacle.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.ConstructionAreaList}
 */
proto.zelos.zoe.data_view.proto.ConstructionAreaList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.ConstructionAreaList;
  return proto.zelos.zoe.data_view.proto.ConstructionAreaList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.ConstructionAreaList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.ConstructionAreaList}
 */
proto.zelos.zoe.data_view.proto.ConstructionAreaList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.VirtualObstacle;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VirtualObstacle.deserializeBinaryFromReader);
      msg.addConstructionAreas(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.ConstructionAreaList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.ConstructionAreaList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.ConstructionAreaList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ConstructionAreaList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConstructionAreasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.VirtualObstacle.serializeBinaryToWriter
    );
  }
};


/**
 * repeated VirtualObstacle construction_areas = 1;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.VirtualObstacle>}
 */
proto.zelos.zoe.data_view.proto.ConstructionAreaList.prototype.getConstructionAreasList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.VirtualObstacle>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.VirtualObstacle, 1));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.VirtualObstacle>} value
 * @return {!proto.zelos.zoe.data_view.proto.ConstructionAreaList} returns this
*/
proto.zelos.zoe.data_view.proto.ConstructionAreaList.prototype.setConstructionAreasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.VirtualObstacle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.VirtualObstacle}
 */
proto.zelos.zoe.data_view.proto.ConstructionAreaList.prototype.addConstructionAreas = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.zelos.zoe.data_view.proto.VirtualObstacle, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.ConstructionAreaList} returns this
 */
proto.zelos.zoe.data_view.proto.ConstructionAreaList.prototype.clearConstructionAreasList = function() {
  return this.setConstructionAreasList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.PncBusinessInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.PncBusinessInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
gatePosePointList: (f = msg.getGatePosePointList()) && proto.zelos.zoe.data_view.proto.GatePosePointList.toObject(includeInstance, f),
constructionAreaList: (f = msg.getConstructionAreaList()) && proto.zelos.zoe.data_view.proto.ConstructionAreaList.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessInfo}
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.PncBusinessInfo;
  return proto.zelos.zoe.data_view.proto.PncBusinessInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.PncBusinessInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessInfo}
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 11:
      var value = new proto.zelos.zoe.data_view.proto.GatePosePointList;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.GatePosePointList.deserializeBinaryFromReader);
      msg.setGatePosePointList(value);
      break;
    case 12:
      var value = new proto.zelos.zoe.data_view.proto.ConstructionAreaList;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.ConstructionAreaList.deserializeBinaryFromReader);
      msg.setConstructionAreaList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.PncBusinessInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.PncBusinessInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGatePosePointList();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.zelos.zoe.data_view.proto.GatePosePointList.serializeBinaryToWriter
    );
  }
  f = message.getConstructionAreaList();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.zelos.zoe.data_view.proto.ConstructionAreaList.serializeBinaryToWriter
    );
  }
};


/**
 * optional GatePosePointList gate_pose_point_list = 11;
 * @return {?proto.zelos.zoe.data_view.proto.GatePosePointList}
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo.prototype.getGatePosePointList = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.GatePosePointList} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.GatePosePointList, 11));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.GatePosePointList|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessInfo} returns this
*/
proto.zelos.zoe.data_view.proto.PncBusinessInfo.prototype.setGatePosePointList = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessInfo} returns this
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo.prototype.clearGatePosePointList = function() {
  return this.setGatePosePointList(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo.prototype.hasGatePosePointList = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional ConstructionAreaList construction_area_list = 12;
 * @return {?proto.zelos.zoe.data_view.proto.ConstructionAreaList}
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo.prototype.getConstructionAreaList = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.ConstructionAreaList} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.ConstructionAreaList, 12));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.ConstructionAreaList|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessInfo} returns this
*/
proto.zelos.zoe.data_view.proto.PncBusinessInfo.prototype.setConstructionAreaList = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessInfo} returns this
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo.prototype.clearConstructionAreaList = function() {
  return this.setConstructionAreaList(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.PncBusinessInfo.prototype.hasConstructionAreaList = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.EraseObstacle.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.EraseObstacle.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.EraseObstacle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.EraseObstacle.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.EraseObstacle}
 */
proto.zelos.zoe.data_view.proto.EraseObstacle.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.EraseObstacle;
  return proto.zelos.zoe.data_view.proto.EraseObstacle.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.EraseObstacle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.EraseObstacle}
 */
proto.zelos.zoe.data_view.proto.EraseObstacle.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.EraseObstacle.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.EraseObstacle.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.EraseObstacle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.EraseObstacle.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.EraseObstacle.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.EraseObstacle} returns this
 */
proto.zelos.zoe.data_view.proto.EraseObstacle.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.toObject = function(includeInstance, msg) {
  var f, obj = {
eraseAreaType: jspb.Message.getFieldWithDefault(msg, 1, 0),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point2D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea}
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.FreeMoveEraseArea;
  return proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea}
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.EraseAreaType} */ (reader.readEnum());
      msg.setEraseAreaType(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point2D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point2D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEraseAreaType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point2D.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.EraseAreaType = {
  UNKNOWN: 0,
  ERASE_STATIC_AREA: 1,
  ERASE_BUILDING_AREA: 2,
  ERASE_VEHICLE_AREA: 3,
  ERASE_MOVABLE_GATE_AREA: 4,
  ERASE_MOVABLE_CURB_AREA: 5
};

/**
 * optional EraseAreaType erase_area_type = 1;
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.EraseAreaType}
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.prototype.getEraseAreaType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.EraseAreaType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.EraseAreaType} value
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea} returns this
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.prototype.setEraseAreaType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated Point2D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point2D>}
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point2D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point2D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point2D>} value
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea} returns this
*/
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point2D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point2D}
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point2D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea} returns this
 */
proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.EnvironmentEdit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.EnvironmentEdit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.toObject = function(includeInstance, msg) {
  var f, obj = {
eraseObstaclesList: jspb.Message.toObjectList(msg.getEraseObstaclesList(),
    proto.zelos.zoe.data_view.proto.EraseObstacle.toObject, includeInstance),
eraseObstacleAreasList: jspb.Message.toObjectList(msg.getEraseObstacleAreasList(),
    proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.EnvironmentEdit}
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.EnvironmentEdit;
  return proto.zelos.zoe.data_view.proto.EnvironmentEdit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.EnvironmentEdit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.EnvironmentEdit}
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.EraseObstacle;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.EraseObstacle.deserializeBinaryFromReader);
      msg.addEraseObstacles(value);
      break;
    case 4:
      var value = new proto.zelos.zoe.data_view.proto.FreeMoveEraseArea;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.deserializeBinaryFromReader);
      msg.addEraseObstacleAreas(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.EnvironmentEdit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.EnvironmentEdit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEraseObstaclesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.EraseObstacle.serializeBinaryToWriter
    );
  }
  f = message.getEraseObstacleAreasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.zelos.zoe.data_view.proto.FreeMoveEraseArea.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EraseObstacle erase_obstacles = 3;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.EraseObstacle>}
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.prototype.getEraseObstaclesList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.EraseObstacle>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.EraseObstacle, 3));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.EraseObstacle>} value
 * @return {!proto.zelos.zoe.data_view.proto.EnvironmentEdit} returns this
*/
proto.zelos.zoe.data_view.proto.EnvironmentEdit.prototype.setEraseObstaclesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.EraseObstacle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.EraseObstacle}
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.prototype.addEraseObstacles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.zelos.zoe.data_view.proto.EraseObstacle, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.EnvironmentEdit} returns this
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.prototype.clearEraseObstaclesList = function() {
  return this.setEraseObstaclesList([]);
};


/**
 * repeated FreeMoveEraseArea erase_obstacle_areas = 4;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea>}
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.prototype.getEraseObstacleAreasList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.FreeMoveEraseArea, 4));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea>} value
 * @return {!proto.zelos.zoe.data_view.proto.EnvironmentEdit} returns this
*/
proto.zelos.zoe.data_view.proto.EnvironmentEdit.prototype.setEraseObstacleAreasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveEraseArea}
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.prototype.addEraseObstacleAreas = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.zelos.zoe.data_view.proto.FreeMoveEraseArea, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.EnvironmentEdit} returns this
 */
proto.zelos.zoe.data_view.proto.EnvironmentEdit.prototype.clearEraseObstacleAreasList = function() {
  return this.setEraseObstacleAreasList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.RecoveryCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.RecoveryCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.RecoveryCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.RecoveryCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
environmentEdit: (f = msg.getEnvironmentEdit()) && proto.zelos.zoe.data_view.proto.EnvironmentEdit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.RecoveryCommand}
 */
proto.zelos.zoe.data_view.proto.RecoveryCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.RecoveryCommand;
  return proto.zelos.zoe.data_view.proto.RecoveryCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.RecoveryCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.RecoveryCommand}
 */
proto.zelos.zoe.data_view.proto.RecoveryCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.EnvironmentEdit;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.EnvironmentEdit.deserializeBinaryFromReader);
      msg.setEnvironmentEdit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.RecoveryCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.RecoveryCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.RecoveryCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.RecoveryCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnvironmentEdit();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.EnvironmentEdit.serializeBinaryToWriter
    );
  }
};


/**
 * optional EnvironmentEdit environment_edit = 3;
 * @return {?proto.zelos.zoe.data_view.proto.EnvironmentEdit}
 */
proto.zelos.zoe.data_view.proto.RecoveryCommand.prototype.getEnvironmentEdit = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.EnvironmentEdit} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.EnvironmentEdit, 3));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.EnvironmentEdit|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.RecoveryCommand} returns this
*/
proto.zelos.zoe.data_view.proto.RecoveryCommand.prototype.setEnvironmentEdit = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.RecoveryCommand} returns this
 */
proto.zelos.zoe.data_view.proto.RecoveryCommand.prototype.clearEnvironmentEdit = function() {
  return this.setEnvironmentEdit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.RecoveryCommand.prototype.hasEnvironmentEdit = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.CommandCase = {
  COMMAND_NOT_SET: 0,
  PREVIEW: 1,
  START: 2,
  CANCEL: 3,
  CLEAR: 4
};

/**
 * @return {proto.zelos.zoe.data_view.proto.FreeMoveCommand.CommandCase}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.getCommandCase = function() {
  return /** @type {proto.zelos.zoe.data_view.proto.FreeMoveCommand.CommandCase} */(jspb.Message.computeOneofCase(this, proto.zelos.zoe.data_view.proto.FreeMoveCommand.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.FreeMoveCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
preview: (f = msg.getPreview()) && proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.toObject(includeInstance, f),
start: (f = msg.getStart()) && proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.toObject(includeInstance, f),
cancel: (f = msg.getCancel()) && proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.toObject(includeInstance, f),
clear: (f = msg.getClear()) && proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.toObject(includeInstance, f),
historyPreview: (f = msg.getHistoryPreview()) && proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.FreeMoveCommand;
  return proto.zelos.zoe.data_view.proto.FreeMoveCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.deserializeBinaryFromReader);
      msg.setPreview(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.deserializeBinaryFromReader);
      msg.setStart(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.deserializeBinaryFromReader);
      msg.setCancel(value);
      break;
    case 4:
      var value = new proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.deserializeBinaryFromReader);
      msg.setClear(value);
      break;
    case 5:
      var value = new proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.deserializeBinaryFromReader);
      msg.setHistoryPreview(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.FreeMoveCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPreview();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.serializeBinaryToWriter
    );
  }
  f = message.getStart();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.serializeBinaryToWriter
    );
  }
  f = message.getCancel();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.serializeBinaryToWriter
    );
  }
  f = message.getClear();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.serializeBinaryToWriter
    );
  }
  f = message.getHistoryPreview();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.toObject = function(includeInstance, msg) {
  var f, obj = {
environmentEdit: (f = msg.getEnvironmentEdit()) && proto.zelos.zoe.data_view.proto.EnvironmentEdit.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview;
  return proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 11:
      var value = new proto.zelos.zoe.data_view.proto.EnvironmentEdit;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.EnvironmentEdit.deserializeBinaryFromReader);
      msg.setEnvironmentEdit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnvironmentEdit();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.zelos.zoe.data_view.proto.EnvironmentEdit.serializeBinaryToWriter
    );
  }
};


/**
 * optional EnvironmentEdit environment_edit = 11;
 * @return {?proto.zelos.zoe.data_view.proto.EnvironmentEdit}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.prototype.getEnvironmentEdit = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.EnvironmentEdit} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.EnvironmentEdit, 11));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.EnvironmentEdit|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview} returns this
*/
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.prototype.setEnvironmentEdit = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview} returns this
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.prototype.clearEnvironmentEdit = function() {
  return this.setEnvironmentEdit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview.prototype.hasEnvironmentEdit = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start;
  return proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel;
  return proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand;
  return proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * optional Preview preview = 1;
 * @return {?proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.getPreview = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} returns this
*/
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.setPreview = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.zelos.zoe.data_view.proto.FreeMoveCommand.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} returns this
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.clearPreview = function() {
  return this.setPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.hasPreview = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Start start = 2;
 * @return {?proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.getStart = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start, 2));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.FreeMoveCommand.Start|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} returns this
*/
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.setStart = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.zelos.zoe.data_view.proto.FreeMoveCommand.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} returns this
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.clearStart = function() {
  return this.setStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.hasStart = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Cancel cancel = 3;
 * @return {?proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.getCancel = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel, 3));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.FreeMoveCommand.Cancel|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} returns this
*/
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.setCancel = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.zelos.zoe.data_view.proto.FreeMoveCommand.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} returns this
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.clearCancel = function() {
  return this.setCancel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.hasCancel = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ClearCommand clear = 4;
 * @return {?proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.getClear = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand, 4));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.FreeMoveCommand.ClearCommand|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} returns this
*/
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.setClear = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.zelos.zoe.data_view.proto.FreeMoveCommand.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} returns this
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.clearClear = function() {
  return this.setClear(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.hasClear = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Preview history_preview = 5;
 * @return {?proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.getHistoryPreview = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview, 5));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.FreeMoveCommand.Preview|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} returns this
*/
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.setHistoryPreview = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.FreeMoveCommand} returns this
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.clearHistoryPreview = function() {
  return this.setHistoryPreview(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.FreeMoveCommand.prototype.hasHistoryPreview = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
recoveryCommand: (f = msg.getRecoveryCommand()) && proto.zelos.zoe.data_view.proto.RecoveryCommand.toObject(includeInstance, f),
freeMoveCommand: (f = msg.getFreeMoveCommand()) && proto.zelos.zoe.data_view.proto.FreeMoveCommand.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand}
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand;
  return proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand}
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.RecoveryCommand;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.RecoveryCommand.deserializeBinaryFromReader);
      msg.setRecoveryCommand(value);
      break;
    case 5:
      var value = new proto.zelos.zoe.data_view.proto.FreeMoveCommand;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.FreeMoveCommand.deserializeBinaryFromReader);
      msg.setFreeMoveCommand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecoveryCommand();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.RecoveryCommand.serializeBinaryToWriter
    );
  }
  f = message.getFreeMoveCommand();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.zelos.zoe.data_view.proto.FreeMoveCommand.serializeBinaryToWriter
    );
  }
};


/**
 * optional RecoveryCommand recovery_command = 3;
 * @return {?proto.zelos.zoe.data_view.proto.RecoveryCommand}
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.prototype.getRecoveryCommand = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.RecoveryCommand} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.RecoveryCommand, 3));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.RecoveryCommand|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand} returns this
*/
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.prototype.setRecoveryCommand = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand} returns this
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.prototype.clearRecoveryCommand = function() {
  return this.setRecoveryCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.prototype.hasRecoveryCommand = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional FreeMoveCommand free_move_command = 5;
 * @return {?proto.zelos.zoe.data_view.proto.FreeMoveCommand}
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.prototype.getFreeMoveCommand = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.FreeMoveCommand} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.FreeMoveCommand, 5));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.FreeMoveCommand|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand} returns this
*/
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.prototype.setFreeMoveCommand = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand} returns this
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.prototype.clearFreeMoveCommand = function() {
  return this.setFreeMoveCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.prototype.hasFreeMoveCommand = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.repeatedFields_ = [21];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.PncBusinessCommand.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.PncBusinessCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.toObject = function(includeInstance, msg) {
  var f, obj = {
pncBusinessInfosList: jspb.Message.toObjectList(msg.getPncBusinessInfosList(),
    proto.zelos.zoe.data_view.proto.PncBusinessInfo.toObject, includeInstance),
remoteTakeoverCommand: (f = msg.getRemoteTakeoverCommand()) && proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessCommand}
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.PncBusinessCommand;
  return proto.zelos.zoe.data_view.proto.PncBusinessCommand.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.PncBusinessCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessCommand}
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 21:
      var value = new proto.zelos.zoe.data_view.proto.PncBusinessInfo;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.PncBusinessInfo.deserializeBinaryFromReader);
      msg.addPncBusinessInfos(value);
      break;
    case 30:
      var value = new proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.deserializeBinaryFromReader);
      msg.setRemoteTakeoverCommand(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.PncBusinessCommand.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.PncBusinessCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPncBusinessInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      proto.zelos.zoe.data_view.proto.PncBusinessInfo.serializeBinaryToWriter
    );
  }
  f = message.getRemoteTakeoverCommand();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PncBusinessInfo pnc_business_infos = 21;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.PncBusinessInfo>}
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.prototype.getPncBusinessInfosList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.PncBusinessInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.PncBusinessInfo, 21));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.PncBusinessInfo>} value
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessCommand} returns this
*/
proto.zelos.zoe.data_view.proto.PncBusinessCommand.prototype.setPncBusinessInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.PncBusinessInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessInfo}
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.prototype.addPncBusinessInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.zelos.zoe.data_view.proto.PncBusinessInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessCommand} returns this
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.prototype.clearPncBusinessInfosList = function() {
  return this.setPncBusinessInfosList([]);
};


/**
 * optional RemoteTakeOverCommand remote_takeover_command = 30;
 * @return {?proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand}
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.prototype.getRemoteTakeoverCommand = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand, 30));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.RemoteTakeOverCommand|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessCommand} returns this
*/
proto.zelos.zoe.data_view.proto.PncBusinessCommand.prototype.setRemoteTakeoverCommand = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.PncBusinessCommand} returns this
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.prototype.clearRemoteTakeoverCommand = function() {
  return this.setRemoteTakeoverCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.PncBusinessCommand.prototype.hasRemoteTakeoverCommand = function() {
  return jspb.Message.getField(this, 30) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.CoordinateType.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.CoordinateType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.CoordinateType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.CoordinateType.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.CoordinateType}
 */
proto.zelos.zoe.data_view.proto.CoordinateType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.CoordinateType;
  return proto.zelos.zoe.data_view.proto.CoordinateType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.CoordinateType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.CoordinateType}
 */
proto.zelos.zoe.data_view.proto.CoordinateType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.CoordinateType.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.CoordinateType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.CoordinateType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.CoordinateType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.CoordinateType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.CoordinateType.Type = {
  UNKNOWN: 0,
  WGS84: 1,
  LOCAL: 2
};

/**
 * optional Type type = 1;
 * @return {!proto.zelos.zoe.data_view.proto.CoordinateType.Type}
 */
proto.zelos.zoe.data_view.proto.CoordinateType.prototype.getType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.CoordinateType.Type} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.CoordinateType.Type} value
 * @return {!proto.zelos.zoe.data_view.proto.CoordinateType} returns this
 */
proto.zelos.zoe.data_view.proto.CoordinateType.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.BusinessInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.BusinessInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.BusinessInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.BusinessInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
remoteBusinessCommand: (f = msg.getRemoteBusinessCommand()) && proto.zelos.zoe.data_view.proto.PncBusinessCommand.toObject(includeInstance, f),
coordinateType: (f = msg.getCoordinateType()) && proto.zelos.zoe.data_view.proto.CoordinateType.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.BusinessInfo}
 */
proto.zelos.zoe.data_view.proto.BusinessInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.BusinessInfo;
  return proto.zelos.zoe.data_view.proto.BusinessInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.BusinessInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.BusinessInfo}
 */
proto.zelos.zoe.data_view.proto.BusinessInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.PncBusinessCommand;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.PncBusinessCommand.deserializeBinaryFromReader);
      msg.setRemoteBusinessCommand(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.CoordinateType;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.CoordinateType.deserializeBinaryFromReader);
      msg.setCoordinateType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.BusinessInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.BusinessInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.BusinessInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.BusinessInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRemoteBusinessCommand();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.PncBusinessCommand.serializeBinaryToWriter
    );
  }
  f = message.getCoordinateType();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.CoordinateType.serializeBinaryToWriter
    );
  }
};


/**
 * optional PncBusinessCommand remote_business_command = 2;
 * @return {?proto.zelos.zoe.data_view.proto.PncBusinessCommand}
 */
proto.zelos.zoe.data_view.proto.BusinessInfo.prototype.getRemoteBusinessCommand = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.PncBusinessCommand} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.PncBusinessCommand, 2));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.PncBusinessCommand|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.BusinessInfo} returns this
*/
proto.zelos.zoe.data_view.proto.BusinessInfo.prototype.setRemoteBusinessCommand = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.BusinessInfo} returns this
 */
proto.zelos.zoe.data_view.proto.BusinessInfo.prototype.clearRemoteBusinessCommand = function() {
  return this.setRemoteBusinessCommand(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.BusinessInfo.prototype.hasRemoteBusinessCommand = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CoordinateType coordinate_type = 3;
 * @return {?proto.zelos.zoe.data_view.proto.CoordinateType}
 */
proto.zelos.zoe.data_view.proto.BusinessInfo.prototype.getCoordinateType = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.CoordinateType} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.CoordinateType, 3));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.CoordinateType|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.BusinessInfo} returns this
*/
proto.zelos.zoe.data_view.proto.BusinessInfo.prototype.setCoordinateType = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.BusinessInfo} returns this
 */
proto.zelos.zoe.data_view.proto.BusinessInfo.prototype.clearCoordinateType = function() {
  return this.setCoordinateType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.BusinessInfo.prototype.hasCoordinateType = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.ShieldEmergencyStop} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.toObject = function(includeInstance, msg) {
  var f, obj = {
isForwardEstop: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
isBackwardEstop: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
reason: jspb.Message.getFieldWithDefault(msg, 3, ""),
isCollision: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
estopCounter: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.ShieldEmergencyStop}
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.ShieldEmergencyStop;
  return proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.ShieldEmergencyStop} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.ShieldEmergencyStop}
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsForwardEstop(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsBackwardEstop(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsCollision(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEstopCounter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.ShieldEmergencyStop} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsForwardEstop();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getIsBackwardEstop();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIsCollision();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getEstopCounter();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional bool is_forward_estop = 1;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.prototype.getIsForwardEstop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.ShieldEmergencyStop} returns this
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.prototype.setIsForwardEstop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool is_backward_estop = 2;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.prototype.getIsBackwardEstop = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.ShieldEmergencyStop} returns this
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.prototype.setIsBackwardEstop = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string reason = 3;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.ShieldEmergencyStop} returns this
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool is_collision = 4;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.prototype.getIsCollision = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.ShieldEmergencyStop} returns this
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.prototype.setIsCollision = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional int32 estop_counter = 5;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.prototype.getEstopCounter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.ShieldEmergencyStop} returns this
 */
proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.prototype.setEstopCounter = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.Path.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Path.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Path.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Path} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Path.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
pathPointList: jspb.Message.toObjectList(msg.getPathPointList(),
    proto.zelos.zoe.data_view.proto.PathPoint.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Path}
 */
proto.zelos.zoe.data_view.proto.Path.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Path;
  return proto.zelos.zoe.data_view.proto.Path.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Path} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Path}
 */
proto.zelos.zoe.data_view.proto.Path.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.PathPoint;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.PathPoint.deserializeBinaryFromReader);
      msg.addPathPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Path.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Path.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Path} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Path.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPathPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.PathPoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.Path.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.Path} returns this
 */
proto.zelos.zoe.data_view.proto.Path.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated PathPoint path_point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.PathPoint>}
 */
proto.zelos.zoe.data_view.proto.Path.prototype.getPathPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.PathPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.PathPoint, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.PathPoint>} value
 * @return {!proto.zelos.zoe.data_view.proto.Path} returns this
*/
proto.zelos.zoe.data_view.proto.Path.prototype.setPathPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.PathPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint}
 */
proto.zelos.zoe.data_view.proto.Path.prototype.addPathPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.PathPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.Path} returns this
 */
proto.zelos.zoe.data_view.proto.Path.prototype.clearPathPointList = function() {
  return this.setPathPointList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.EmergencySteering.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.EmergencySteering.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.EmergencySteering} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.EmergencySteering.toObject = function(includeInstance, msg) {
  var f, obj = {
path: (f = msg.getPath()) && proto.zelos.zoe.data_view.proto.Path.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.EmergencySteering}
 */
proto.zelos.zoe.data_view.proto.EmergencySteering.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.EmergencySteering;
  return proto.zelos.zoe.data_view.proto.EmergencySteering.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.EmergencySteering} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.EmergencySteering}
 */
proto.zelos.zoe.data_view.proto.EmergencySteering.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.Path;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Path.deserializeBinaryFromReader);
      msg.setPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.EmergencySteering.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.EmergencySteering.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.EmergencySteering} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.EmergencySteering.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.Path.serializeBinaryToWriter
    );
  }
};


/**
 * optional Path path = 1;
 * @return {?proto.zelos.zoe.data_view.proto.Path}
 */
proto.zelos.zoe.data_view.proto.EmergencySteering.prototype.getPath = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Path} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Path, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Path|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.EmergencySteering} returns this
*/
proto.zelos.zoe.data_view.proto.EmergencySteering.prototype.setPath = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.EmergencySteering} returns this
 */
proto.zelos.zoe.data_view.proto.EmergencySteering.prototype.clearPath = function() {
  return this.setPath(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.EmergencySteering.prototype.hasPath = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.ShieldOutput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.ShieldOutput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.toObject = function(includeInstance, msg) {
  var f, obj = {
path: (f = msg.getPath()) && proto.zelos.zoe.data_view.proto.Path.toObject(includeInstance, f),
emergencyStop: (f = msg.getEmergencyStop()) && proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.toObject(includeInstance, f),
emergencySteering: (f = msg.getEmergencySteering()) && proto.zelos.zoe.data_view.proto.EmergencySteering.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.ShieldOutput}
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.ShieldOutput;
  return proto.zelos.zoe.data_view.proto.ShieldOutput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.ShieldOutput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.ShieldOutput}
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.Path;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Path.deserializeBinaryFromReader);
      msg.setPath(value);
      break;
    case 5:
      var value = new proto.zelos.zoe.data_view.proto.ShieldEmergencyStop;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.deserializeBinaryFromReader);
      msg.setEmergencyStop(value);
      break;
    case 6:
      var value = new proto.zelos.zoe.data_view.proto.EmergencySteering;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.EmergencySteering.deserializeBinaryFromReader);
      msg.setEmergencySteering(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.ShieldOutput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.ShieldOutput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.Path.serializeBinaryToWriter
    );
  }
  f = message.getEmergencyStop();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.zelos.zoe.data_view.proto.ShieldEmergencyStop.serializeBinaryToWriter
    );
  }
  f = message.getEmergencySteering();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.zelos.zoe.data_view.proto.EmergencySteering.serializeBinaryToWriter
    );
  }
};


/**
 * optional Path path = 1;
 * @return {?proto.zelos.zoe.data_view.proto.Path}
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.getPath = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Path} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Path, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Path|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.ShieldOutput} returns this
*/
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.setPath = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.ShieldOutput} returns this
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.clearPath = function() {
  return this.setPath(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.hasPath = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ShieldEmergencyStop emergency_stop = 5;
 * @return {?proto.zelos.zoe.data_view.proto.ShieldEmergencyStop}
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.getEmergencyStop = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.ShieldEmergencyStop} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.ShieldEmergencyStop, 5));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.ShieldEmergencyStop|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.ShieldOutput} returns this
*/
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.setEmergencyStop = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.ShieldOutput} returns this
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.clearEmergencyStop = function() {
  return this.setEmergencyStop(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.hasEmergencyStop = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional EmergencySteering emergency_steering = 6;
 * @return {?proto.zelos.zoe.data_view.proto.EmergencySteering}
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.getEmergencySteering = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.EmergencySteering} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.EmergencySteering, 6));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.EmergencySteering|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.ShieldOutput} returns this
*/
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.setEmergencySteering = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.ShieldOutput} returns this
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.clearEmergencySteering = function() {
  return this.setEmergencySteering(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.ShieldOutput.prototype.hasEmergencySteering = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.RoadMark.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.RoadMark.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.RoadMark.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.RoadMark} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.RoadMark.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance),
type: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.RoadMark}
 */
proto.zelos.zoe.data_view.proto.RoadMark.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.RoadMark;
  return proto.zelos.zoe.data_view.proto.RoadMark.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.RoadMark} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.RoadMark}
 */
proto.zelos.zoe.data_view.proto.RoadMark.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    case 3:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.RoadMark.Type} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.RoadMark.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.RoadMark.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.RoadMark} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.RoadMark.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.RoadMark.Type = {
  UNKNOWN: 0,
  BIKE: 1,
  DIAMOND: 2,
  LEFT: 3,
  LEFT_RIGHT: 4,
  LEFT_UTURN: 5,
  RIGHT: 6,
  STRAIGHT: 7,
  STRAIGHT_LEFT: 8,
  STRAIGHT_LEFT_RIGHT: 9,
  STRAIGHT_RIGHT: 10,
  STRAIGHT_UTURN: 11,
  UTURN: 12,
  NO_STRAIGHT: 15,
  NO_LEFT: 16,
  NO_RIGHT: 17,
  NO_UTURN: 18
};

/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.RoadMark.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.RoadMark} returns this
 */
proto.zelos.zoe.data_view.proto.RoadMark.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Point3D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.RoadMark.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.RoadMark} returns this
*/
proto.zelos.zoe.data_view.proto.RoadMark.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.RoadMark.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.RoadMark} returns this
 */
proto.zelos.zoe.data_view.proto.RoadMark.prototype.clearPointList = function() {
  return this.setPointList([]);
};


/**
 * optional Type type = 3;
 * @return {!proto.zelos.zoe.data_view.proto.RoadMark.Type}
 */
proto.zelos.zoe.data_view.proto.RoadMark.prototype.getType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.RoadMark.Type} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.RoadMark.Type} value
 * @return {!proto.zelos.zoe.data_view.proto.RoadMark} returns this
 */
proto.zelos.zoe.data_view.proto.RoadMark.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.LocalNaviLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.LocalNaviLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance),
enableHighLight: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.LocalNaviLine}
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.LocalNaviLine;
  return proto.zelos.zoe.data_view.proto.LocalNaviLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.LocalNaviLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.LocalNaviLine}
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableHighLight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.LocalNaviLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.LocalNaviLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getEnableHighLight();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.LocalNaviLine} returns this
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Point3D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.LocalNaviLine} returns this
*/
proto.zelos.zoe.data_view.proto.LocalNaviLine.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.LocalNaviLine} returns this
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.prototype.clearPointList = function() {
  return this.setPointList([]);
};


/**
 * optional bool enable_high_light = 3;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.prototype.getEnableHighLight = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.LocalNaviLine} returns this
 */
proto.zelos.zoe.data_view.proto.LocalNaviLine.prototype.setEnableHighLight = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.EntryLine.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.EntryLine.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.EntryLine.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.EntryLine} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.EntryLine.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pointList: jspb.Message.toObjectList(msg.getPointList(),
    proto.zelos.zoe.data_view.proto.Point3D.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.EntryLine}
 */
proto.zelos.zoe.data_view.proto.EntryLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.EntryLine;
  return proto.zelos.zoe.data_view.proto.EntryLine.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.EntryLine} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.EntryLine}
 */
proto.zelos.zoe.data_view.proto.EntryLine.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.addPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.EntryLine.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.EntryLine.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.EntryLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.EntryLine.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPointList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.EntryLine.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.EntryLine} returns this
 */
proto.zelos.zoe.data_view.proto.EntryLine.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Point3D point = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Point3D>}
 */
proto.zelos.zoe.data_view.proto.EntryLine.prototype.getPointList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Point3D>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Point3D>} value
 * @return {!proto.zelos.zoe.data_view.proto.EntryLine} returns this
*/
proto.zelos.zoe.data_view.proto.EntryLine.prototype.setPointList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Point3D=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.EntryLine.prototype.addPoint = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Point3D, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.EntryLine} returns this
 */
proto.zelos.zoe.data_view.proto.EntryLine.prototype.clearPointList = function() {
  return this.setPointList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.LocalMap.repeatedFields_ = [1,2,3,4,5,6,7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.LocalMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.LocalMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.LocalMap.toObject = function(includeInstance, msg) {
  var f, obj = {
stopLineList: jspb.Message.toObjectList(msg.getStopLineList(),
    proto.zelos.zoe.data_view.proto.StopLine.toObject, includeInstance),
boundaryList: jspb.Message.toObjectList(msg.getBoundaryList(),
    proto.zelos.zoe.data_view.proto.Boundary.toObject, includeInstance),
crossWalkList: jspb.Message.toObjectList(msg.getCrossWalkList(),
    proto.zelos.zoe.data_view.proto.CrossWalk.toObject, includeInstance),
speedBumpList: jspb.Message.toObjectList(msg.getSpeedBumpList(),
    proto.zelos.zoe.data_view.proto.SpeedBump.toObject, includeInstance),
roadMarkList: jspb.Message.toObjectList(msg.getRoadMarkList(),
    proto.zelos.zoe.data_view.proto.RoadMark.toObject, includeInstance),
parkingList: jspb.Message.toObjectList(msg.getParkingList(),
    proto.zelos.zoe.data_view.proto.Parking.toObject, includeInstance),
laneList: jspb.Message.toObjectList(msg.getLaneList(),
    proto.zelos.zoe.data_view.proto.Lane.toObject, includeInstance),
localNaviLineList: jspb.Message.toObjectList(msg.getLocalNaviLineList(),
    proto.zelos.zoe.data_view.proto.LocalNaviLine.toObject, includeInstance),
entryLineList: jspb.Message.toObjectList(msg.getEntryLineList(),
    proto.zelos.zoe.data_view.proto.EntryLine.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap}
 */
proto.zelos.zoe.data_view.proto.LocalMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.LocalMap;
  return proto.zelos.zoe.data_view.proto.LocalMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.LocalMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap}
 */
proto.zelos.zoe.data_view.proto.LocalMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.StopLine;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.StopLine.deserializeBinaryFromReader);
      msg.addStopLine(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Boundary;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Boundary.deserializeBinaryFromReader);
      msg.addBoundary(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.CrossWalk;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.CrossWalk.deserializeBinaryFromReader);
      msg.addCrossWalk(value);
      break;
    case 4:
      var value = new proto.zelos.zoe.data_view.proto.SpeedBump;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.SpeedBump.deserializeBinaryFromReader);
      msg.addSpeedBump(value);
      break;
    case 5:
      var value = new proto.zelos.zoe.data_view.proto.RoadMark;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.RoadMark.deserializeBinaryFromReader);
      msg.addRoadMark(value);
      break;
    case 6:
      var value = new proto.zelos.zoe.data_view.proto.Parking;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Parking.deserializeBinaryFromReader);
      msg.addParking(value);
      break;
    case 7:
      var value = new proto.zelos.zoe.data_view.proto.Lane;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Lane.deserializeBinaryFromReader);
      msg.addLane(value);
      break;
    case 8:
      var value = new proto.zelos.zoe.data_view.proto.LocalNaviLine;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.LocalNaviLine.deserializeBinaryFromReader);
      msg.addLocalNaviLine(value);
      break;
    case 9:
      var value = new proto.zelos.zoe.data_view.proto.EntryLine;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.EntryLine.deserializeBinaryFromReader);
      msg.addEntryLine(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.LocalMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.LocalMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.LocalMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStopLineList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.StopLine.serializeBinaryToWriter
    );
  }
  f = message.getBoundaryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Boundary.serializeBinaryToWriter
    );
  }
  f = message.getCrossWalkList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.CrossWalk.serializeBinaryToWriter
    );
  }
  f = message.getSpeedBumpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.zelos.zoe.data_view.proto.SpeedBump.serializeBinaryToWriter
    );
  }
  f = message.getRoadMarkList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.zelos.zoe.data_view.proto.RoadMark.serializeBinaryToWriter
    );
  }
  f = message.getParkingList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.zelos.zoe.data_view.proto.Parking.serializeBinaryToWriter
    );
  }
  f = message.getLaneList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.zelos.zoe.data_view.proto.Lane.serializeBinaryToWriter
    );
  }
  f = message.getLocalNaviLineList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.zelos.zoe.data_view.proto.LocalNaviLine.serializeBinaryToWriter
    );
  }
  f = message.getEntryLineList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.zelos.zoe.data_view.proto.EntryLine.serializeBinaryToWriter
    );
  }
};


/**
 * repeated StopLine stop_line = 1;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.StopLine>}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.getStopLineList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.StopLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.StopLine, 1));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.StopLine>} value
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
*/
proto.zelos.zoe.data_view.proto.LocalMap.prototype.setStopLineList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.StopLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.StopLine}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.addStopLine = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.zelos.zoe.data_view.proto.StopLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.clearStopLineList = function() {
  return this.setStopLineList([]);
};


/**
 * repeated Boundary boundary = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Boundary>}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.getBoundaryList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Boundary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Boundary, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Boundary>} value
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
*/
proto.zelos.zoe.data_view.proto.LocalMap.prototype.setBoundaryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Boundary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Boundary}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.addBoundary = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.Boundary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.clearBoundaryList = function() {
  return this.setBoundaryList([]);
};


/**
 * repeated CrossWalk cross_walk = 3;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.CrossWalk>}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.getCrossWalkList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.CrossWalk>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.CrossWalk, 3));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.CrossWalk>} value
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
*/
proto.zelos.zoe.data_view.proto.LocalMap.prototype.setCrossWalkList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.CrossWalk=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.CrossWalk}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.addCrossWalk = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.zelos.zoe.data_view.proto.CrossWalk, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.clearCrossWalkList = function() {
  return this.setCrossWalkList([]);
};


/**
 * repeated SpeedBump speed_bump = 4;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.SpeedBump>}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.getSpeedBumpList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.SpeedBump>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.SpeedBump, 4));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.SpeedBump>} value
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
*/
proto.zelos.zoe.data_view.proto.LocalMap.prototype.setSpeedBumpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.SpeedBump=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.SpeedBump}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.addSpeedBump = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.zelos.zoe.data_view.proto.SpeedBump, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.clearSpeedBumpList = function() {
  return this.setSpeedBumpList([]);
};


/**
 * repeated RoadMark road_mark = 5;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.RoadMark>}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.getRoadMarkList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.RoadMark>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.RoadMark, 5));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.RoadMark>} value
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
*/
proto.zelos.zoe.data_view.proto.LocalMap.prototype.setRoadMarkList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.RoadMark=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.RoadMark}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.addRoadMark = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.zelos.zoe.data_view.proto.RoadMark, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.clearRoadMarkList = function() {
  return this.setRoadMarkList([]);
};


/**
 * repeated Parking parking = 6;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Parking>}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.getParkingList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Parking>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Parking, 6));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Parking>} value
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
*/
proto.zelos.zoe.data_view.proto.LocalMap.prototype.setParkingList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Parking=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Parking}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.addParking = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.zelos.zoe.data_view.proto.Parking, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.clearParkingList = function() {
  return this.setParkingList([]);
};


/**
 * repeated Lane lane = 7;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Lane>}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.getLaneList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Lane>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Lane, 7));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Lane>} value
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
*/
proto.zelos.zoe.data_view.proto.LocalMap.prototype.setLaneList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Lane=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Lane}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.addLane = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.zelos.zoe.data_view.proto.Lane, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.clearLaneList = function() {
  return this.setLaneList([]);
};


/**
 * repeated LocalNaviLine local_navi_line = 8;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.LocalNaviLine>}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.getLocalNaviLineList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.LocalNaviLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.LocalNaviLine, 8));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.LocalNaviLine>} value
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
*/
proto.zelos.zoe.data_view.proto.LocalMap.prototype.setLocalNaviLineList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.LocalNaviLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.LocalNaviLine}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.addLocalNaviLine = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.zelos.zoe.data_view.proto.LocalNaviLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.clearLocalNaviLineList = function() {
  return this.setLocalNaviLineList([]);
};


/**
 * repeated EntryLine entry_line = 9;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.EntryLine>}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.getEntryLineList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.EntryLine>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.EntryLine, 9));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.EntryLine>} value
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
*/
proto.zelos.zoe.data_view.proto.LocalMap.prototype.setEntryLineList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.EntryLine=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.EntryLine}
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.addEntryLine = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.zelos.zoe.data_view.proto.EntryLine, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.LocalMap} returns this
 */
proto.zelos.zoe.data_view.proto.LocalMap.prototype.clearEntryLineList = function() {
  return this.setEntryLineList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.TrafficSign.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.TrafficSign.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.TrafficSign} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.TrafficSign.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
location: (f = msg.getLocation()) && proto.zelos.zoe.data_view.proto.Point3D.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.TrafficSign}
 */
proto.zelos.zoe.data_view.proto.TrafficSign.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.TrafficSign;
  return proto.zelos.zoe.data_view.proto.TrafficSign.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.TrafficSign} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.TrafficSign}
 */
proto.zelos.zoe.data_view.proto.TrafficSign.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.TrafficSignType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.setLocation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.TrafficSign.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.TrafficSign.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.TrafficSign} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.TrafficSign.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLocation();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.TrafficSign.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficSign} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficSign.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional TrafficSignType type = 2;
 * @return {!proto.zelos.zoe.data_view.proto.TrafficSignType}
 */
proto.zelos.zoe.data_view.proto.TrafficSign.prototype.getType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.TrafficSignType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.TrafficSignType} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficSign} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficSign.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Point3D location = 3;
 * @return {?proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.TrafficSign.prototype.getLocation = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Point3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 3));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Point3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.TrafficSign} returns this
*/
proto.zelos.zoe.data_view.proto.TrafficSign.prototype.setLocation = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.TrafficSign} returns this
 */
proto.zelos.zoe.data_view.proto.TrafficSign.prototype.clearLocation = function() {
  return this.setLocation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.TrafficSign.prototype.hasLocation = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.TrackList.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.TrackList.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.TrackList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.TrackList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.TrackList.toObject = function(includeInstance, msg) {
  var f, obj = {
trafficSignList: jspb.Message.toObjectList(msg.getTrafficSignList(),
    proto.zelos.zoe.data_view.proto.TrafficSign.toObject, includeInstance),
movableGateList: jspb.Message.toObjectList(msg.getMovableGateList(),
    proto.zelos.zoe.data_view.proto.MovableGate.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.TrackList}
 */
proto.zelos.zoe.data_view.proto.TrackList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.TrackList;
  return proto.zelos.zoe.data_view.proto.TrackList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.TrackList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.TrackList}
 */
proto.zelos.zoe.data_view.proto.TrackList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.TrafficSign;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.TrafficSign.deserializeBinaryFromReader);
      msg.addTrafficSign(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.MovableGate;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.MovableGate.deserializeBinaryFromReader);
      msg.addMovableGate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.TrackList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.TrackList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.TrackList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.TrackList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrafficSignList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.TrafficSign.serializeBinaryToWriter
    );
  }
  f = message.getMovableGateList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.MovableGate.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TrafficSign traffic_sign = 1;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.TrafficSign>}
 */
proto.zelos.zoe.data_view.proto.TrackList.prototype.getTrafficSignList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.TrafficSign>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.TrafficSign, 1));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.TrafficSign>} value
 * @return {!proto.zelos.zoe.data_view.proto.TrackList} returns this
*/
proto.zelos.zoe.data_view.proto.TrackList.prototype.setTrafficSignList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.TrafficSign=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.TrafficSign}
 */
proto.zelos.zoe.data_view.proto.TrackList.prototype.addTrafficSign = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.zelos.zoe.data_view.proto.TrafficSign, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.TrackList} returns this
 */
proto.zelos.zoe.data_view.proto.TrackList.prototype.clearTrafficSignList = function() {
  return this.setTrafficSignList([]);
};


/**
 * repeated MovableGate movable_gate = 2;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.MovableGate>}
 */
proto.zelos.zoe.data_view.proto.TrackList.prototype.getMovableGateList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.MovableGate>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.MovableGate, 2));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.MovableGate>} value
 * @return {!proto.zelos.zoe.data_view.proto.TrackList} returns this
*/
proto.zelos.zoe.data_view.proto.TrackList.prototype.setMovableGateList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.MovableGate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate}
 */
proto.zelos.zoe.data_view.proto.TrackList.prototype.addMovableGate = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.zelos.zoe.data_view.proto.MovableGate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.TrackList} returns this
 */
proto.zelos.zoe.data_view.proto.TrackList.prototype.clearMovableGateList = function() {
  return this.setMovableGateList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Scene.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Scene.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Scene} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Scene.toObject = function(includeInstance, msg) {
  var f, obj = {
roadType: jspb.Message.getFieldWithDefault(msg, 1, 0),
sensorAnomalyDetection: (f = msg.getSensorAnomalyDetection()) && proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.toObject(includeInstance, f),
sceneType: jspb.Message.getFieldWithDefault(msg, 6, 0),
calibrationDetection: (f = msg.getCalibrationDetection()) && proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Scene}
 */
proto.zelos.zoe.data_view.proto.Scene.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Scene;
  return proto.zelos.zoe.data_view.proto.Scene.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Scene} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Scene}
 */
proto.zelos.zoe.data_view.proto.Scene.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.RoadType} */ (reader.readEnum());
      msg.setRoadType(value);
      break;
    case 5:
      var value = new proto.zelos.zoe.data_view.proto.SensorAnomalyDetection;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.deserializeBinaryFromReader);
      msg.setSensorAnomalyDetection(value);
      break;
    case 6:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.SceneType} */ (reader.readEnum());
      msg.setSceneType(value);
      break;
    case 7:
      var value = new proto.zelos.zoe.data_view.proto.SensorAnomalyDetection;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.deserializeBinaryFromReader);
      msg.setCalibrationDetection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Scene.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Scene.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Scene} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Scene.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoadType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSensorAnomalyDetection();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.serializeBinaryToWriter
    );
  }
  f = message.getSceneType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getCalibrationDetection();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.zelos.zoe.data_view.proto.SensorAnomalyDetection.serializeBinaryToWriter
    );
  }
};


/**
 * optional RoadType road_type = 1;
 * @return {!proto.zelos.zoe.data_view.proto.RoadType}
 */
proto.zelos.zoe.data_view.proto.Scene.prototype.getRoadType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.RoadType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.RoadType} value
 * @return {!proto.zelos.zoe.data_view.proto.Scene} returns this
 */
proto.zelos.zoe.data_view.proto.Scene.prototype.setRoadType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional SensorAnomalyDetection sensor_anomaly_detection = 5;
 * @return {?proto.zelos.zoe.data_view.proto.SensorAnomalyDetection}
 */
proto.zelos.zoe.data_view.proto.Scene.prototype.getSensorAnomalyDetection = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.SensorAnomalyDetection} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.SensorAnomalyDetection, 5));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.SensorAnomalyDetection|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Scene} returns this
*/
proto.zelos.zoe.data_view.proto.Scene.prototype.setSensorAnomalyDetection = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Scene} returns this
 */
proto.zelos.zoe.data_view.proto.Scene.prototype.clearSensorAnomalyDetection = function() {
  return this.setSensorAnomalyDetection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Scene.prototype.hasSensorAnomalyDetection = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional SceneType scene_type = 6;
 * @return {!proto.zelos.zoe.data_view.proto.SceneType}
 */
proto.zelos.zoe.data_view.proto.Scene.prototype.getSceneType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.SceneType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.SceneType} value
 * @return {!proto.zelos.zoe.data_view.proto.Scene} returns this
 */
proto.zelos.zoe.data_view.proto.Scene.prototype.setSceneType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional SensorAnomalyDetection calibration_detection = 7;
 * @return {?proto.zelos.zoe.data_view.proto.SensorAnomalyDetection}
 */
proto.zelos.zoe.data_view.proto.Scene.prototype.getCalibrationDetection = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.SensorAnomalyDetection} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.SensorAnomalyDetection, 7));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.SensorAnomalyDetection|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Scene} returns this
*/
proto.zelos.zoe.data_view.proto.Scene.prototype.setCalibrationDetection = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Scene} returns this
 */
proto.zelos.zoe.data_view.proto.Scene.prototype.clearCalibrationDetection = function() {
  return this.setCalibrationDetection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Scene.prototype.hasCalibrationDetection = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.MovableGate.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.MovableGate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.MovableGate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MovableGate.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, 0),
gateType: jspb.Message.getFieldWithDefault(msg, 2, 0),
startPosition: (f = msg.getStartPosition()) && proto.zelos.zoe.data_view.proto.Point3D.toObject(includeInstance, f),
endPosition: (f = msg.getEndPosition()) && proto.zelos.zoe.data_view.proto.Point3D.toObject(includeInstance, f),
movingStatus: jspb.Message.getFieldWithDefault(msg, 5, 0),
age: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
specialStateList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate}
 */
proto.zelos.zoe.data_view.proto.MovableGate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.MovableGate;
  return proto.zelos.zoe.data_view.proto.MovableGate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.MovableGate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate}
 */
proto.zelos.zoe.data_view.proto.MovableGate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.GateType} */ (reader.readEnum());
      msg.setGateType(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.setStartPosition(value);
      break;
    case 4:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.setEndPosition(value);
      break;
    case 5:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.GateMovingStatus} */ (reader.readEnum());
      msg.setMovingStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAge(value);
      break;
    case 7:
      var values = /** @type {!Array<!proto.zelos.zoe.data_view.proto.GateSpecialState>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addSpecialState(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.MovableGate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.MovableGate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MovableGate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getGateType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStartPosition();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getEndPosition();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getMovingStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getAge();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getSpecialStateList();
  if (f.length > 0) {
    writer.writePackedEnum(
      7,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate} returns this
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional GateType gate_type = 2;
 * @return {!proto.zelos.zoe.data_view.proto.GateType}
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.getGateType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.GateType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.GateType} value
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate} returns this
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.setGateType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Point3D start_position = 3;
 * @return {?proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.getStartPosition = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Point3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 3));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Point3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate} returns this
*/
proto.zelos.zoe.data_view.proto.MovableGate.prototype.setStartPosition = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate} returns this
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.clearStartPosition = function() {
  return this.setStartPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.hasStartPosition = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Point3D end_position = 4;
 * @return {?proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.getEndPosition = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Point3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 4));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Point3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate} returns this
*/
proto.zelos.zoe.data_view.proto.MovableGate.prototype.setEndPosition = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate} returns this
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.clearEndPosition = function() {
  return this.setEndPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.hasEndPosition = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional GateMovingStatus moving_status = 5;
 * @return {!proto.zelos.zoe.data_view.proto.GateMovingStatus}
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.getMovingStatus = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.GateMovingStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.GateMovingStatus} value
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate} returns this
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.setMovingStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional float age = 6;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.getAge = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate} returns this
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.setAge = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * repeated GateSpecialState special_state = 7;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.GateSpecialState>}
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.getSpecialStateList = function() {
  return /** @type {!Array<!proto.zelos.zoe.data_view.proto.GateSpecialState>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.GateSpecialState>} value
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate} returns this
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.setSpecialStateList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.GateSpecialState} value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate} returns this
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.addSpecialState = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MovableGate} returns this
 */
proto.zelos.zoe.data_view.proto.MovableGate.prototype.clearSpecialStateList = function() {
  return this.setSpecialStateList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.VehicleData.repeatedFields_ = [5,6,16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.VehicleData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.VehicleData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleData.toObject = function(includeInstance, msg) {
  var f, obj = {
origin: (f = msg.getOrigin()) && proto.zelos.zoe.data_view.proto.Point3D.toObject(includeInstance, f),
vehicle: (f = msg.getVehicle()) && proto.zelos.zoe.data_view.proto.Vehicle.toObject(includeInstance, f),
planning: (f = msg.getPlanning()) && proto.zelos.zoe.data_view.proto.Planning.toObject(includeInstance, f),
routing: (f = msg.getRouting()) && proto.zelos.zoe.data_view.proto.Routing.toObject(includeInstance, f),
trafficLightList: jspb.Message.toObjectList(msg.getTrafficLightList(),
    proto.zelos.zoe.data_view.proto.TrafficLight.toObject, includeInstance),
obstacleList: jspb.Message.toObjectList(msg.getObstacleList(),
    proto.zelos.zoe.data_view.proto.Obstacle.toObject, includeInstance),
overwriteMode: jspb.Message.getFieldWithDefault(msg, 10, 0),
controlDebugData: (f = msg.getControlDebugData()) && proto.zelos.zoe.data_view.proto.ControlDebugData.toObject(includeInstance, f),
locMode: jspb.Message.getFieldWithDefault(msg, 12, 0),
overallSeverity: jspb.Message.getFieldWithDefault(msg, 13, 0),
weatherType: jspb.Message.getFieldWithDefault(msg, 14, 0),
weatherCommand: jspb.Message.getFieldWithDefault(msg, 15, 0),
metricDataFrameList: jspb.Message.toObjectList(msg.getMetricDataFrameList(),
    proto.zelos.zoe.data_view.proto.MetricDataFrame.toObject, includeInstance),
localization: (f = msg.getLocalization()) && proto.zelos.zoe.data_view.proto.Localization.toObject(includeInstance, f),
vehicleMotion: (f = msg.getVehicleMotion()) && proto.zelos.zoe.data_view.proto.VehicleMotion.toObject(includeInstance, f),
trackList: (f = msg.getTrackList()) && proto.zelos.zoe.data_view.proto.TrackList.toObject(includeInstance, f),
scene: (f = msg.getScene()) && proto.zelos.zoe.data_view.proto.Scene.toObject(includeInstance, f),
vehicleParam: (f = msg.getVehicleParam()) && proto.zelos.zoe.data_view.proto.VehicleParam.toObject(includeInstance, f),
shieldOutput: (f = msg.getShieldOutput()) && proto.zelos.zoe.data_view.proto.ShieldOutput.toObject(includeInstance, f),
ultrasonicData: (f = msg.getUltrasonicData()) && proto.zelos.zoe.data_view.proto.UltrasonicData.toObject(includeInstance, f),
vehicleCalibration: (f = msg.getVehicleCalibration()) && proto.zelos.zoe.data_view.proto.VehicleCalibration.toObject(includeInstance, f),
vehicleTrajectory: (f = msg.getVehicleTrajectory()) && proto.zelos.zoe.data_view.proto.VehicleTrajectory.toObject(includeInstance, f),
businessResult: (f = msg.getBusinessResult()) && proto.zelos.zoe.data_view.proto.BusinessInfo.toObject(includeInstance, f),
localMap: (f = msg.getLocalMap()) && proto.zelos.zoe.data_view.proto.LocalMap.toObject(includeInstance, f),
isNewProtocol: jspb.Message.getBooleanFieldWithDefault(msg, 36, false),
gpsInfo: (f = msg.getGpsInfo()) && proto.zelos.zoe.data_view.proto.GpsInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData}
 */
proto.zelos.zoe.data_view.proto.VehicleData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.VehicleData;
  return proto.zelos.zoe.data_view.proto.VehicleData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData}
 */
proto.zelos.zoe.data_view.proto.VehicleData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.setOrigin(value);
      break;
    case 2:
      var value = new proto.zelos.zoe.data_view.proto.Vehicle;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Vehicle.deserializeBinaryFromReader);
      msg.setVehicle(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.Planning;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Planning.deserializeBinaryFromReader);
      msg.setPlanning(value);
      break;
    case 4:
      var value = new proto.zelos.zoe.data_view.proto.Routing;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Routing.deserializeBinaryFromReader);
      msg.setRouting(value);
      break;
    case 5:
      var value = new proto.zelos.zoe.data_view.proto.TrafficLight;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.TrafficLight.deserializeBinaryFromReader);
      msg.addTrafficLight(value);
      break;
    case 6:
      var value = new proto.zelos.zoe.data_view.proto.Obstacle;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Obstacle.deserializeBinaryFromReader);
      msg.addObstacle(value);
      break;
    case 10:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.OverwriteType} */ (reader.readEnum());
      msg.setOverwriteMode(value);
      break;
    case 11:
      var value = new proto.zelos.zoe.data_view.proto.ControlDebugData;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.ControlDebugData.deserializeBinaryFromReader);
      msg.setControlDebugData(value);
      break;
    case 12:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.VehicleData.LocMode} */ (reader.readEnum());
      msg.setLocMode(value);
      break;
    case 13:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.VehicleData.AnomalySeverity} */ (reader.readEnum());
      msg.setOverallSeverity(value);
      break;
    case 14:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.VehicleData.WeatherType} */ (reader.readEnum());
      msg.setWeatherType(value);
      break;
    case 15:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.VehicleData.WeatherCommand} */ (reader.readEnum());
      msg.setWeatherCommand(value);
      break;
    case 16:
      var value = new proto.zelos.zoe.data_view.proto.MetricDataFrame;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.MetricDataFrame.deserializeBinaryFromReader);
      msg.addMetricDataFrame(value);
      break;
    case 17:
      var value = new proto.zelos.zoe.data_view.proto.Localization;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Localization.deserializeBinaryFromReader);
      msg.setLocalization(value);
      break;
    case 18:
      var value = new proto.zelos.zoe.data_view.proto.VehicleMotion;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VehicleMotion.deserializeBinaryFromReader);
      msg.setVehicleMotion(value);
      break;
    case 20:
      var value = new proto.zelos.zoe.data_view.proto.TrackList;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.TrackList.deserializeBinaryFromReader);
      msg.setTrackList(value);
      break;
    case 21:
      var value = new proto.zelos.zoe.data_view.proto.Scene;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Scene.deserializeBinaryFromReader);
      msg.setScene(value);
      break;
    case 23:
      var value = new proto.zelos.zoe.data_view.proto.VehicleParam;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VehicleParam.deserializeBinaryFromReader);
      msg.setVehicleParam(value);
      break;
    case 24:
      var value = new proto.zelos.zoe.data_view.proto.ShieldOutput;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.ShieldOutput.deserializeBinaryFromReader);
      msg.setShieldOutput(value);
      break;
    case 28:
      var value = new proto.zelos.zoe.data_view.proto.UltrasonicData;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.UltrasonicData.deserializeBinaryFromReader);
      msg.setUltrasonicData(value);
      break;
    case 29:
      var value = new proto.zelos.zoe.data_view.proto.VehicleCalibration;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VehicleCalibration.deserializeBinaryFromReader);
      msg.setVehicleCalibration(value);
      break;
    case 30:
      var value = new proto.zelos.zoe.data_view.proto.VehicleTrajectory;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VehicleTrajectory.deserializeBinaryFromReader);
      msg.setVehicleTrajectory(value);
      break;
    case 32:
      var value = new proto.zelos.zoe.data_view.proto.BusinessInfo;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.BusinessInfo.deserializeBinaryFromReader);
      msg.setBusinessResult(value);
      break;
    case 33:
      var value = new proto.zelos.zoe.data_view.proto.LocalMap;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.LocalMap.deserializeBinaryFromReader);
      msg.setLocalMap(value);
      break;
    case 36:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsNewProtocol(value);
      break;
    case 37:
      var value = new proto.zelos.zoe.data_view.proto.GpsInfo;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.GpsInfo.deserializeBinaryFromReader);
      msg.setGpsInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.VehicleData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.VehicleData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.VehicleData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrigin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getVehicle();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.zelos.zoe.data_view.proto.Vehicle.serializeBinaryToWriter
    );
  }
  f = message.getPlanning();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.Planning.serializeBinaryToWriter
    );
  }
  f = message.getRouting();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.zelos.zoe.data_view.proto.Routing.serializeBinaryToWriter
    );
  }
  f = message.getTrafficLightList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.zelos.zoe.data_view.proto.TrafficLight.serializeBinaryToWriter
    );
  }
  f = message.getObstacleList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.zelos.zoe.data_view.proto.Obstacle.serializeBinaryToWriter
    );
  }
  f = message.getOverwriteMode();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getControlDebugData();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.zelos.zoe.data_view.proto.ControlDebugData.serializeBinaryToWriter
    );
  }
  f = message.getLocMode();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getOverallSeverity();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getWeatherType();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getWeatherCommand();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getMetricDataFrameList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.zelos.zoe.data_view.proto.MetricDataFrame.serializeBinaryToWriter
    );
  }
  f = message.getLocalization();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.zelos.zoe.data_view.proto.Localization.serializeBinaryToWriter
    );
  }
  f = message.getVehicleMotion();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.zelos.zoe.data_view.proto.VehicleMotion.serializeBinaryToWriter
    );
  }
  f = message.getTrackList();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.zelos.zoe.data_view.proto.TrackList.serializeBinaryToWriter
    );
  }
  f = message.getScene();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.zelos.zoe.data_view.proto.Scene.serializeBinaryToWriter
    );
  }
  f = message.getVehicleParam();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.zelos.zoe.data_view.proto.VehicleParam.serializeBinaryToWriter
    );
  }
  f = message.getShieldOutput();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.zelos.zoe.data_view.proto.ShieldOutput.serializeBinaryToWriter
    );
  }
  f = message.getUltrasonicData();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      proto.zelos.zoe.data_view.proto.UltrasonicData.serializeBinaryToWriter
    );
  }
  f = message.getVehicleCalibration();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      proto.zelos.zoe.data_view.proto.VehicleCalibration.serializeBinaryToWriter
    );
  }
  f = message.getVehicleTrajectory();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      proto.zelos.zoe.data_view.proto.VehicleTrajectory.serializeBinaryToWriter
    );
  }
  f = message.getBusinessResult();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      proto.zelos.zoe.data_view.proto.BusinessInfo.serializeBinaryToWriter
    );
  }
  f = message.getLocalMap();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      proto.zelos.zoe.data_view.proto.LocalMap.serializeBinaryToWriter
    );
  }
  f = message.getIsNewProtocol();
  if (f) {
    writer.writeBool(
      36,
      f
    );
  }
  f = message.getGpsInfo();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      proto.zelos.zoe.data_view.proto.GpsInfo.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.VehicleData.LocMode = {
  MODE_GLOBAL: 0,
  MODE_LOCAL: 1,
  MODE_NOMAP: 3,
  MODE_NOA: 4,
  MODE_SDMAP: 5
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.VehicleData.AnomalySeverity = {
  SEVERITY_UNKNOWN: 0,
  SEVERITY_NORMAL: 1,
  SEVERITY_WARNING: 2,
  SEVERITY_ERROR: 3,
  SEVERITY_FATAL: 4,
  SEVERITY_INVALID: 99
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.VehicleData.WeatherType = {
  WEATHER_INVALID: 0,
  WEATHER_NORMAL: 1,
  WEATHER_RAIN: 2,
  WEATHER_FOG: 3,
  WEATHER_SNOW: 4,
  WEATHER_HEAVY_RAIN: 5,
  WEATHER_LIGHT_SNOW: 6,
  WEATHER_HEAVY_FOG: 7,
  WEATHER_TYPE_MAX: 101
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.VehicleData.WeatherCommand = {
  COMMAND_INVALID: 0,
  COMMAND_AUTO: 1,
  COMMAND_OFF: 2,
  COMMAND_RAIN: 3,
  COMMAND_FOG: 4,
  COMMAND_SNOW: 5,
  COMMAND_HEAVY_RAIN: 6,
  COMMAND_LIGHT_SNOW: 7,
  COMMAND_NORMAL: 8,
  COMMAND_HEAVY_FOG: 9,
  COMMAND_MAX: 101
};

/**
 * optional Point3D origin = 1;
 * @return {?proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getOrigin = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Point3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Point3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setOrigin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearOrigin = function() {
  return this.setOrigin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasOrigin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Vehicle vehicle = 2;
 * @return {?proto.zelos.zoe.data_view.proto.Vehicle}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getVehicle = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Vehicle} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Vehicle, 2));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Vehicle|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setVehicle = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearVehicle = function() {
  return this.setVehicle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasVehicle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Planning planning = 3;
 * @return {?proto.zelos.zoe.data_view.proto.Planning}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getPlanning = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Planning} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Planning, 3));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Planning|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setPlanning = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearPlanning = function() {
  return this.setPlanning(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasPlanning = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Routing routing = 4;
 * @return {?proto.zelos.zoe.data_view.proto.Routing}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getRouting = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Routing} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Routing, 4));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Routing|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setRouting = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearRouting = function() {
  return this.setRouting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasRouting = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated TrafficLight traffic_light = 5;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.TrafficLight>}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getTrafficLightList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.TrafficLight>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.TrafficLight, 5));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.TrafficLight>} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setTrafficLightList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.TrafficLight=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.TrafficLight}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.addTrafficLight = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.zelos.zoe.data_view.proto.TrafficLight, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearTrafficLightList = function() {
  return this.setTrafficLightList([]);
};


/**
 * repeated Obstacle obstacle = 6;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.Obstacle>}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getObstacleList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.Obstacle>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.Obstacle, 6));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.Obstacle>} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setObstacleList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Obstacle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.Obstacle}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.addObstacle = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.zelos.zoe.data_view.proto.Obstacle, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearObstacleList = function() {
  return this.setObstacleList([]);
};


/**
 * optional OverwriteType overwrite_mode = 10;
 * @return {!proto.zelos.zoe.data_view.proto.OverwriteType}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getOverwriteMode = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.OverwriteType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.OverwriteType} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setOverwriteMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional ControlDebugData control_debug_data = 11;
 * @return {?proto.zelos.zoe.data_view.proto.ControlDebugData}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getControlDebugData = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.ControlDebugData} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.ControlDebugData, 11));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.ControlDebugData|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setControlDebugData = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearControlDebugData = function() {
  return this.setControlDebugData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasControlDebugData = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional LocMode loc_mode = 12;
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData.LocMode}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getLocMode = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.VehicleData.LocMode} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.VehicleData.LocMode} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setLocMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional AnomalySeverity overall_severity = 13;
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData.AnomalySeverity}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getOverallSeverity = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.VehicleData.AnomalySeverity} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.VehicleData.AnomalySeverity} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setOverallSeverity = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional WeatherType weather_type = 14;
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData.WeatherType}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getWeatherType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.VehicleData.WeatherType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.VehicleData.WeatherType} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setWeatherType = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional WeatherCommand weather_command = 15;
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData.WeatherCommand}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getWeatherCommand = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.VehicleData.WeatherCommand} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.VehicleData.WeatherCommand} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setWeatherCommand = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * repeated MetricDataFrame metric_data_frame = 16;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.MetricDataFrame>}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getMetricDataFrameList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.MetricDataFrame>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.MetricDataFrame, 16));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.MetricDataFrame>} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setMetricDataFrameList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.MetricDataFrame=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.MetricDataFrame}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.addMetricDataFrame = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.zelos.zoe.data_view.proto.MetricDataFrame, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearMetricDataFrameList = function() {
  return this.setMetricDataFrameList([]);
};


/**
 * optional Localization localization = 17;
 * @return {?proto.zelos.zoe.data_view.proto.Localization}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getLocalization = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Localization} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Localization, 17));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Localization|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setLocalization = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearLocalization = function() {
  return this.setLocalization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasLocalization = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional VehicleMotion vehicle_motion = 18;
 * @return {?proto.zelos.zoe.data_view.proto.VehicleMotion}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getVehicleMotion = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.VehicleMotion} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.VehicleMotion, 18));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.VehicleMotion|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setVehicleMotion = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearVehicleMotion = function() {
  return this.setVehicleMotion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasVehicleMotion = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional TrackList track_list = 20;
 * @return {?proto.zelos.zoe.data_view.proto.TrackList}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getTrackList = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.TrackList} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.TrackList, 20));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.TrackList|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setTrackList = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearTrackList = function() {
  return this.setTrackList(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasTrackList = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional Scene scene = 21;
 * @return {?proto.zelos.zoe.data_view.proto.Scene}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getScene = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Scene} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Scene, 21));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Scene|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setScene = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearScene = function() {
  return this.setScene(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasScene = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional VehicleParam vehicle_param = 23;
 * @return {?proto.zelos.zoe.data_view.proto.VehicleParam}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getVehicleParam = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.VehicleParam} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.VehicleParam, 23));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.VehicleParam|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setVehicleParam = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearVehicleParam = function() {
  return this.setVehicleParam(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasVehicleParam = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional ShieldOutput shield_output = 24;
 * @return {?proto.zelos.zoe.data_view.proto.ShieldOutput}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getShieldOutput = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.ShieldOutput} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.ShieldOutput, 24));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.ShieldOutput|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setShieldOutput = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearShieldOutput = function() {
  return this.setShieldOutput(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasShieldOutput = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional UltrasonicData ultrasonic_data = 28;
 * @return {?proto.zelos.zoe.data_view.proto.UltrasonicData}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getUltrasonicData = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.UltrasonicData} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.UltrasonicData, 28));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.UltrasonicData|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setUltrasonicData = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearUltrasonicData = function() {
  return this.setUltrasonicData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasUltrasonicData = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional VehicleCalibration vehicle_calibration = 29;
 * @return {?proto.zelos.zoe.data_view.proto.VehicleCalibration}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getVehicleCalibration = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.VehicleCalibration} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.VehicleCalibration, 29));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.VehicleCalibration|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setVehicleCalibration = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearVehicleCalibration = function() {
  return this.setVehicleCalibration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasVehicleCalibration = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional VehicleTrajectory vehicle_trajectory = 30;
 * @return {?proto.zelos.zoe.data_view.proto.VehicleTrajectory}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getVehicleTrajectory = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.VehicleTrajectory} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.VehicleTrajectory, 30));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.VehicleTrajectory|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setVehicleTrajectory = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearVehicleTrajectory = function() {
  return this.setVehicleTrajectory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasVehicleTrajectory = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional BusinessInfo business_result = 32;
 * @return {?proto.zelos.zoe.data_view.proto.BusinessInfo}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getBusinessResult = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.BusinessInfo} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.BusinessInfo, 32));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.BusinessInfo|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setBusinessResult = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearBusinessResult = function() {
  return this.setBusinessResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasBusinessResult = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional LocalMap local_map = 33;
 * @return {?proto.zelos.zoe.data_view.proto.LocalMap}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getLocalMap = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.LocalMap} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.LocalMap, 33));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.LocalMap|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setLocalMap = function(value) {
  return jspb.Message.setWrapperField(this, 33, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearLocalMap = function() {
  return this.setLocalMap(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasLocalMap = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional bool is_new_protocol = 36;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getIsNewProtocol = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 36, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setIsNewProtocol = function(value) {
  return jspb.Message.setProto3BooleanField(this, 36, value);
};


/**
 * optional GpsInfo gps_info = 37;
 * @return {?proto.zelos.zoe.data_view.proto.GpsInfo}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.getGpsInfo = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.GpsInfo} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.GpsInfo, 37));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.GpsInfo|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
*/
proto.zelos.zoe.data_view.proto.VehicleData.prototype.setGpsInfo = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.VehicleData} returns this
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.clearGpsInfo = function() {
  return this.setGpsInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.VehicleData.prototype.hasGpsInfo = function() {
  return jspb.Message.getField(this, 37) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.repeatedFields_ = [10];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.MetricDataFrame.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.MetricDataFrame} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.toObject = function(includeInstance, msg) {
  var f, obj = {
metricName: jspb.Message.getFieldWithDefault(msg, 1, ""),
metricLineDataList: jspb.Message.toObjectList(msg.getMetricLineDataList(),
    proto.zelos.zoe.data_view.proto.MetricLineData.toObject, includeInstance),
timestamp: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
scaleFactor: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.MetricDataFrame}
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.MetricDataFrame;
  return proto.zelos.zoe.data_view.proto.MetricDataFrame.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.MetricDataFrame} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.MetricDataFrame}
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetricName(value);
      break;
    case 10:
      var value = new proto.zelos.zoe.data_view.proto.MetricLineData;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.MetricLineData.deserializeBinaryFromReader);
      msg.addMetricLineData(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTimestamp(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScaleFactor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.MetricDataFrame.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.MetricDataFrame} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetricName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMetricLineDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.zelos.zoe.data_view.proto.MetricLineData.serializeBinaryToWriter
    );
  }
  f = message.getTimestamp();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getScaleFactor();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
};


/**
 * optional string metric_name = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.prototype.getMetricName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.MetricDataFrame} returns this
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.prototype.setMetricName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated MetricLineData metric_line_data = 10;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.MetricLineData>}
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.prototype.getMetricLineDataList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.MetricLineData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.MetricLineData, 10));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.MetricLineData>} value
 * @return {!proto.zelos.zoe.data_view.proto.MetricDataFrame} returns this
*/
proto.zelos.zoe.data_view.proto.MetricDataFrame.prototype.setMetricLineDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.MetricLineData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.MetricLineData}
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.prototype.addMetricLineData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.zelos.zoe.data_view.proto.MetricLineData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MetricDataFrame} returns this
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.prototype.clearMetricLineDataList = function() {
  return this.setMetricLineDataList([]);
};


/**
 * optional double timestamp = 11;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.MetricDataFrame} returns this
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional int32 scale_factor = 12;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.prototype.getScaleFactor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.MetricDataFrame} returns this
 */
proto.zelos.zoe.data_view.proto.MetricDataFrame.prototype.setScaleFactor = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.MetricLineData.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.MetricLineData.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.MetricLineData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.MetricLineData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MetricLineData.toObject = function(includeInstance, msg) {
  var f, obj = {
metricLineName: jspb.Message.getFieldWithDefault(msg, 1, ""),
metricLineType: jspb.Message.getFieldWithDefault(msg, 2, 0),
metricPointDataList: jspb.Message.toObjectList(msg.getMetricPointDataList(),
    proto.zelos.zoe.data_view.proto.MetricPointData.toObject, includeInstance),
lineXType: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.MetricLineData}
 */
proto.zelos.zoe.data_view.proto.MetricLineData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.MetricLineData;
  return proto.zelos.zoe.data_view.proto.MetricLineData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.MetricLineData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.MetricLineData}
 */
proto.zelos.zoe.data_view.proto.MetricLineData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMetricLineName(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.MetricLineType} */ (reader.readEnum());
      msg.setMetricLineType(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.MetricPointData;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.MetricPointData.deserializeBinaryFromReader);
      msg.addMetricPointData(value);
      break;
    case 4:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.MetricLineData.LineXType} */ (reader.readEnum());
      msg.setLineXType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.MetricLineData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.MetricLineData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.MetricLineData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MetricLineData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMetricLineName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMetricLineType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getMetricPointDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.MetricPointData.serializeBinaryToWriter
    );
  }
  f = message.getLineXType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.MetricLineData.LineXType = {
  LINEX_REALVALUE: 0,
  LINEX_TIMESTAMP: 1
};

/**
 * optional string metric_line_name = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.MetricLineData.prototype.getMetricLineName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.MetricLineData} returns this
 */
proto.zelos.zoe.data_view.proto.MetricLineData.prototype.setMetricLineName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MetricLineType metric_line_type = 2;
 * @return {!proto.zelos.zoe.data_view.proto.MetricLineType}
 */
proto.zelos.zoe.data_view.proto.MetricLineData.prototype.getMetricLineType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.MetricLineType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.MetricLineType} value
 * @return {!proto.zelos.zoe.data_view.proto.MetricLineData} returns this
 */
proto.zelos.zoe.data_view.proto.MetricLineData.prototype.setMetricLineType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated MetricPointData metric_point_data = 3;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.MetricPointData>}
 */
proto.zelos.zoe.data_view.proto.MetricLineData.prototype.getMetricPointDataList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.MetricPointData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.MetricPointData, 3));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.MetricPointData>} value
 * @return {!proto.zelos.zoe.data_view.proto.MetricLineData} returns this
*/
proto.zelos.zoe.data_view.proto.MetricLineData.prototype.setMetricPointDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.MetricPointData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.MetricPointData}
 */
proto.zelos.zoe.data_view.proto.MetricLineData.prototype.addMetricPointData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.zelos.zoe.data_view.proto.MetricPointData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.MetricLineData} returns this
 */
proto.zelos.zoe.data_view.proto.MetricLineData.prototype.clearMetricPointDataList = function() {
  return this.setMetricPointDataList([]);
};


/**
 * optional LineXType line_x_type = 4;
 * @return {!proto.zelos.zoe.data_view.proto.MetricLineData.LineXType}
 */
proto.zelos.zoe.data_view.proto.MetricLineData.prototype.getLineXType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.MetricLineData.LineXType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.MetricLineData.LineXType} value
 * @return {!proto.zelos.zoe.data_view.proto.MetricLineData} returns this
 */
proto.zelos.zoe.data_view.proto.MetricLineData.prototype.setLineXType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.MetricPointData.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.MetricPointData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.MetricPointData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MetricPointData.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
yInt: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.MetricPointData}
 */
proto.zelos.zoe.data_view.proto.MetricPointData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.MetricPointData;
  return proto.zelos.zoe.data_view.proto.MetricPointData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.MetricPointData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.MetricPointData}
 */
proto.zelos.zoe.data_view.proto.MetricPointData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.MetricPointData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.MetricPointData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.MetricPointData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.MetricPointData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getYInt();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional double x = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.MetricPointData.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.MetricPointData} returns this
 */
proto.zelos.zoe.data_view.proto.MetricPointData.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double y = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.MetricPointData.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.MetricPointData} returns this
 */
proto.zelos.zoe.data_view.proto.MetricPointData.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int32 y_int = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.MetricPointData.prototype.getYInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.MetricPointData} returns this
 */
proto.zelos.zoe.data_view.proto.MetricPointData.prototype.setYInt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.PathPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.PathPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.PathPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
z: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
theta: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
kappa: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
s: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
dkappa: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
ddkappa: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
xInt: jspb.Message.getFieldWithDefault(msg, 9, 0),
yInt: jspb.Message.getFieldWithDefault(msg, 10, 0),
zInt: jspb.Message.getFieldWithDefault(msg, 11, 0),
thetaInt: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint}
 */
proto.zelos.zoe.data_view.proto.PathPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.PathPoint;
  return proto.zelos.zoe.data_view.proto.PathPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.PathPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint}
 */
proto.zelos.zoe.data_view.proto.PathPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setY(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setZ(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTheta(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setKappa(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setS(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDkappa(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDdkappa(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setXInt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYInt(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setZInt(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setThetaInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.PathPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.PathPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.PathPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getZ();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTheta();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getKappa();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getS();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getDkappa();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getDdkappa();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getXInt();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getYInt();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getZInt();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getThetaInt();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
};


/**
 * optional double x = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint} returns this
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double y = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint} returns this
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double z = 3;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.getZ = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint} returns this
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.setZ = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double theta = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.getTheta = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint} returns this
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.setTheta = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double kappa = 5;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.getKappa = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint} returns this
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.setKappa = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double s = 6;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.getS = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint} returns this
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.setS = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double dkappa = 7;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.getDkappa = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint} returns this
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.setDkappa = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double ddkappa = 8;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.getDdkappa = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint} returns this
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.setDdkappa = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional int32 x_int = 9;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.getXInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint} returns this
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.setXInt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 y_int = 10;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.getYInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint} returns this
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.setYInt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 z_int = 11;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.getZInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint} returns this
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.setZInt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 theta_int = 12;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.getThetaInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.PathPoint} returns this
 */
proto.zelos.zoe.data_view.proto.PathPoint.prototype.setThetaInt = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.ControlDebugData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.ControlDebugData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.toObject = function(includeInstance, msg) {
  var f, obj = {
vehicleThrottle: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
vehicleBrake: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
vanguardBrake: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
vehicleThrottleInt: jspb.Message.getFieldWithDefault(msg, 29, 0),
vehicleBrakeInt: jspb.Message.getFieldWithDefault(msg, 30, 0),
vanguardBrakeInt: jspb.Message.getFieldWithDefault(msg, 31, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.ControlDebugData}
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.ControlDebugData;
  return proto.zelos.zoe.data_view.proto.ControlDebugData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.ControlDebugData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.ControlDebugData}
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVehicleThrottle(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVehicleBrake(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVanguardBrake(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVehicleThrottleInt(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVehicleBrakeInt(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVanguardBrakeInt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.ControlDebugData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.ControlDebugData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleThrottle();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getVehicleBrake();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getVanguardBrake();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = message.getVehicleThrottleInt();
  if (f !== 0) {
    writer.writeInt32(
      29,
      f
    );
  }
  f = message.getVehicleBrakeInt();
  if (f !== 0) {
    writer.writeInt32(
      30,
      f
    );
  }
  f = message.getVanguardBrakeInt();
  if (f !== 0) {
    writer.writeInt32(
      31,
      f
    );
  }
};


/**
 * optional double vehicle_throttle = 14;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.getVehicleThrottle = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.ControlDebugData} returns this
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.setVehicleThrottle = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double vehicle_brake = 15;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.getVehicleBrake = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.ControlDebugData} returns this
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.setVehicleBrake = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double vanguard_brake = 19;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.getVanguardBrake = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.ControlDebugData} returns this
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.setVanguardBrake = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional int32 vehicle_throttle_int = 29;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.getVehicleThrottleInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.ControlDebugData} returns this
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.setVehicleThrottleInt = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional int32 vehicle_brake_int = 30;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.getVehicleBrakeInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.ControlDebugData} returns this
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.setVehicleBrakeInt = function(value) {
  return jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional int32 vanguard_brake_int = 31;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.getVanguardBrakeInt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.ControlDebugData} returns this
 */
proto.zelos.zoe.data_view.proto.ControlDebugData.prototype.setVanguardBrakeInt = function(value) {
  return jspb.Message.setProto3IntField(this, 31, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.GpsInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.GpsInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.GpsInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.GpsInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
gpsPosStatus: jspb.Message.getFieldWithDefault(msg, 1, 0),
gnssStatus: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.GpsInfo}
 */
proto.zelos.zoe.data_view.proto.GpsInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.GpsInfo;
  return proto.zelos.zoe.data_view.proto.GpsInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.GpsInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.GpsInfo}
 */
proto.zelos.zoe.data_view.proto.GpsInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.GpsInfo.GpsPositionStatus} */ (reader.readEnum());
      msg.setGpsPosStatus(value);
      break;
    case 2:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.GpsInfo.GnssStatus} */ (reader.readEnum());
      msg.setGnssStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.GpsInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.GpsInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.GpsInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.GpsInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGpsPosStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getGnssStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.GpsInfo.GnssStatus = {
  INS_NONE: 0,
  INS_INITIALIZATION_MODE: 1,
  INS_SATELLITE_MODE: 2,
  INS_INTEGRATED_NAVIGATION_MODE: 3,
  INS_INERTIAL_NAVIGATION_MODE: 4,
  INS_INACTIVE: 5,
  INS_ALIGNING: 6,
  INS_HIGH_VARIANCE: 7,
  INS_SOLUTION_GOOD: 8,
  INS_SOLUTION_FREE: 9,
  INS_ALIGNMENT_COMPLETE: 10,
  INS_DETERMINING_ORIENTATION: 11,
  INS_WAITING_INITIALPOS: 12,
  INS_WAITING_AZIMUTH: 13,
  INS_INITIALIZING_BIASES: 14,
  INS_MOTION_DETECT: 15,
  INS_WAITING_ALIGNMENTORIENTATION: 16
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.GpsInfo.GpsPositionStatus = {
  GPS_POS_NONE: 0,
  GPS_POS_NOLOCATION: 1,
  GPS_POS_SINGLE: 2,
  GPS_POS_PSRDIFF: 3,
  GPS_POS_PROPAGATED: 4,
  GPS_POS_RTK_FIXED: 5,
  GPS_POS_RTK_FLOAT: 6,
  GPS_POS_SINGLE_NO_ORIENTATION: 7,
  GPS_POS_PSRDIFF_NO_ORIENTATION: 8,
  GPS_POS_RTK_FIXED_NO_ORIENTATION: 9,
  GPS_POS_RTK_FLOAT_NO_ORIENTATION: 10,
  GPS_POSE_INIT: 11,
  GPS_POSE_COARSE_ALIGN: 12,
  GPS_POSE_FINE_ALIGN: 13,
  GPS_POSE_LOCATION: 14,
  GPS_POSE_ORIENTATION: 15,
  GPS_POSE_DMI_INTEGRATION: 16,
  GPS_POSE_DMI_CALIBRATION: 17,
  GPS_POSE_SPEED_CORRECTION: 18,
  GPS_POSE_VG_MODE: 19,
  GPS_POSE_RTK_ORIENTATION: 20,
  GPS_POSE_DYNAMIC_ALIGN: 21,
  GPS_POS_RTK_FIXED_NO_CONVERGENCE: 22
};

/**
 * optional GpsPositionStatus gps_pos_status = 1;
 * @return {!proto.zelos.zoe.data_view.proto.GpsInfo.GpsPositionStatus}
 */
proto.zelos.zoe.data_view.proto.GpsInfo.prototype.getGpsPosStatus = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.GpsInfo.GpsPositionStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.GpsInfo.GpsPositionStatus} value
 * @return {!proto.zelos.zoe.data_view.proto.GpsInfo} returns this
 */
proto.zelos.zoe.data_view.proto.GpsInfo.prototype.setGpsPosStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional GnssStatus gnss_status = 2;
 * @return {!proto.zelos.zoe.data_view.proto.GpsInfo.GnssStatus}
 */
proto.zelos.zoe.data_view.proto.GpsInfo.prototype.getGnssStatus = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.GpsInfo.GnssStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.GpsInfo.GnssStatus} value
 * @return {!proto.zelos.zoe.data_view.proto.GpsInfo} returns this
 */
proto.zelos.zoe.data_view.proto.GpsInfo.prototype.setGnssStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.Localization.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.Localization} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Localization.toObject = function(includeInstance, msg) {
  var f, obj = {
status: jspb.Message.getFieldWithDefault(msg, 4, 0),
linearAcceleration: (f = msg.getLinearAcceleration()) && proto.zelos.zoe.data_view.proto.Vector3d.toObject(includeInstance, f),
linearVelocity: (f = msg.getLinearVelocity()) && proto.zelos.zoe.data_view.proto.Vector3d.toObject(includeInstance, f),
gpsPose: (f = msg.getGpsPose()) && proto.zelos.zoe.data_view.proto.Point3D.toObject(includeInstance, f),
globalPosition: (f = msg.getGlobalPosition()) && proto.zelos.zoe.data_view.proto.ZPoint3D.toObject(includeInstance, f),
roadType: jspb.Message.getFieldWithDefault(msg, 14, 0),
sourceFrom: jspb.Message.getFieldWithDefault(msg, 15, 0),
gpsPosePosition: (f = msg.getGpsPosePosition()) && proto.zelos.zoe.data_view.proto.ZPoint3D.toObject(includeInstance, f),
mapVersionMeta: (f = msg.getMapVersionMeta()) && proto.zelos.zoe.data_view.proto.MapVersionMeta.toObject(includeInstance, f),
mapMode: jspb.Message.getFieldWithDefault(msg, 19, 0),
fuseRtk: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
hiddenMode: jspb.Message.getFieldWithDefault(msg, 21, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.Localization}
 */
proto.zelos.zoe.data_view.proto.Localization.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.Localization;
  return proto.zelos.zoe.data_view.proto.Localization.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.Localization} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.Localization}
 */
proto.zelos.zoe.data_view.proto.Localization.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Localization.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = new proto.zelos.zoe.data_view.proto.Vector3d;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Vector3d.deserializeBinaryFromReader);
      msg.setLinearAcceleration(value);
      break;
    case 6:
      var value = new proto.zelos.zoe.data_view.proto.Vector3d;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Vector3d.deserializeBinaryFromReader);
      msg.setLinearVelocity(value);
      break;
    case 12:
      var value = new proto.zelos.zoe.data_view.proto.Point3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.Point3D.deserializeBinaryFromReader);
      msg.setGpsPose(value);
      break;
    case 13:
      var value = new proto.zelos.zoe.data_view.proto.ZPoint3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.ZPoint3D.deserializeBinaryFromReader);
      msg.setGlobalPosition(value);
      break;
    case 14:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Localization.RoadType} */ (reader.readEnum());
      msg.setRoadType(value);
      break;
    case 15:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Localization.SourceFrom} */ (reader.readEnum());
      msg.setSourceFrom(value);
      break;
    case 17:
      var value = new proto.zelos.zoe.data_view.proto.ZPoint3D;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.ZPoint3D.deserializeBinaryFromReader);
      msg.setGpsPosePosition(value);
      break;
    case 18:
      var value = new proto.zelos.zoe.data_view.proto.MapVersionMeta;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.MapVersionMeta.deserializeBinaryFromReader);
      msg.setMapVersionMeta(value);
      break;
    case 19:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Localization.MapMode} */ (reader.readEnum());
      msg.setMapMode(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFuseRtk(value);
      break;
    case 21:
      var value = /** @type {!proto.zelos.zoe.data_view.proto.Localization.Mode} */ (reader.readEnum());
      msg.setHiddenMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.Localization.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.Localization} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.Localization.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getLinearAcceleration();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.zelos.zoe.data_view.proto.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getLinearVelocity();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.zelos.zoe.data_view.proto.Vector3d.serializeBinaryToWriter
    );
  }
  f = message.getGpsPose();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.zelos.zoe.data_view.proto.Point3D.serializeBinaryToWriter
    );
  }
  f = message.getGlobalPosition();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.zelos.zoe.data_view.proto.ZPoint3D.serializeBinaryToWriter
    );
  }
  f = message.getRoadType();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getSourceFrom();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getGpsPosePosition();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.zelos.zoe.data_view.proto.ZPoint3D.serializeBinaryToWriter
    );
  }
  f = message.getMapVersionMeta();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.zelos.zoe.data_view.proto.MapVersionMeta.serializeBinaryToWriter
    );
  }
  f = message.getMapMode();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getFuseRtk();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getHiddenMode();
  if (f !== 0.0) {
    writer.writeEnum(
      21,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Localization.RoadType = {
  UNKNOWN: 0,
  PARK: 1,
  PUBLIC: 2,
  INDOOR: 3,
  COMMUNITY: 4,
  SLOPE: 5,
  SCHOOL: 6,
  HOSPITAL: 7,
  VIRTUAL_ILLEGAL: 8,
  MULTI_FLOORS: 9,
  NATIONAL_HIGHWAY: 10,
  EXPRESSWAY: 11,
  FAST_ROAD: 12,
  TUNNEL: 13,
  VIRTUAL_LONG_CORRIDOR: 14,
  DANGER_AREA: 15,
  VILLAGE: 16,
  LONG_CORRIDOR_RTK: 17,
  LONG_CORRIDOR_FUSION: 18
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Localization.SourceFrom = {
  SOURCE_UNKNOWN: 0,
  SOURCE_ZELOS_LD: 1,
  SOURCE_ZELOS_HD: 2,
  SOURCE_BAIDU_LD: 3,
  SOURCE_SATELLITE_LD: 4,
  SOURCE_ZELOS_SD: 5
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Localization.Status = {
  UNKONWN: 0,
  SUCCESS: 1,
  UNRELIABILITY: 2,
  DEGENERATION: 3,
  DIVERGENCE: 4,
  RELOC: 5,
  COORD_RESET: 6,
  FAILURE: 7,
  OUT_MAP: 8,
  VCT_MAP_UNRELIABILITY: 9,
  WARMUP: 10
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Localization.MapMode = {
  MAP_NORMAL: 0,
  MAP_DATA_CAPTURE: 1
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.Localization.Mode = {
  GLOBAL: 0,
  LOCAL: 1,
  NOMAP: 3,
  NOA: 4,
  SDMAP: 5
};

/**
 * optional Status status = 4;
 * @return {!proto.zelos.zoe.data_view.proto.Localization.Status}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.getStatus = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Localization.Status} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Localization.Status} value
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional Vector3d linear_acceleration = 5;
 * @return {?proto.zelos.zoe.data_view.proto.Vector3d}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.getLinearAcceleration = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Vector3d, 5));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Vector3d|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
*/
proto.zelos.zoe.data_view.proto.Localization.prototype.setLinearAcceleration = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.clearLinearAcceleration = function() {
  return this.setLinearAcceleration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.hasLinearAcceleration = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Vector3d linear_velocity = 6;
 * @return {?proto.zelos.zoe.data_view.proto.Vector3d}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.getLinearVelocity = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Vector3d} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Vector3d, 6));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Vector3d|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
*/
proto.zelos.zoe.data_view.proto.Localization.prototype.setLinearVelocity = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.clearLinearVelocity = function() {
  return this.setLinearVelocity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.hasLinearVelocity = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Point3D gps_pose = 12;
 * @return {?proto.zelos.zoe.data_view.proto.Point3D}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.getGpsPose = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.Point3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.Point3D, 12));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.Point3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
*/
proto.zelos.zoe.data_view.proto.Localization.prototype.setGpsPose = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.clearGpsPose = function() {
  return this.setGpsPose(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.hasGpsPose = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional ZPoint3D global_position = 13;
 * @return {?proto.zelos.zoe.data_view.proto.ZPoint3D}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.getGlobalPosition = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.ZPoint3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.ZPoint3D, 13));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.ZPoint3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
*/
proto.zelos.zoe.data_view.proto.Localization.prototype.setGlobalPosition = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.clearGlobalPosition = function() {
  return this.setGlobalPosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.hasGlobalPosition = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional RoadType road_type = 14;
 * @return {!proto.zelos.zoe.data_view.proto.Localization.RoadType}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.getRoadType = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Localization.RoadType} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Localization.RoadType} value
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.setRoadType = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional SourceFrom source_from = 15;
 * @return {!proto.zelos.zoe.data_view.proto.Localization.SourceFrom}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.getSourceFrom = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Localization.SourceFrom} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Localization.SourceFrom} value
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.setSourceFrom = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional ZPoint3D gps_pose_position = 17;
 * @return {?proto.zelos.zoe.data_view.proto.ZPoint3D}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.getGpsPosePosition = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.ZPoint3D} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.ZPoint3D, 17));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.ZPoint3D|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
*/
proto.zelos.zoe.data_view.proto.Localization.prototype.setGpsPosePosition = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.clearGpsPosePosition = function() {
  return this.setGpsPosePosition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.hasGpsPosePosition = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional MapVersionMeta map_version_meta = 18;
 * @return {?proto.zelos.zoe.data_view.proto.MapVersionMeta}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.getMapVersionMeta = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.MapVersionMeta} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.MapVersionMeta, 18));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.MapVersionMeta|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
*/
proto.zelos.zoe.data_view.proto.Localization.prototype.setMapVersionMeta = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.clearMapVersionMeta = function() {
  return this.setMapVersionMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.hasMapVersionMeta = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional MapMode map_mode = 19;
 * @return {!proto.zelos.zoe.data_view.proto.Localization.MapMode}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.getMapMode = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Localization.MapMode} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Localization.MapMode} value
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.setMapMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional bool fuse_rtk = 20;
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.getFuseRtk = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.setFuseRtk = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional Mode hidden_mode = 21;
 * @return {!proto.zelos.zoe.data_view.proto.Localization.Mode}
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.getHiddenMode = function() {
  return /** @type {!proto.zelos.zoe.data_view.proto.Localization.Mode} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.Localization.Mode} value
 * @return {!proto.zelos.zoe.data_view.proto.Localization} returns this
 */
proto.zelos.zoe.data_view.proto.Localization.prototype.setHiddenMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.RequestData.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.RequestData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.RequestData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.RequestData.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pb_interface: jspb.Message.getFieldWithDefault(msg, 2, ""),
paramsMap: (f = msg.getParamsMap()) ? f.toObject(includeInstance, undefined) : [],
requestTimestamp: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.RequestData}
 */
proto.zelos.zoe.data_view.proto.RequestData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.RequestData;
  return proto.zelos.zoe.data_view.proto.RequestData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.RequestData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.RequestData}
 */
proto.zelos.zoe.data_view.proto.RequestData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterface(value);
      break;
    case 3:
      var value = msg.getParamsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRequestTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.RequestData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.RequestData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.RequestData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.RequestData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInterface();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getParamsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getRequestTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.RequestData.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.RequestData} returns this
 */
proto.zelos.zoe.data_view.proto.RequestData.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string interface = 2;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.RequestData.prototype.getInterface = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.RequestData} returns this
 */
proto.zelos.zoe.data_view.proto.RequestData.prototype.setInterface = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * map<string, string> params = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.zelos.zoe.data_view.proto.RequestData.prototype.getParamsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.zelos.zoe.data_view.proto.RequestData} returns this
 */
proto.zelos.zoe.data_view.proto.RequestData.prototype.clearParamsMap = function() {
  this.getParamsMap().clear();
  return this;
};


/**
 * optional int64 request_timestamp = 4;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.RequestData.prototype.getRequestTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.RequestData} returns this
 */
proto.zelos.zoe.data_view.proto.RequestData.prototype.setRequestTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.FrameData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.FrameData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FrameData.toObject = function(includeInstance, msg) {
  var f, obj = {
timestamp: jspb.Message.getFieldWithDefault(msg, 1, 0),
createTimestamp: jspb.Message.getFieldWithDefault(msg, 2, 0),
vehicleData: msg.getVehicleData_asB64(),
mapData: msg.getMapData_asB64(),
abnormalInfos: jspb.Message.getFieldWithDefault(msg, 5, ""),
vehicleSignal: (f = msg.getVehicleSignal()) && proto.zelos.zoe.data_view.proto.VehicleSignal.toObject(includeInstance, f),
vehicleBumper: (f = msg.getVehicleBumper()) && proto.zelos.zoe.data_view.proto.VehicleBumper.toObject(includeInstance, f),
extraInfo: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.FrameData}
 */
proto.zelos.zoe.data_view.proto.FrameData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.FrameData;
  return proto.zelos.zoe.data_view.proto.FrameData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.FrameData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.FrameData}
 */
proto.zelos.zoe.data_view.proto.FrameData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCreateTimestamp(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setVehicleData(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMapData(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbnormalInfos(value);
      break;
    case 6:
      var value = new proto.zelos.zoe.data_view.proto.VehicleSignal;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VehicleSignal.deserializeBinaryFromReader);
      msg.setVehicleSignal(value);
      break;
    case 7:
      var value = new proto.zelos.zoe.data_view.proto.VehicleBumper;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.VehicleBumper.deserializeBinaryFromReader);
      msg.setVehicleBumper(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtraInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.FrameData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.FrameData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.FrameData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getCreateTimestamp();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getVehicleData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getMapData_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
  f = message.getAbnormalInfos();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getVehicleSignal();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.zelos.zoe.data_view.proto.VehicleSignal.serializeBinaryToWriter
    );
  }
  f = message.getVehicleBumper();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.zelos.zoe.data_view.proto.VehicleBumper.serializeBinaryToWriter
    );
  }
  f = message.getExtraInfo();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional uint64 timestamp = 1;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.FrameData} returns this
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 create_timestamp = 2;
 * @return {number}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.getCreateTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.zelos.zoe.data_view.proto.FrameData} returns this
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.setCreateTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bytes vehicle_data = 3;
 * @return {!(string|Uint8Array)}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.getVehicleData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes vehicle_data = 3;
 * This is a type-conversion wrapper around `getVehicleData()`
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.getVehicleData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getVehicleData()));
};


/**
 * optional bytes vehicle_data = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getVehicleData()`
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.getVehicleData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getVehicleData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.zelos.zoe.data_view.proto.FrameData} returns this
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.setVehicleData = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional bytes map_data = 4;
 * @return {!(string|Uint8Array)}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.getMapData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes map_data = 4;
 * This is a type-conversion wrapper around `getMapData()`
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.getMapData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMapData()));
};


/**
 * optional bytes map_data = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMapData()`
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.getMapData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMapData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.zelos.zoe.data_view.proto.FrameData} returns this
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.setMapData = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};


/**
 * optional string abnormal_infos = 5;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.getAbnormalInfos = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.FrameData} returns this
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.setAbnormalInfos = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional VehicleSignal vehicle_signal = 6;
 * @return {?proto.zelos.zoe.data_view.proto.VehicleSignal}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.getVehicleSignal = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.VehicleSignal} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.VehicleSignal, 6));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.VehicleSignal|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.FrameData} returns this
*/
proto.zelos.zoe.data_view.proto.FrameData.prototype.setVehicleSignal = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.FrameData} returns this
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.clearVehicleSignal = function() {
  return this.setVehicleSignal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.hasVehicleSignal = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional VehicleBumper vehicle_bumper = 7;
 * @return {?proto.zelos.zoe.data_view.proto.VehicleBumper}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.getVehicleBumper = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.VehicleBumper} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.VehicleBumper, 7));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.VehicleBumper|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.FrameData} returns this
*/
proto.zelos.zoe.data_view.proto.FrameData.prototype.setVehicleBumper = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.FrameData} returns this
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.clearVehicleBumper = function() {
  return this.setVehicleBumper(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.hasVehicleBumper = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string extra_info = 8;
 * @return {string}
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.getExtraInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.zelos.zoe.data_view.proto.FrameData} returns this
 */
proto.zelos.zoe.data_view.proto.FrameData.prototype.setExtraInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.zelos.zoe.data_view.proto.DataPackage.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.DataPackage.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.DataPackage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.DataPackage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.DataPackage.toObject = function(includeInstance, msg) {
  var f, obj = {
frameDataList: jspb.Message.toObjectList(msg.getFrameDataList(),
    proto.zelos.zoe.data_view.proto.FrameData.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.DataPackage}
 */
proto.zelos.zoe.data_view.proto.DataPackage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.DataPackage;
  return proto.zelos.zoe.data_view.proto.DataPackage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.DataPackage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.DataPackage}
 */
proto.zelos.zoe.data_view.proto.DataPackage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.FrameData;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.FrameData.deserializeBinaryFromReader);
      msg.addFrameData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.DataPackage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.DataPackage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.DataPackage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.DataPackage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrameDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.FrameData.serializeBinaryToWriter
    );
  }
};


/**
 * repeated FrameData frame_data = 1;
 * @return {!Array<!proto.zelos.zoe.data_view.proto.FrameData>}
 */
proto.zelos.zoe.data_view.proto.DataPackage.prototype.getFrameDataList = function() {
  return /** @type{!Array<!proto.zelos.zoe.data_view.proto.FrameData>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.zelos.zoe.data_view.proto.FrameData, 1));
};


/**
 * @param {!Array<!proto.zelos.zoe.data_view.proto.FrameData>} value
 * @return {!proto.zelos.zoe.data_view.proto.DataPackage} returns this
*/
proto.zelos.zoe.data_view.proto.DataPackage.prototype.setFrameDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.zelos.zoe.data_view.proto.FrameData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.zelos.zoe.data_view.proto.FrameData}
 */
proto.zelos.zoe.data_view.proto.DataPackage.prototype.addFrameData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.zelos.zoe.data_view.proto.FrameData, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.zelos.zoe.data_view.proto.DataPackage} returns this
 */
proto.zelos.zoe.data_view.proto.DataPackage.prototype.clearFrameDataList = function() {
  return this.setFrameDataList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.oneofGroups_ = [[1,3,6]];

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.SessionDataCase = {
  SESSION_DATA_NOT_SET: 0,
  CONNECTION_DATA: 1,
  REQUEST_DATA: 3,
  FRAME_DATA: 6
};

/**
 * @return {proto.zelos.zoe.data_view.proto.DataSessionProtocal.SessionDataCase}
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.getSessionDataCase = function() {
  return /** @type {proto.zelos.zoe.data_view.proto.DataSessionProtocal.SessionDataCase} */(jspb.Message.computeOneofCase(this, proto.zelos.zoe.data_view.proto.DataSessionProtocal.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.toObject = function(opt_includeInstance) {
  return proto.zelos.zoe.data_view.proto.DataSessionProtocal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.zelos.zoe.data_view.proto.DataSessionProtocal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.toObject = function(includeInstance, msg) {
  var f, obj = {
connectionData: (f = msg.getConnectionData()) && proto.zelos.zoe.data_view.proto.ConnectionData.toObject(includeInstance, f),
requestData: (f = msg.getRequestData()) && proto.zelos.zoe.data_view.proto.RequestData.toObject(includeInstance, f),
frameData: (f = msg.getFrameData()) && proto.zelos.zoe.data_view.proto.DataPackage.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.zelos.zoe.data_view.proto.DataSessionProtocal}
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.zelos.zoe.data_view.proto.DataSessionProtocal;
  return proto.zelos.zoe.data_view.proto.DataSessionProtocal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.zelos.zoe.data_view.proto.DataSessionProtocal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.zelos.zoe.data_view.proto.DataSessionProtocal}
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.zelos.zoe.data_view.proto.ConnectionData;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.ConnectionData.deserializeBinaryFromReader);
      msg.setConnectionData(value);
      break;
    case 3:
      var value = new proto.zelos.zoe.data_view.proto.RequestData;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.RequestData.deserializeBinaryFromReader);
      msg.setRequestData(value);
      break;
    case 6:
      var value = new proto.zelos.zoe.data_view.proto.DataPackage;
      reader.readMessage(value,proto.zelos.zoe.data_view.proto.DataPackage.deserializeBinaryFromReader);
      msg.setFrameData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.zelos.zoe.data_view.proto.DataSessionProtocal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.zelos.zoe.data_view.proto.DataSessionProtocal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConnectionData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.zelos.zoe.data_view.proto.ConnectionData.serializeBinaryToWriter
    );
  }
  f = message.getRequestData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.zelos.zoe.data_view.proto.RequestData.serializeBinaryToWriter
    );
  }
  f = message.getFrameData();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.zelos.zoe.data_view.proto.DataPackage.serializeBinaryToWriter
    );
  }
};


/**
 * optional ConnectionData connection_data = 1;
 * @return {?proto.zelos.zoe.data_view.proto.ConnectionData}
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.getConnectionData = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.ConnectionData} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.ConnectionData, 1));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.ConnectionData|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.DataSessionProtocal} returns this
*/
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.setConnectionData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.zelos.zoe.data_view.proto.DataSessionProtocal.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.DataSessionProtocal} returns this
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.clearConnectionData = function() {
  return this.setConnectionData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.hasConnectionData = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RequestData request_data = 3;
 * @return {?proto.zelos.zoe.data_view.proto.RequestData}
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.getRequestData = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.RequestData} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.RequestData, 3));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.RequestData|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.DataSessionProtocal} returns this
*/
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.setRequestData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.zelos.zoe.data_view.proto.DataSessionProtocal.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.DataSessionProtocal} returns this
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.clearRequestData = function() {
  return this.setRequestData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.hasRequestData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional DataPackage frame_data = 6;
 * @return {?proto.zelos.zoe.data_view.proto.DataPackage}
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.getFrameData = function() {
  return /** @type{?proto.zelos.zoe.data_view.proto.DataPackage} */ (
    jspb.Message.getWrapperField(this, proto.zelos.zoe.data_view.proto.DataPackage, 6));
};


/**
 * @param {?proto.zelos.zoe.data_view.proto.DataPackage|undefined} value
 * @return {!proto.zelos.zoe.data_view.proto.DataSessionProtocal} returns this
*/
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.setFrameData = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.zelos.zoe.data_view.proto.DataSessionProtocal.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.zelos.zoe.data_view.proto.DataSessionProtocal} returns this
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.clearFrameData = function() {
  return this.setFrameData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.zelos.zoe.data_view.proto.DataSessionProtocal.prototype.hasFrameData = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.ObjectNegligibleType = {
  NEGLIGIBLE_UNKNOWN: 0,
  OBJECT_NEGLIGIBLE: 1,
  OBJECT_NON_NEGLIGIBLE: 2,
  OBJECT_SOFT_NEGLIGIBLE: 3,
  OBJECT_SLOWDOWN_NEGLIGIBLE: 4
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.FreeMoveFailReason = {
  FREE_MOVE_FAIL_REASON_UNSPECIFIED: 0,
  FREE_MOVE_FAIL_REASON_INVALID_TARGET: 1,
  FREE_MOVE_FAIL_REASON_NO_LOCALIZATION: 2,
  FREE_MOVE_FAIL_REASON_VEHICLE_STATE_NOT_READY: 3,
  FREE_MOVE_FAIL_REASON_ALREADY_AT_TARGET: 4,
  FREE_MOVE_FAIL_REASON_TARGET_TOO_FAR: 5,
  FREE_MOVE_FAIL_REASON_TARGET_MISMATCH_ROUTING: 6,
  FREE_MOVE_FAIL_REASON_CANCELLED_BY_COMMAND: 7,
  FREE_MOVE_FAIL_REASON_PLANNING_PATH_TIMEOUT: 8,
  FREE_MOVE_FAIL_REASON_READY_TO_EXECUTE_TIMEOUT: 9,
  FREE_MOVE_FAIL_REASON_EXECUTION_FAILED: 10
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.SessionType = {
  UNKNOWN_SESSION_TYPE: 0,
  RECORD: 1,
  LIVE: 2,
  VERIFY: 3
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.MessageFormat = {
  UNKNOWN_MESSAGE_FORMAT: 0,
  TEXT: 1,
  BINARY: 2
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.OverwriteType = {
  OVERWRITE_OFF: 0,
  OVERWRITE_UNKNOWN_AND_BLACK_TO_GREEN: 1,
  OVERWRITE_ALL_TO_GREEN: 2
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.SceneType = {
  SCENE_UNKNOWN: 0,
  SCENE_OUTDOOR: 1,
  SCENE_TUNNEL: 2,
  SCENE_GARAGE: 3,
  SCENE_OTHER: 4
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.TrafficSignType = {
  TS_UNKNOWN: 0,
  TS_WARNING: 1,
  TS_PROHIBITION: 2,
  TS_DIRECTIVE: 3,
  TS_WAY_GUIDE: 4,
  TS_HIGHWAY_GUIDE: 5,
  TS_AUXILIARY: 6,
  TS_CONSTRUCTION_SAFETY: 7,
  TS_TOURIST_AREA: 8,
  TS_PROHIBITION_STOP: 100,
  TS_PROHIBITION_YIELD: 101,
  TS_PROHIBITION_NO_ENTER: 102,
  TS_PROHIBITION_NO_STOP: 103,
  TS_PROHIBITION_SPEED_LIMIT: 104,
  TS_PROHIBITION_HEIGHT_LIMIT: 105,
  TS_PROHIBITION_WIDTH_LIMIT: 106,
  TS_PROHIBITION_WEIGHT_LIMIT: 107,
  TS_PROHIBITION_AXLE_WEIGHT_LIMIT: 108
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.RoadType = {
  ROAD_UNKNOWN: 0,
  ROAD_COMMON: 1,
  ROAD_WET: 2,
  ROAD_FROZEN_ALL: 3,
  ROAD_FROZEN_LEFT: 4,
  ROAD_FROZEN_RIGHT: 5
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.GateType = {
  GATE_TYPE_UNKNOWN: 0,
  GATE_TYPE_LIFTING_LEVER: 1,
  GATE_TYPE_RETRACTABLE: 2,
  GATE_TYPE_ROLLING_SHUTTER: 3
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.GateMovingStatus = {
  GATE_MOVING_UNKNOWN: 0,
  GATE_MOVING_OPENING: 1,
  GATE_MOVING_CLOSING: 2,
  GATE_MOVING_OPENED: 3,
  GATE_MOVING_CLOSED: 4
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.GateSpecialState = {
  GATE_SPECICAL_NORMAL: 0,
  GATE_SPECICAL_RAILWAY: 1
};

/**
 * @enum {number}
 */
proto.zelos.zoe.data_view.proto.MetricLineType = {
  BOUND: 0,
  REFERENCE: 1,
  LINE: 2,
  SHAPE: 3,
  POINT: 4
};

export default proto.zelos.zoe.data_view.proto;
